import {NoteSortingKey} from 'notability-services-common-universal'
import {NotificationType} from 'notability-services-common-universal'
import {GalleryNoteContentType} from 'notability-services-common-universal'
import {FlaggedReason} from 'notability-services-common-universal'
import {GalleryNotesAdminEventType} from 'notability-services-common-universal'
import {UsersAdminEventType} from 'notability-services-common-universal'
import {SearchFilter} from 'notability-services-common-universal'
import {CommentReviewState} from 'notability-services-common-universal'
import {ExperimentEnrollmentStrategy} from 'notability-services-common-universal'
import {gql} from '@apollo/client'
import * as Apollo from '@apollo/client'
export type Maybe<T> = T | null
export type Exact<T extends {[key: string]: unknown}> = {[K in keyof T]: T[K]}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {[SubKey in K]?: Maybe<T[SubKey]>}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {[SubKey in K]: Maybe<T[SubKey]>}
const defaultOptions = {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: any
  /** GqlUUID scalar type that converts all UUIDs to lowercase */
  GqlUUID: any
  InstitutionOrderBy: any
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any
  /** The javascript `Date` as integer. Type represents date and time as number of milliseconds from start of UNIX epoch. */
  Timestamp: any
}

export type AsrJob = {
  __typename?: 'ASRJob'
  audioCreationDate?: Maybe<Scalars['DateTime']>
  audioDurationMs?: Maybe<Scalars['Float']>
  beamSize?: Maybe<Scalars['Float']>
  createdAt: Scalars['DateTime']
  errorReason?: Maybe<ErrorReason>
  extension: Scalars['String']
  isHistorical: Scalars['Boolean']
  language?: Maybe<Scalars['String']>
  processorVersion: Scalars['Float']
  quizJobs?: Maybe<Array<QuizJob>>
  results?: Maybe<AsrJobResults>
  sha512Hash: Scalars['String']
  status: AsrJobStatus
  summaryJobs?: Maybe<Array<SummaryJob>>
  updatedAt: Scalars['DateTime']
  uploadPolicy?: Maybe<Scalars['String']>
  whisperImplementation: WhisperImplementation
}

export type AsrJobResult = {
  __typename?: 'ASRJobResult'
  errorCode?: Maybe<AsrErrorCode>
  job?: Maybe<AsrJob>
  retryAfter?: Maybe<Scalars['String']>
  success: Scalars['Boolean']
}

export type AsrJobResultSegment = {
  __typename?: 'ASRJobResultSegment'
  confidence: Scalars['Float']
  endTime: Scalars['Float']
  startTime: Scalars['Float']
  text: Scalars['String']
}

export type AsrJobResults = {
  __typename?: 'ASRJobResults'
  language: Scalars['String']
  segments: Array<AsrJobResultSegment>
  sha512Hash: Scalars['ID']
  text: Scalars['String']
}

export enum AsrJobStatus {
  Completed = 'COMPLETED',
  PermanentError = 'PERMANENT_ERROR',
  Processing = 'PROCESSING',
  TransientError = 'TRANSIENT_ERROR',
  Uploaded = 'UPLOADED',
  Uploading = 'UPLOADING'
}

export type AsrProcessorVersion = {
  __typename?: 'ASRProcessorVersion'
  processorVersion: Scalars['Float']
}

export enum AccessLevel {
  Editor = 'EDITOR',
  Viewer = 'VIEWER'
}

export type AccountType = {
  __typename?: 'AccountType'
  description: Scalars['String']
  id: Scalars['ID']
  maxNumberOfNotes: Scalars['Int']
  maxNumberOfPublishedNotes: Scalars['Int']
  maxUploadSize: Scalars['Float']
  name: Scalars['String']
}

export type AddNoteToCollectionParams = {
  id: Scalars['String']
  noteId: Scalars['String']
}

export type AddOrganizationAdminParams = {
  fullName?: Maybe<Scalars['String']>
  jobTitle?: Maybe<Scalars['String']>
  organizationAdminEmail: Scalars['String']
  organizationId: Scalars['String']
  phone?: Maybe<Scalars['String']>
}

export type AddOrganizationOwnerParams = {
  fullName?: Maybe<Scalars['String']>
  jobTitle?: Maybe<Scalars['String']>
  organizationId: Scalars['String']
  organizationOwnerEmail: Scalars['String']
  phone?: Maybe<Scalars['String']>
}

export type AddToStudyMaterialsBatchParams = {
  additionalFlashcards?: Maybe<Scalars['Float']>
  additionalQuizQuestions?: Maybe<Scalars['Float']>
  isShared?: Maybe<Scalars['Boolean']>
  studyMaterialsBatchId: Scalars['String']
  subscriptionId?: Maybe<Scalars['String']>
}

export type AdminEventSearchParams = {
  offset?: Maybe<Scalars['Float']>
  pageSize?: Maybe<Scalars['Float']>
  userId: Scalars['String']
}

export type AdminFuzzyUserSearchParams = {
  limit: Scalars['Float']
  query: Scalars['String']
  searchType?: Maybe<Scalars['String']>
}

export type AdminGetCurrentLearnUsageParams = {
  subscriptionId?: Maybe<Scalars['String']>
  userId?: Maybe<Scalars['String']>
}

export type AdminGetUserDataParams = {
  email?: Maybe<Scalars['String']>
  screenname?: Maybe<Scalars['String']>
  transactionId?: Maybe<Scalars['String']>
}

export type AdminLearnQuotaCalculation = {
  __typename?: 'AdminLearnQuotaCalculation'
  cost: AdminLearnQuotaUsage
  mode: Scalars['String']
  questions: AdminLearnQuotaUsage
}

export type AdminLearnQuotaCounts = {
  __typename?: 'AdminLearnQuotaCounts'
  quizCount: Scalars['Float']
  summaryCount: Scalars['Float']
}

export type AdminLearnQuotaResponse = {
  __typename?: 'AdminLearnQuotaResponse'
  calculation: AdminLearnQuotaCalculation
  counts: AdminLearnQuotaCounts
  quotaWindowStart: Scalars['DateTime']
  usage: LearnQuotaUsage
}

export type AdminLearnQuotaUsage = {
  __typename?: 'AdminLearnQuotaUsage'
  hasExceededLearnQuotaUsage: Scalars['Boolean']
  limit: Scalars['Float']
  quotaUsagePercentage: Scalars['Float']
  used: Scalars['Float']
}

export type AllOrganizationResults = {
  __typename?: 'AllOrganizationResults'
  organizationCount: Scalars['Int']
  organizations: Array<OrganizationDetails>
}

export type AllPermissionedUsersForNoteRequest = {
  noteId: Scalars['String']
}

export type AllPermissionedUsersForNoteResponse = {
  __typename?: 'AllPermissionedUsersForNoteResponse'
  permissionedUsers: Array<PermissionedUser>
}

export type AppSettingsResponse = {
  __typename?: 'AppSettingsResponse'
  appSettings?: Maybe<Scalars['JSONObject']>
  errorCode?: Maybe<Scalars['Float']>
  success: Scalars['Boolean']
}

export type AppStoreClassicStatus = {
  __typename?: 'AppStoreClassicStatus'
  createdAt: Scalars['DateTime']
  deviceId: Scalars['String']
  id: Scalars['String']
  likelyFraud: Scalars['Boolean']
  originalApplicationVersion: Scalars['String']
  originalPurchaseDate: Scalars['DateTime']
  updatedAt: Scalars['DateTime']
  user?: Maybe<User>
}

export type AppStoreReceipt = {
  __typename?: 'AppStoreReceipt'
  deviceId?: Maybe<Scalars['String']>
  environment: Scalars['String']
  id: Scalars['Float']
  isValid: Scalars['Boolean']
  originalTransactionId?: Maybe<Scalars['String']>
  parsedReceipt?: Maybe<Scalars['JSONObject']>
  receipt?: Maybe<Scalars['String']>
  receiptCreationDate: Scalars['DateTime']
  updatedAt: Scalars['DateTime']
  user?: Maybe<User>
}

export type AppStoreSubscription = {
  __typename?: 'AppStoreSubscription'
  deviceLimitEnforcementEnabled: Scalars['Boolean']
  devices: Array<AppStoreSubscriptionDevice>
  environment: Scalars['String']
  expirationDate: Scalars['DateTime']
  expirationIntent?: Maybe<ExpirationIntent>
  gracePeriodExpiresAt?: Maybe<Scalars['DateTime']>
  isInBillingRetryPeriod: Scalars['Boolean']
  isInIntroOfferPeriod: Scalars['Boolean']
  isTrialPeriod: Scalars['Boolean']
  offerCodeRefName?: Maybe<Scalars['String']>
  originalPurchaseDate: Scalars['DateTime']
  originalTransactionId: Scalars['String']
  overDeviceLimit: Scalars['Boolean']
  productId: Scalars['String']
  promotionalOfferId?: Maybe<Scalars['String']>
  refundedDate?: Maybe<Scalars['DateTime']>
  refundedReason?: Maybe<Scalars['Int']>
  status: Scalars['String']
  subscriber?: Maybe<Subscriber>
  tier: Scalars['String']
  user?: Maybe<User>
}

export type AppStoreSubscriptionDevice = {
  __typename?: 'AppStoreSubscriptionDevice'
  countryCode?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  deactivatedAt?: Maybe<Scalars['DateTime']>
  deviceId: Scalars['String']
  id: Scalars['String']
  latestReceiptAt?: Maybe<Scalars['DateTime']>
  updatedAt: Scalars['DateTime']
}

export type AppleReceiptParams = {
  countryCode?: Maybe<Scalars['String']>
  deviceId?: Maybe<Scalars['String']>
  receipt?: Maybe<Scalars['String']>
}

export type ApproveCommentParams = {
  commentId: Scalars['String']
}

export type AskChatQuestionParams = {
  studyMaterialsBatchId: Scalars['String']
  subscriptionId?: Maybe<Scalars['String']>
  text: Scalars['String']
}

export enum AsrErrorCode {
  JobAlreadyProcessed = 'JOB_ALREADY_PROCESSED',
  JobNotFound = 'JOB_NOT_FOUND',
  JobProcessing = 'JOB_PROCESSING',
  NotAuthorized = 'NOT_AUTHORIZED',
  NotSubscribed = 'NOT_SUBSCRIBED',
  QuotaExceeded = 'QUOTA_EXCEEDED',
  UnknownError = 'UNKNOWN_ERROR'
}

export type AssociateAppStoreTransactionsParams = {
  countryCode?: Maybe<Scalars['String']>
  transactions: Array<Scalars['String']>
}

export type AuthParams = {
  authToken?: Maybe<Scalars['String']>
}

export type BatchGetUserSurveyResponsesParams = {
  userIds: Array<Scalars['String']>
}

export type BioParams = {
  bio?: Maybe<Scalars['String']>
  etsyUsername?: Maybe<Scalars['String']>
  instagramUsername?: Maybe<Scalars['String']>
  tikTokUsername?: Maybe<Scalars['String']>
  twitterUsername?: Maybe<Scalars['String']>
  youtubeUrl?: Maybe<Scalars['String']>
}

export type CancelUserTrialSubscriptionParams = {
  trialUserId?: Maybe<Scalars['String']>
}

export type Category = {
  __typename?: 'Category'
  contentType: GalleryContentType
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  isActive: Scalars['Boolean']
  isDefaultForPublishing: Scalars['Boolean']
  localizedName: Scalars['String']
  name: Scalars['String']
  parentId?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
}

export type ChangeAdminStatusParams = {
  isAdmin: Scalars['Boolean']
  notes?: Maybe<Scalars['String']>
  userId: Scalars['String']
}

export type ChangeBlockStatusParams = {
  doBlock: Scalars['Boolean']
  notes?: Maybe<Scalars['String']>
  userId: Scalars['String']
}

export type ChangeEmailParams = {
  email: Scalars['String']
  notes?: Maybe<Scalars['String']>
  userId: Scalars['String']
}

export type ChangeScreennameParams = {
  newScreenname: Scalars['String']
  notes?: Maybe<Scalars['String']>
  userId: Scalars['String']
}

export type CheckEnrollmentAvailabilityParams = {
  clientId: Scalars['String']
}

export type CollabDeleteLibraryParams = {
  userId: Scalars['String']
}

export type CollabNoteEditor = {
  __typename?: 'CollabNoteEditor'
  deviceId: Scalars['String']
  id: Scalars['ID']
  note: CollabNoteMetadata
  permissions: CollabNotePermission
  siteId: Scalars['Float']
  user: User
}

export type CollabNoteMetadata = {
  __typename?: 'CollabNoteMetadata'
  accessLevel: AccessLevel
  createdAt: Scalars['Timestamp']
  deletedAt?: Maybe<Scalars['Timestamp']>
  editors: Array<CollabNoteEditor>
  id: Scalars['String']
  legacyNoteId?: Maybe<Scalars['String']>
  mediaInsertions: Array<NoteMediaInsertion>
  mostRecentOpTime?: Maybe<Scalars['Timestamp']>
  owner: User
  permissionScope: PermissionScope
  permissions: Array<CollabNotePermission>
  serverPublishTime: Scalars['Float']
  subject?: Maybe<Subject>
  thumbnail?: Maybe<CollabNoteThumbnail>
  title?: Maybe<Scalars['String']>
  titleOpLogicalTime?: Maybe<Scalars['Float']>
  titleOpSiteId?: Maybe<Scalars['Float']>
  updatedAt: Scalars['Timestamp']
  users: Array<CollabNoteUserMetadata>
}

export type CollabNotePermission = {
  __typename?: 'CollabNotePermission'
  id: Scalars['ID']
  note: CollabNoteMetadata
  role: CollabNoteRole
  user: User
}

export enum CollabNoteRole {
  Editor = 'EDITOR',
  Owner = 'OWNER',
  Viewer = 'VIEWER'
}

export type CollabNoteThumbnail = {
  __typename?: 'CollabNoteThumbnail'
  id: Scalars['String']
}

export type CollabNoteUserMetadata = {
  __typename?: 'CollabNoteUserMetadata'
  id: Scalars['ID']
  isFavorited: Scalars['Boolean']
  lastOpened?: Maybe<Scalars['Timestamp']>
  note: CollabNoteMetadata
  noteId: Scalars['String']
  updatedAt: Scalars['DateTime']
  user: User
}

export type CollabTestDataParams = {
  breadth: Scalars['Float']
  depth: Scalars['Float']
}

export type College = {
  __typename?: 'College'
  country: Scalars['String']
  id: Scalars['String']
  name: Scalars['String']
  website: Scalars['String']
}

export type CollegeMajor = {
  __typename?: 'CollegeMajor'
  code: Scalars['Int']
  major: Scalars['String']
}

export type Comment = {
  __typename?: 'Comment'
  approvalState?: Maybe<CommentReviewState>
  author: User
  commentText: Scalars['String']
  createdAt: Scalars['DateTime']
  galleryNote: GalleryNote
  id: Scalars['ID']
  parent?: Maybe<Comment>
  rejectionReason?: Maybe<Scalars['String']>
  reviewedBy?: Maybe<User>
  updatedAt: Scalars['DateTime']
}

export {CommentReviewState}

export type CreateAsrJobParams = {
  audioCreationDateMs: Scalars['Float']
  audioDurationMs?: Maybe<Scalars['Float']>
  deviceId?: Maybe<Scalars['String']>
  extension?: Maybe<Scalars['String']>
  generateStudyJobs?: Maybe<Scalars['Boolean']>
  language?: Maybe<Scalars['String']>
  recordingCount?: Maybe<Scalars['Int']>
  sha512Hash: Scalars['String']
  subscriptionId?: Maybe<Scalars['String']>
}

export type CreateCommentParams = {
  commentText: Scalars['String']
  galleryNoteId: Scalars['String']
}

export type CreateDivider = {
  id: Scalars['String']
  parentId?: Maybe<Scalars['String']>
  siblingOrder: Scalars['Float']
  title: Scalars['String']
}

export type CreateMagicLinkParams = {
  email: Scalars['String']
  isFromWebApp?: Maybe<Scalars['Boolean']>
  signUp: Scalars['Boolean']
}

export type CreateNote = {
  createdAt: Scalars['Timestamp']
  deviceId: Scalars['String']
  id: Scalars['String']
  legacyNoteId?: Maybe<Scalars['String']>
  linkAccessLevel: AccessLevel
  linkPermissionScope: PermissionScope
  title?: Maybe<Scalars['String']>
}

export type CreateNoteCollectionParams = {
  isOfficialContent?: Maybe<Scalars['Boolean']>
  name: Scalars['String']
  officialCollectionId?: Maybe<Scalars['String']>
}

export type CreateOrgParams = {
  comments?: Maybe<Scalars['String']>
  contractAcceptedAt?: Maybe<Scalars['DateTime']>
  creatorEmail: Scalars['String']
  creatorFullName?: Maybe<Scalars['String']>
  creatorJobTitle?: Maybe<Scalars['String']>
  educationLevelsProvided?: Maybe<Array<EducationLevel>>
  industry?: Maybe<Scalars['String']>
  isAsmEnrolled?: Maybe<Scalars['Boolean']>
  mdmPlatform?: Maybe<Scalars['String']>
  orgName: Scalars['String']
  organizationType?: Maybe<OrganizationType>
  phone?: Maybe<Scalars['String']>
  seatCount: Scalars['Int']
}

export type CreateSubject = {
  emoji?: Maybe<Scalars['String']>
  hexColor: Scalars['String']
  id: Scalars['String']
  isLocked: Scalars['Boolean']
  parentId?: Maybe<Scalars['String']>
  siblingOrder: Scalars['Float']
  title: Scalars['String']
}

export type CreateTrialSubscriptionParams = {
  expirationDate?: Maybe<Scalars['DateTime']>
  trialLengthInDays?: Maybe<Scalars['Float']>
  trialUserId: Scalars['String']
}

export type CreateVppEmailDomainParams = {
  emailDomain: Scalars['String']
}

export type DegradedStateParams = {
  setDegraded: Scalars['Boolean']
}

export type DeleteCommentParams = {
  commentId: Scalars['String']
}

export type DeleteExperimentParams = {
  id: Scalars['String']
}

export type DeleteGlobalOverrideValueParams = {
  key: Scalars['String']
}

export type DeleteNote = {
  noteId: Scalars['String']
}

export type DeleteNoteCollectionParams = {
  id: Scalars['String']
}

export type DeleteOrganizer = {
  childrenHash?: Maybe<Scalars['String']>
  organizerId: Scalars['String']
}

export type DeletePromoParams = {
  id: Scalars['String']
}

export type DeleteVppEmailDomainParams = {
  emailDomain: Scalars['String']
}

export type DisableDevicesForSubscriptionsParams = {
  transactionId: Scalars['String']
}

export type Divider = {
  __typename?: 'Divider'
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  noteMetadatas: Array<CollabNoteMetadata>
  organizerType: OrganizerTypeKey
  parent?: Maybe<Organizer>
  parentId?: Maybe<Scalars['String']>
  siblingOrder: Scalars['Float']
  title: Scalars['String']
  updatedAt: Scalars['DateTime']
  user: User
}

export type DownloadedGalleryNote = {
  __typename?: 'DownloadedGalleryNote'
  createdAt: Scalars['DateTime']
  galleryNote: GalleryNote
  id: Scalars['ID']
  updatedAt: Scalars['DateTime']
  user: User
}

export type EditParams = {
  commentsEnabled: Scalars['Boolean']
  contentType: Scalars['String']
  description: Scalars['String']
  id: Scalars['String']
  language?: Maybe<Scalars['String']>
  noteName: Scalars['String']
  tags: Array<Scalars['String']>
}

export enum EducationLevel {
  K_12 = 'K_12',
  Other = 'OTHER',
  PostGraduate = 'POST_GRADUATE',
  University = 'UNIVERSITY'
}

export type EnableGalleryAccessParams = {
  clientId?: Maybe<Scalars['String']>
}

export type EnrollmentLimits = {
  __typename?: 'EnrollmentLimits'
  clientId: Scalars['ID']
  /** @deprecated Legacy support for link sharing. Always returns true. */
  enabled: Scalars['Boolean']
  /** @deprecated Legacy support for note gallery. Always returns true. */
  noteGalleryEnabled: Scalars['Boolean']
}

export enum ErrorCode {
  InvalidMutation = 'InvalidMutation',
  InvalidUuid = 'InvalidUUID',
  NotFound = 'NotFound',
  ServerError = 'ServerError',
  Unauthorized = 'Unauthorized'
}

export enum ErrorReason {
  AttemptsExhausted = 'ATTEMPTS_EXHAUSTED',
  SpeechNotDetected = 'SPEECH_NOT_DETECTED'
}

export type ExchangeResponse = {
  __typename?: 'ExchangeResponse'
  message?: Maybe<StudyChatMessage>
  pending: Scalars['Boolean']
}

export type Experiment = {
  __typename?: 'Experiment'
  analyticsPanelUrl?: Maybe<Scalars['String']>
  description: Scalars['String']
  enrolledUsers: Array<ExperimentEnrollment>
  enrollmentStrategy: ExperimentEnrollmentStrategy
  id: Scalars['ID']
  targetEnrollmentPct: Scalars['Float']
}

export type ExperimentData = {
  __typename?: 'ExperimentData'
  experiments: Array<ExperimentPlacement>
  values: Array<ExperimentValueOverride>
}

export type ExperimentDataParams = {
  anonymousId?: Maybe<Scalars['String']>
  buildNumber?: Maybe<Scalars['Float']>
  languageCode?: Maybe<Scalars['String']>
  subscriptionTier?: Maybe<Scalars['String']>
  userId?: Maybe<Scalars['String']>
}

export type ExperimentEnrollment = {
  __typename?: 'ExperimentEnrollment'
  anonymousId: Scalars['String']
  experiment: Experiment
  id: Scalars['ID']
  inVariantGroup: Scalars['Boolean']
  isOverride: Scalars['Boolean']
  user?: Maybe<User>
}

export type ExperimentEnrollmentOverrideQueryParams = {
  experimentId: Scalars['String']
}

export type ExperimentEnrollmentParams = {
  experimentId: Scalars['String']
  inVariantGroup: Scalars['Boolean']
  screenname: Scalars['String']
}

export {ExperimentEnrollmentStrategy}

export type ExperimentParams = {
  analyticsPanelUrl?: Maybe<Scalars['String']>
  codeFilters?: Maybe<Array<Scalars['String']>>
  description: Scalars['String']
  enrollmentStrategy: ExperimentEnrollmentStrategy
  freeformValues?: Maybe<Array<ExperimentValueMapping>>
  id: Scalars['String']
  matchType?: Maybe<Scalars['String']>
  structuredValues?: Maybe<Array<ExperimentValueMapping>>
  targetEnrollmentPct?: Maybe<Scalars['Float']>
}

export type ExperimentPlacement = {
  __typename?: 'ExperimentPlacement'
  experimentName: Scalars['String']
  variantName: Scalars['String']
}

export type ExperimentValueMapping = {
  controlVal: Scalars['String']
  valueKey: Scalars['String']
  variantVal: Scalars['String']
}

export type ExperimentValueOverride = {
  __typename?: 'ExperimentValueOverride'
  parameterName: Scalars['String']
  value: Scalars['String']
}

export enum ExpirationIntent {
  BillingError = 'BILLING_ERROR',
  CustomerCancelled = 'CUSTOMER_CANCELLED',
  PriceIncreased = 'PRICE_INCREASED',
  ProductUnavailable = 'PRODUCT_UNAVAILABLE',
  UnknownError = 'UNKNOWN_ERROR'
}

export type FailedMutation = {
  __typename?: 'FailedMutation'
  error: ErrorCode
  idempotencyKey: Scalars['String']
}

export type FavoriteNotesParams = {
  numberToGet?: Maybe<Scalars['Int']>
}

export type FeaturedCollectionsAndNotesParams = {
  limit: Scalars['Float']
}

export type FlagParams = {
  note: Scalars['String']
  reason: Scalars['String']
  reporterComment?: Maybe<Scalars['String']>
}

export type FlagProfileParams = {
  profileSection: ProfileSection
  profileToFlagId: Scalars['String']
  reason: Scalars['String']
  reporterComment?: Maybe<Scalars['String']>
}

export type FlaggedContent = {
  __typename?: 'FlaggedContent'
  context: Scalars['String']
  flaggedTerm: Scalars['String']
}

export type FlaggedNote = {
  __typename?: 'FlaggedNote'
  createdAt: Scalars['DateTime']
  flaggedReason: FlaggedReason
  galleryNote: GalleryNote
  id: Scalars['ID']
  updatedAt: Scalars['DateTime']
  user: User
}

export {FlaggedReason}

export type FollowPair = {
  __typename?: 'FollowPair'
  followedId: Scalars['String']
  followerId: Scalars['String']
  isFollowing: Scalars['Boolean']
}

export type FollowParams = {
  userIdToFollow: Scalars['String']
}

export type Following = {
  __typename?: 'Following'
  followed: User
}

export type FollowingMetadata = {
  __typename?: 'FollowingMetadata'
  createdAt: Scalars['DateTime']
  newNotesAvailable: Scalars['Boolean']
  updatedAt: Scalars['DateTime']
  user: User
}

export type FollowingUsersParameters = {
  limit?: Maybe<Scalars['Float']>
  offset?: Maybe<Scalars['Float']>
  userId?: Maybe<Scalars['String']>
}

export type ForceResetMigrationsRequest = {
  userId: Scalars['String']
}

export type FreeNamespaceParams = {
  pullRequestId: Scalars['Float']
}

export enum GalleryContentType {
  Any = 'ANY',
  Templates = 'TEMPLATES'
}

export type GalleryNote = {
  __typename?: 'GalleryNote'
  activeTags: Array<Scalars['String']>
  adminEvents: Array<GalleryNoteAdminEvent>
  category?: Maybe<Category>
  clientId: Scalars['String']
  commentsEnabled: Scalars['Boolean']
  containsPencil: Scalars['Boolean']
  containsStudyTape: Scalars['Boolean']
  contentType: GalleryNoteContentType
  createdAt: Scalars['DateTime']
  description: Scalars['String']
  downloadURL: Scalars['String']
  downloadedGalleryNotes: Array<DownloadedGalleryNote>
  downloads: Scalars['Float']
  flaggedNotes: Array<FlaggedNote>
  id: Scalars['String']
  isSubscriberForBackfill: Scalars['Boolean']
  language?: Maybe<Scalars['String']>
  likedGalleryNotes: Array<LikedGalleryNote>
  likes: Scalars['Float']
  mentionedProfiles: Array<UserProfile>
  name: Scalars['String']
  noteUploadedAt?: Maybe<Scalars['DateTime']>
  notifications: Array<Notification>
  parentNoteId?: Maybe<Scalars['String']>
  passedReviewAtFlagCount: Scalars['Float']
  pdfUploadedAt?: Maybe<Scalars['DateTime']>
  popularScore: Scalars['Float']
  previewCount: Scalars['Float']
  previewImages: Array<Scalars['String']>
  previewUploadCount: Scalars['Float']
  rating: Scalars['Float']
  remixCount: Scalars['Float']
  rootNoteId?: Maybe<Scalars['String']>
  tags?: Maybe<Array<GalleryNoteTag>>
  trendingScoreCalculatedAt: Scalars['DateTime']
  triageState: TriageState
  updatedAt: Scalars['DateTime']
  url: Scalars['String']
  user: User
  viewCount: Scalars['Float']
}

export type GalleryNoteDownloadUrlArgs = {
  fileType: Scalars['String']
}

export type GalleryNoteAdminEvent = {
  __typename?: 'GalleryNoteAdminEvent'
  createdAt: Scalars['DateTime']
  eventType: GalleryNotesAdminEventType
  flaggedReason?: Maybe<FlaggedReason>
  galleryNote: GalleryNote
  galleryNoteName: Scalars['String']
  id: Scalars['String']
  systemNotes?: Maybe<Scalars['String']>
  triggeringUser?: Maybe<User>
  triggeringUserEmail: Scalars['String']
  triggeringUserNotes?: Maybe<Scalars['String']>
}

export {GalleryNoteContentType}

export type GalleryNoteResults = {
  __typename?: 'GalleryNoteResults'
  results: Array<GalleryNote>
  totalCount: Scalars['Float']
}

export type GalleryNoteTag = {
  __typename?: 'GalleryNoteTag'
  createdAt: Scalars['DateTime']
  createdByUser?: Maybe<User>
  id: Scalars['ID']
  isActive: Scalars['Boolean']
  name: Scalars['String']
  updatedAt: Scalars['DateTime']
}

export {GalleryNotesAdminEventType}

export type GenerateCollabLinkParams = {
  noteId: Scalars['GqlUUID']
  permission?: Maybe<Scalars['String']>
}

export type GenerateSiteIdParams = {
  deviceId: Scalars['GqlUUID']
  noteId: Scalars['GqlUUID']
}

export type GenerateStudyMaterialsBatchParams = {
  asrJobSha512Hashes?: Maybe<Array<Scalars['String']>>
  clientNoteId?: Maybe<Scalars['String']>
  existingBatchId?: Maybe<Scalars['String']>
  handwrittenText?: Maybe<Scalars['String']>
  includeFlashcards?: Maybe<Scalars['Boolean']>
  includeQuizzes?: Maybe<Scalars['Boolean']>
  language?: Maybe<Scalars['String']>
  noteText?: Maybe<Scalars['String']>
  numFlashcards?: Maybe<Scalars['Float']>
  numQuizQuestions?: Maybe<Scalars['Float']>
  pdfText?: Maybe<Scalars['String']>
  promptGroup?: Maybe<Scalars['String']>
  subscriptionId?: Maybe<Scalars['String']>
}

export type GetAsrJobParams = {
  sha512Hash: Scalars['String']
}

export type GetAllCommentsParams = {
  authorId?: Maybe<Scalars['String']>
  limit: Scalars['Float']
  offset: Scalars['Float']
  reviewState?: Maybe<Scalars['String']>
}

export type GetAllOrganizationsParams = {
  isApproved?: Maybe<Scalars['Boolean']>
}

export type GetAllSubscriptionInfoParams = {
  deviceId?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
  transactionId?: Maybe<Scalars['String']>
  userId?: Maybe<Scalars['String']>
}

export type GetAllSubscriptionsOverDeviceLimitParams = {
  limit: Scalars['Float']
  offset: Scalars['Float']
}

export type GetAllSubscriptionsOverDeviceLimitResult = {
  __typename?: 'GetAllSubscriptionsOverDeviceLimitResult'
  deviceLimitEnforcementEnabled: Scalars['Boolean']
  numDevices: Scalars['Float']
  subscriptionId: Scalars['String']
}

export type GetBuildMetadataParams = {
  buildNamespace: Scalars['String']
}

export type GetBuildMetadataResult = {
  __typename?: 'GetBuildMetadataResult'
  author: Scalars['String']
  authorAvatar?: Maybe<Scalars['String']>
  prLink: Scalars['String']
  prNumber: Scalars['Float']
  title: Scalars['String']
}

export type GetChatAnswerParams = {
  studyChatExchangeId: Scalars['String']
  subscriptionId?: Maybe<Scalars['String']>
}

export type GetChatHistoryParams = {
  studyMaterialsBatchId: Scalars['String']
  subscriptionId?: Maybe<Scalars['String']>
}

export type GetCollatedFlaggedNoteInfoParams = {
  userId: Scalars['ID']
}

export type GetCollatedFlaggedNoteInfoResult = {
  __typename?: 'GetCollatedFlaggedNoteInfoResult'
  flaggedNotes: Array<GalleryNote>
  flaggingUser: User
}

export type GetCurrentQuotaUsageParams = {
  deviceId?: Maybe<Scalars['String']>
  subscriptionId?: Maybe<Scalars['String']>
  userId?: Maybe<Scalars['String']>
}

export type GetFuzzyScreennameMatchesParams = {
  limit: Scalars['Float']
  screenname: Scalars['String']
}

export type GetInstitutionsParams = {
  ascending: Scalars['Boolean']
  institutionNameSearch: Scalars['String']
  limit: Scalars['Float']
  offset: Scalars['Float']
  orderBy: Scalars['InstitutionOrderBy']
}

export type GetInstitutionsResult = {
  __typename?: 'GetInstitutionsResult'
  count: Scalars['Float']
  institutions: Array<InstitutionWithDeviceCount>
}

export type GetLearnQuotaUsageParams = {
  subscriptionId?: Maybe<Scalars['String']>
}

export type GetNoteRootCommentsParams = {
  limit: Scalars['Float']
  noteId: Scalars['String']
  offset: Scalars['Float']
}

export type GetNotesParameters = {
  language?: Maybe<Scalars['String']>
  limit: Scalars['Float']
  offset: Scalars['Float']
}

export type GetNotificationsParams = {
  limit: Scalars['Float']
  offset: Scalars['Float']
}

export type GetOrganizationParams = {
  organizationId: Scalars['String']
}

export type GetQuizJobContentParams = {
  quizJobId: Scalars['String']
}

export type GetSendGridEventsParams = {
  ascending: Scalars['Boolean']
  email?: Maybe<Scalars['String']>
  limit: Scalars['Float']
  offset: Scalars['Float']
}

export type GetStripeCustomerPortalParams = {
  redirectUrl: Scalars['String']
}

export type GetStudyMaterialsBatchParams = {
  studyMaterialsBatchId: Scalars['String']
}

export type GetSubscriptionInfoParams = {
  userId: Scalars['String']
}

export type GetSummaryJobContentParams = {
  summaryJobId: Scalars['String']
}

export type GetTopTagParams = {
  languages?: Maybe<Array<Scalars['String']>>
  limit?: Maybe<Scalars['Float']>
  offset?: Maybe<Scalars['Float']>
}

export type GetUserIsFollowedParams = {
  followedId: Scalars['String']
}

export type GetUserSharedNotesParams = {
  userId: Scalars['ID']
}

export type GetUserTrialSubscriptionParams = {
  trialUserId?: Maybe<Scalars['String']>
}

export type GetVppEmailDomainParams = {
  limit: Scalars['Float']
  offset: Scalars['Float']
}

export type GetViableSubscriptionParams = {
  subscriptionId?: Maybe<Scalars['String']>
  userId?: Maybe<Scalars['String']>
}

export type GrantSubscriptionOverrideParams = {
  /** email of the user to grant the subscription to */
  email: Scalars['String']
  expirationDate: Scalars['DateTime']
  notes?: Maybe<Scalars['String']>
  overrideReason: Scalars['String']
  overrideTier: SubscriptionTier
}

export type HiddenProfilesParams = {
  offset?: Maybe<Scalars['Float']>
  pageSize?: Maybe<Scalars['Float']>
}

export type HiddenProfilesResults = {
  __typename?: 'HiddenProfilesResults'
  results: Array<UserProfile>
  totalCount: Scalars['Float']
}

export type HideCommentParams = {
  commentId: Scalars['String']
  rejectionReason?: Maybe<Scalars['String']>
}

export type InstitutionWithDeviceCount = {
  __typename?: 'InstitutionWithDeviceCount'
  createdAt: Scalars['DateTime']
  deviceCount: Scalars['Int']
  id: Scalars['String']
  licenseEnforcement: LicenseEnforcement
  licenseEnforcementExpiration?: Maybe<Scalars['DateTime']>
  name: Scalars['String']
}

export enum LearnErrorReason {
  BucketResultNotFound = 'BUCKET_RESULT_NOT_FOUND',
  InputTooShort = 'INPUT_TOO_SHORT',
  InsufficientContext = 'INSUFFICIENT_CONTEXT',
  InvalidResult = 'INVALID_RESULT',
  LlmImproperSchema = 'LLM_IMPROPER_SCHEMA',
  LlmInvalidJson = 'LLM_INVALID_JSON',
  LlmUnexpectedResponse = 'LLM_UNEXPECTED_RESPONSE',
  ProcessingFailure = 'PROCESSING_FAILURE',
  ResultRetrievalFailure = 'RESULT_RETRIEVAL_FAILURE',
  TranscriptDoesNotExist = 'TRANSCRIPT_DOES_NOT_EXIST'
}

export type LearnQuotaUsage = {
  __typename?: 'LearnQuotaUsage'
  hasExceededLearnQuotaUsage: Scalars['Boolean']
  quotaUsagePercentage: Scalars['Float']
}

export type LibraryId = {
  /** required for type: CloudKit */
  icloudUserId?: Maybe<Scalars['String']>
  /** required for type: NotabilityServer */
  serverUserId?: Maybe<Scalars['String']>
  type: LibraryType
  /** required for type: NotabilityServer */
  workspaceId?: Maybe<Scalars['String']>
}

export type LibraryState = {
  __typename?: 'LibraryState'
  permanentlyDeletedNotes?: Maybe<Array<Scalars['String']>>
  /** null if full state reload */
  priorSequenceId?: Maybe<Scalars['Int']>
  privateSpace?: Maybe<Workspace>
  sequenceId: Scalars['Int']
  /** shared notes dont belong to any workspace */
  sharedNotes?: Maybe<Array<NoteV2>>
  sharedSpaces?: Maybe<Array<Workspace>>
}

export enum LibraryType {
  CloudKit = 'CloudKit',
  Legacy = 'Legacy',
  LocalCollab = 'LocalCollab',
  NotabilityServer = 'NotabilityServer'
}

export enum LicenseEnforcement {
  None = 'NONE',
  Strict = 'STRICT',
  Warning = 'WARNING'
}

export type LikeParams = {
  note: Scalars['String']
}

export type LikedGalleryNote = {
  __typename?: 'LikedGalleryNote'
  createdAt: Scalars['DateTime']
  galleryNote: GalleryNote
  id: Scalars['ID']
  updatedAt: Scalars['DateTime']
  user: User
}

export type LikedNotePair = {
  __typename?: 'LikedNotePair'
  likesNote: Scalars['Boolean']
  noteId: Scalars['String']
}

export type LikingUsersParameters = {
  limit: Scalars['Float']
  noteId: Scalars['String']
  offset: Scalars['Float']
}

export type LinkShareSettings = {
  __typename?: 'LinkShareSettings'
  linkAccessLevel: AccessLevel
  linkPermissionScope: PermissionScope
}

export type LlmAddStyleParams = {
  inputText: Scalars['String']
  style: Scalars['String']
}

export type LlmIsCorrectAnswerParams = {
  correctAnswer: Scalars['String']
  question: Scalars['String']
  userAnswer: Scalars['String']
}

export type LlmMakeRhymeParams = {
  focusTopic: Scalars['String']
  inputText: Scalars['String']
  rhymeScheme: Scalars['String']
}

export type LlmTextTransformation = {
  __typename?: 'LlmTextTransformation'
  outputText: Scalars['Boolean']
  success: Scalars['Boolean']
}

export type Locale = {
  __typename?: 'Locale'
  description: Scalars['String']
  id: Scalars['ID']
  languageCode: Scalars['String']
}

export type LoginParams = {
  email: Scalars['String']
  password: Scalars['String']
}

export type MagicLinkLoginParams = {
  magicLinkUUID: Scalars['String']
  userId: Scalars['String']
}

export type MarkFeedAsViewedParams = {
  viewedUpTo: Scalars['String']
}

export type MarkNotificationsSeenParams = {
  notificationIds: Array<Scalars['String']>
}

export type MediaUploadStatus = {
  __typename?: 'MediaUploadStatus'
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  noteMediaInsertions: Array<NoteMediaInsertion>
  sha512Hash: Scalars['String']
  sizeInBytes: Scalars['Float']
  status: MediaUploadStatusEnum
  updatedAt?: Maybe<Scalars['DateTime']>
}

export enum MediaUploadStatusEnum {
  Deleted = 'DELETED',
  Pending = 'PENDING',
  Uploaded = 'UPLOADED'
}

export type MetadataLibraryRequest = {
  /** null to request a full state reset in the response */
  partialUpdateSequenceId?: Maybe<Scalars['Int']>
}

/** One-Of: expects exactly one mutation property to be set */
export type MetadataMutation = {
  createDivider?: Maybe<CreateDivider>
  createNote?: Maybe<CreateNote>
  createSubject?: Maybe<CreateSubject>
  deleteNote?: Maybe<DeleteNote>
  deleteOrganizer?: Maybe<DeleteOrganizer>
  idempotencyKey: Scalars['String']
  modifyNote?: Maybe<ModifyNote>
  modifyOrganizer?: Maybe<ModifyOrganizer>
  permanentlyDeleteNote?: Maybe<PermanentlyDeleteNote>
  undeleteNote?: Maybe<UndeleteNote>
}

export type MigratingDevice = {
  __typename?: 'MigratingDevice'
  controllingDeviceId: Scalars['String']
  controllingDeviceName: Scalars['String']
  id: Scalars['String']
  source: ResponseLibraryId
  startDate: Scalars['Timestamp']
  target: ResponseLibraryId
}

export type ModifyMetadataRequest = {
  mutations: Array<MetadataMutation>
  /** null to request a full state reset in the response */
  partialUpdateSequenceId?: Maybe<Scalars['Int']>
}

export type ModifyMetadataResponse = {
  __typename?: 'ModifyMetadataResponse'
  failedMutations: Array<FailedMutation>
  state: LibraryState
  successfulMutations: Array<Scalars['String']>
}

export type ModifyNote = {
  isFavorited?: Maybe<Scalars['Boolean']>
  lastOpened?: Maybe<Scalars['Timestamp']>
  linkAccessLevel?: Maybe<AccessLevel>
  linkPermissionScope?: Maybe<PermissionScope>
  moveToSubject?: Maybe<MoveToOrganizer>
  noteId: Scalars['String']
  permissions?: Maybe<Array<PermissionChange>>
}

export type ModifyOrgParams = {
  newName: Scalars['String']
  orgId: Scalars['String']
}

export type ModifyOrganizationLicenseParams = {
  expiration?: Maybe<Scalars['DateTime']>
  licenseId: Scalars['String']
  maxSeats?: Maybe<Scalars['Float']>
}

export type ModifyOrganizer = {
  moveToParent?: Maybe<MoveToOrganizer>
  organizerId: Scalars['String']
  siblingOrder?: Maybe<Scalars['Float']>
  subjectEmoji?: Maybe<Scalars['String']>
  subjectHexColor?: Maybe<Scalars['String']>
  subjectIsLocked?: Maybe<Scalars['Boolean']>
  title?: Maybe<Scalars['String']>
}

export type ModifyTrialExpirationParams = {
  trialUserId: Scalars['String']
  updatedExpirationDate: Scalars['DateTime']
}

export type MoveToOrganizer = {
  /** null to unfile */
  parentId?: Maybe<Scalars['String']>
}

export type Mutation = {
  __typename?: 'Mutation'
  /** @deprecated enrollment limits are lifted */
  addEnrollmentRecord: EnrollmentLimits
  addNoteToCollection: NoteCollection
  /** @deprecated Use addOrganizationOwner */
  addOrganizationAdmin: Scalars['Boolean']
  addOrganizationOwner: Scalars['Boolean']
  addToStudyMaterialsBatch: StudyMaterialsBatch
  adminSimulateQuota: Scalars['Boolean']
  approveComment: Scalars['ID']
  askChatQuestion: Scalars['ID']
  assignAllUsersToExperiments: Scalars['Boolean']
  associateAppStoreTransactions: SubscriptionOverview
  cancelTrial: Scalars['Boolean']
  changeAdminStatus: Scalars['Boolean']
  changeBlockStatus: Scalars['Boolean']
  changeEmail: Scalars['String']
  changeScreenname: Scalars['String']
  computeTopTags: Scalars['String']
  createASRJob: AsrJobResult
  createCollection: Scalars['String']
  createComment: Comment
  createExperiment: Experiment
  createMagicLink: Scalars['Boolean']
  createOrganization: Organization
  createPromoNotification: PromoNotification
  createTrialSubscription: TrialSubscription
  createVPPEmailDomain: VppAllowlistEmail
  deleteAccount: Scalars['Boolean']
  deleteCollection: Scalars['Boolean']
  deleteComment: Scalars['ID']
  deleteExperiment: Scalars['Boolean']
  deleteGlobalOverrideValue: Scalars['String']
  deletePromoNotification: Scalars['String']
  deleteUserCollabLibrary: OrganizerMutationResult
  deleteVPPEmailDomain: Scalars['Boolean']
  disableDevicesForSubscriptions: Scalars['Boolean']
  dismissGuidelines: Scalars['Boolean']
  editExperiment: Scalars['Boolean']
  editNote: GalleryNote
  editPromoNotification: PromoNotification
  /** @deprecated enrollment limits are lifted */
  enableGalleryAccess: EnrollmentLimits
  enroll: User
  flagNote: GalleryNote
  flagNoteFamilyTree: Array<GalleryNote>
  flagProfile: Scalars['Boolean']
  followUser: FollowPair
  forceResetMigrations: Scalars['Boolean']
  freeNamespace: Scalars['Boolean']
  generateCollabLinkToken: Scalars['String']
  generateCollabTestDataForUser: OrganizerMutationResult
  generateSiteId: Scalars['Float']
  generateStudyMaterialsBatch: StudyMaterialsBatch
  grantSubscriptionOverride: Scalars['Boolean']
  hideComment: Scalars['ID']
  likeNote: GalleryNote
  loginViaMagicLink: User
  markFeedAsViewed: Scalars['Boolean']
  markNotificationsSeen: Scalars['Boolean']
  modifyMetadata: ModifyMetadataResponse
  modifyOrganization: Scalars['Boolean']
  modifyOrganizationLicense: Scalars['Boolean']
  modifyTrialExpiration: Scalars['Boolean']
  noteViewed: Scalars['Boolean']
  prepareMediaUpload: PrepareMediaUploadResult
  preparePublish: PublishResult
  processAppleReceipt: SubscriptionResult
  processVPPReceipt: VppAccountResult
  reloadEnvironmentCache: Scalars['Boolean']
  removeAppSetting: AppSettingsResponse
  removeExperimentEnrollmentOverride: Scalars['Boolean']
  removeNoteFromCollection: Scalars['Boolean']
  removeUserSurveyResponseKeys: UserSurveyResponse
  renameUser: Scalars['Boolean']
  reorderNoteCollectionNote: Scalars['Boolean']
  reportComment: Scalars['ID']
  reprocessASRJob: AsrJobResult
  resetOrganizationSeatUsage: Scalars['Boolean']
  restoreOrganization: Scalars['Boolean']
  reviewFlaggedProfile: Scalars['Boolean']
  reviewOrganization: Scalars['Boolean']
  revokeCollabLink: Scalars['Boolean']
  setAppSetting: AppSettingsResponse
  setCollegeAndMajor: Scalars['Boolean']
  setGalleryDegraded: Scalars['Boolean']
  setGlobalOverrideValue: Scalars['Boolean']
  setIgnoreFlags: UserProfile
  setLanguage: GalleryNote
  setLicenseEnforcement: Scalars['Boolean']
  setLicenseEnforcementExpiration: Scalars['Boolean']
  setMigratingDevice: SetMigratingDeviceResponse
  setPromoAsDraft: PromoNotification
  setUserSurveyResponse: UserSurveyResponse
  stopSharing: Scalars['Boolean']
  toggleDeviceLimitEnforcement: AppStoreSubscription
  triageNote: TriageResult
  unfollowUser: FollowPair
  unlikeNote: GalleryNote
  unlockUserAccount: Scalars['Boolean']
  unpublish: Scalars['Boolean']
  updateBio: UserProfile
  updateCollection: NoteCollection
  updateCookies: Scalars['String']
  updateExperimentData: ExperimentData
  updateProfile: UserProfile
  updateUserExperimentEnrollmentOverride: ExperimentEnrollment
  updateUserLanguage: Scalars['Boolean']
  upload: UploadResult
  visitCollabLink: Scalars['String']
}

export type MutationAddNoteToCollectionArgs = {
  addNoteToCollectionParams: AddNoteToCollectionParams
}

export type MutationAddOrganizationAdminArgs = {
  addOrganizationAdminParams: AddOrganizationAdminParams
}

export type MutationAddOrganizationOwnerArgs = {
  addOrganizationOwnerParams: AddOrganizationOwnerParams
}

export type MutationAddToStudyMaterialsBatchArgs = {
  addToStudyMaterialsBatchParams: AddToStudyMaterialsBatchParams
}

export type MutationAdminSimulateQuotaArgs = {
  simulateASRQuotaParams: SimulateAsrQuotaParams
}

export type MutationApproveCommentArgs = {
  approveCommentParams: ApproveCommentParams
}

export type MutationAskChatQuestionArgs = {
  askChatQuestionParams: AskChatQuestionParams
}

export type MutationAssociateAppStoreTransactionsArgs = {
  associateAppStoreTransactionsParams: AssociateAppStoreTransactionsParams
}

export type MutationCancelTrialArgs = {
  cancelUserTrialSubscriptionParams: CancelUserTrialSubscriptionParams
}

export type MutationChangeAdminStatusArgs = {
  changeAdminStatusParams: ChangeAdminStatusParams
}

export type MutationChangeBlockStatusArgs = {
  changeBlockStatusParams: ChangeBlockStatusParams
}

export type MutationChangeEmailArgs = {
  changeEmailParams: ChangeEmailParams
}

export type MutationChangeScreennameArgs = {
  changeScreennameParams: ChangeScreennameParams
}

export type MutationCreateAsrJobArgs = {
  createASRJobParams: CreateAsrJobParams
}

export type MutationCreateCollectionArgs = {
  createNoteCollectionParams: CreateNoteCollectionParams
}

export type MutationCreateCommentArgs = {
  createCommentParams: CreateCommentParams
}

export type MutationCreateExperimentArgs = {
  experimentParams: ExperimentParams
}

export type MutationCreateMagicLinkArgs = {
  createMagicLinkParams: CreateMagicLinkParams
}

export type MutationCreateOrganizationArgs = {
  createOrgParams: CreateOrgParams
}

export type MutationCreatePromoNotificationArgs = {
  promoNotificationParams: PromoNotificationParams
}

export type MutationCreateTrialSubscriptionArgs = {
  createTrialSubscriptionParams: CreateTrialSubscriptionParams
}

export type MutationCreateVppEmailDomainArgs = {
  createVPPEmailDomainParams: CreateVppEmailDomainParams
}

export type MutationDeleteCollectionArgs = {
  deleteNoteCollectionParams: DeleteNoteCollectionParams
}

export type MutationDeleteCommentArgs = {
  deleteCommentParams: DeleteCommentParams
}

export type MutationDeleteExperimentArgs = {
  deleteExperimentParams: DeleteExperimentParams
}

export type MutationDeleteGlobalOverrideValueArgs = {
  deleteGlobalOverrideValueParams: DeleteGlobalOverrideValueParams
}

export type MutationDeletePromoNotificationArgs = {
  deletePromoParams: DeletePromoParams
}

export type MutationDeleteUserCollabLibraryArgs = {
  collabDeleteLibraryParams: CollabDeleteLibraryParams
}

export type MutationDeleteVppEmailDomainArgs = {
  deleteVPPEmailDomainParams: DeleteVppEmailDomainParams
}

export type MutationDisableDevicesForSubscriptionsArgs = {
  disableDevicesForSubscriptionsParams: DisableDevicesForSubscriptionsParams
}

export type MutationEditExperimentArgs = {
  experimentParams: ExperimentParams
}

export type MutationEditNoteArgs = {
  editParams: EditParams
}

export type MutationEditPromoNotificationArgs = {
  promoNotificationParams: PromoNotificationParams
}

export type MutationEnableGalleryAccessArgs = {
  params: EnableGalleryAccessParams
}

export type MutationEnrollArgs = {
  userEnrollmentParams: UserEnrollmentParams
}

export type MutationFlagNoteArgs = {
  flagParams: FlagParams
}

export type MutationFlagNoteFamilyTreeArgs = {
  flagParams: FlagParams
}

export type MutationFlagProfileArgs = {
  flagProfileParams: FlagProfileParams
}

export type MutationFollowUserArgs = {
  followParams: FollowParams
}

export type MutationForceResetMigrationsArgs = {
  forceResetMigrationsRequest: ForceResetMigrationsRequest
}

export type MutationFreeNamespaceArgs = {
  freeNamespaceParams: FreeNamespaceParams
}

export type MutationGenerateCollabLinkTokenArgs = {
  generateCollabLinkParams: GenerateCollabLinkParams
}

export type MutationGenerateCollabTestDataForUserArgs = {
  collabTestDataParams: CollabTestDataParams
}

export type MutationGenerateSiteIdArgs = {
  generateSiteIdParams: GenerateSiteIdParams
}

export type MutationGenerateStudyMaterialsBatchArgs = {
  generateStudyMaterialsBatchParams: GenerateStudyMaterialsBatchParams
}

export type MutationGrantSubscriptionOverrideArgs = {
  grantSubscriptionOverrideParams: GrantSubscriptionOverrideParams
}

export type MutationHideCommentArgs = {
  hideCommentParams: HideCommentParams
}

export type MutationLikeNoteArgs = {
  likeParams: LikeParams
}

export type MutationLoginViaMagicLinkArgs = {
  magicLinkLoginParams: MagicLinkLoginParams
}

export type MutationMarkFeedAsViewedArgs = {
  markFeedAsViewedParams: MarkFeedAsViewedParams
}

export type MutationMarkNotificationsSeenArgs = {
  markNotificationsSeenParams: MarkNotificationsSeenParams
}

export type MutationModifyMetadataArgs = {
  modifyMetadataRequest: ModifyMetadataRequest
}

export type MutationModifyOrganizationArgs = {
  modifyOrgParams: ModifyOrgParams
}

export type MutationModifyOrganizationLicenseArgs = {
  modifyOrganizationLicenseParams: ModifyOrganizationLicenseParams
}

export type MutationModifyTrialExpirationArgs = {
  modifyTrialExpirationParams: ModifyTrialExpirationParams
}

export type MutationNoteViewedArgs = {
  viewedNote: ViewedNoteParameters
}

export type MutationPrepareMediaUploadArgs = {
  prepareMediaUploadParams: PrepareMediaUploadParams
}

export type MutationPreparePublishArgs = {
  publishParams: PublishParams
}

export type MutationProcessAppleReceiptArgs = {
  receiptParams: AppleReceiptParams
}

export type MutationProcessVppReceiptArgs = {
  vppReceiptParams: VppReceiptParams
}

export type MutationRemoveAppSettingArgs = {
  removeAppSettingParams: RemoveAppSettingParams
}

export type MutationRemoveExperimentEnrollmentOverrideArgs = {
  removeExperimentEnrollmentOverrideParams: RemoveExperimentEnrollmentOverrideParams
}

export type MutationRemoveNoteFromCollectionArgs = {
  removeNoteFromCollectionParams: RemoveNoteFromCollectionParams
}

export type MutationRemoveUserSurveyResponseKeysArgs = {
  removeUserSurveyResponseKeysParams: RemoveUserSurveyResponseKeysParams
}

export type MutationRenameUserArgs = {
  renameUserParams: RenameUserParams
}

export type MutationReorderNoteCollectionNoteArgs = {
  reorderNoteCollectionNoteParams: ReorderNoteCollectionNoteParams
}

export type MutationReportCommentArgs = {
  reportCommentParams: ReportCommentParams
}

export type MutationReprocessAsrJobArgs = {
  reprocessASRJobParams: ReprocessAsrJobParams
}

export type MutationResetOrganizationSeatUsageArgs = {
  resetOrganizationSeatUsageParams: ResetOrganizationSeatUsageParams
}

export type MutationRestoreOrganizationArgs = {
  restoreOrganizationParams: RestoreOrganizationParams
}

export type MutationReviewFlaggedProfileArgs = {
  reviewFlaggedProfileParams: ReviewFlaggedProfileParam
}

export type MutationReviewOrganizationArgs = {
  reviewOrganizationParams: ReviewOrganizationParams
}

export type MutationRevokeCollabLinkArgs = {
  revokeCollabLinkParams: RevokeCollabLinkParams
}

export type MutationSetAppSettingArgs = {
  setAppSettingParams: SetAppSettingParams
}

export type MutationSetCollegeAndMajorArgs = {
  setCollegeAndMajorParams: SetCollegeAndMajorParams
}

export type MutationSetGalleryDegradedArgs = {
  degradedStateParams: DegradedStateParams
}

export type MutationSetGlobalOverrideValueArgs = {
  setGlobalOverrideValueParams: SetGlobalOverrideValueParams
}

export type MutationSetIgnoreFlagsArgs = {
  setIgnoreFlagsParams: SetIgnoreFlagsParams
}

export type MutationSetLanguageArgs = {
  languageParams: SetLanguageParams
}

export type MutationSetLicenseEnforcementArgs = {
  setLicenseEnforcementParams: SetLicenseEnforcementParams
}

export type MutationSetLicenseEnforcementExpirationArgs = {
  setLicenseEnforcementExpirationParams: SetLicenseEnforcementExpirationParams
}

export type MutationSetMigratingDeviceArgs = {
  setMigratingDeviceRequest: SetMigratingDeviceRequest
}

export type MutationSetPromoAsDraftArgs = {
  promoDraftParams: PromoDraftParams
}

export type MutationSetUserSurveyResponseArgs = {
  setUserSurveyResponseParams: SetUserSurveyResponseParams
}

export type MutationStopSharingArgs = {
  stopParams: StopParams
}

export type MutationToggleDeviceLimitEnforcementArgs = {
  toggleDeviceLimitEnforcementParams: ToggleDeviceLimitEnforcementParams
}

export type MutationTriageNoteArgs = {
  triageNoteParams: TriageNoteParams
}

export type MutationUnfollowUserArgs = {
  unfollowParams: UnfollowParams
}

export type MutationUnlikeNoteArgs = {
  unlikeParams: LikeParams
}

export type MutationUnlockUserAccountArgs = {
  unlockUserAccountParams: UnlockUserAccountParams
}

export type MutationUnpublishArgs = {
  unpublishParams: UnpublishParams
}

export type MutationUpdateBioArgs = {
  bioParams: BioParams
}

export type MutationUpdateCollectionArgs = {
  updateNoteCollectionParams: UpdateNoteCollectionParams
}

export type MutationUpdateCookiesArgs = {
  updateCookiesParams: UpdateCookiesParams
}

export type MutationUpdateExperimentDataArgs = {
  experimentDataParams: ExperimentDataParams
}

export type MutationUpdateProfileArgs = {
  profileParams: ProfileParams
}

export type MutationUpdateUserExperimentEnrollmentOverrideArgs = {
  experimentEnrollmentParams: ExperimentEnrollmentParams
}

export type MutationUpdateUserLanguageArgs = {
  updateUserLanguageParams: UpdateUserLanguageParams
}

export type MutationUploadArgs = {
  uploadParams: UploadParams
}

export type MutationVisitCollabLinkArgs = {
  visitCollabLinkParams: VisitCollabLinkParams
}

export type Note = {
  __typename?: 'Note'
  clientId: Scalars['String']
  clientModifiedDate: Scalars['DateTime']
  createdDate: Scalars['DateTime']
  id: Scalars['String']
  lastUpdateDate: Scalars['DateTime']
  name: Scalars['String']
  noteUploadedAt?: Maybe<Scalars['DateTime']>
  pdfUploadedAt?: Maybe<Scalars['DateTime']>
  /** @deprecated No longer used */
  updatedDate: Scalars['DateTime']
  url: Scalars['String']
}

export type NoteCollection = {
  __typename?: 'NoteCollection'
  id: Scalars['String']
  isFeatured: Scalars['Boolean']
  isOfficialContent: Scalars['Boolean']
  name: Scalars['String']
  notes: Array<GalleryNote>
  owner: User
}

export type NoteCollectionListResults = {
  __typename?: 'NoteCollectionListResults'
  results: Array<NoteCollection>
  totalCount: Scalars['Float']
}

export type NoteCollectionNotesParams = {
  id: Scalars['String']
  limit?: Maybe<Scalars['Float']>
  offset?: Maybe<Scalars['Float']>
}

export type NoteCollectionParams = {
  collectionId: Scalars['String']
}

export type NoteCollectionWithCount = {
  __typename?: 'NoteCollectionWithCount'
  collection: NoteCollection
  totalCount: Scalars['Float']
}

export type NoteMediaInsertion = {
  __typename?: 'NoteMediaInsertion'
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  insertionOpLogicalTime: Scalars['Float']
  insertionOpSiteId: Scalars['Float']
  mediaExtension?: Maybe<Scalars['String']>
  mediaType?: Maybe<Scalars['String']>
  mediaUpload: MediaUploadStatus
  note: CollabNoteMetadata
  updatedAt?: Maybe<Scalars['DateTime']>
}

export type NoteRenderData = {
  __typename?: 'NoteRenderData'
  data: Scalars['String']
}

export type NoteRendererParams = {
  noteId: Scalars['String']
}

export {NoteSortingKey}

export type NoteV2 = {
  __typename?: 'NoteV2'
  createdAt: Scalars['Timestamp']
  deletedAt?: Maybe<Scalars['Timestamp']>
  hasRecordings: Scalars['Boolean']
  id: Scalars['String']
  isFavorited: Scalars['Boolean']
  lastOpened?: Maybe<Scalars['Timestamp']>
  legacyNoteId?: Maybe<Scalars['String']>
  linkShareSettings: LinkShareSettings
  mostRecentOpTime?: Maybe<Scalars['Timestamp']>
  subjectId?: Maybe<Scalars['String']>
  thumbnailOp?: Maybe<OpId>
  thumbnailUrl?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
  titleOp?: Maybe<OpId>
  updatedAt: Scalars['Timestamp']
  userPermission: UserPermission
}

export type Notification = {
  __typename?: 'Notification'
  comment?: Maybe<Comment>
  createdAt: Scalars['DateTime']
  eventCount: Scalars['Float']
  galleryNote?: Maybe<GalleryNote>
  id: Scalars['ID']
  lastNotificationActionAt: Scalars['DateTime']
  notificationEvents: Array<NotificationEvent>
  promoNotification?: Maybe<PromoNotification>
  recipient: User
  seen: Scalars['Boolean']
  type: NotificationType
}

export type NotificationEvent = {
  __typename?: 'NotificationEvent'
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  notification: Notification
  triggeringUser?: Maybe<User>
}

export {NotificationType}

export type OfficialCollectionNotesParams = {
  limit?: Maybe<Scalars['Float']>
  officialId: Scalars['String']
  offset?: Maybe<Scalars['Float']>
}

export type OpId = {
  __typename?: 'OpId'
  siteId: Scalars['Int']
  timestamp: Scalars['Int']
}

export type Organization = {
  __typename?: 'Organization'
  approved: Scalars['Boolean']
  approvedAt?: Maybe<Scalars['DateTime']>
  comments?: Maybe<Scalars['String']>
  contractAcceptedAt?: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  deletedAt?: Maybe<Scalars['DateTime']>
  educationLevelsProvided: Array<EducationLevel>
  id: Scalars['String']
  industry?: Maybe<Scalars['String']>
  isAsmEnrolled: Scalars['Boolean']
  license?: Maybe<OrganizationLicense>
  mdmPlatform?: Maybe<Scalars['String']>
  name: Scalars['String']
  organizationType: OrganizationType
  rejectionReason?: Maybe<Scalars['String']>
  sentLicenseReminderEmailAt?: Maybe<Scalars['DateTime']>
  stripeCustomerId?: Maybe<Scalars['String']>
  subscription?: Maybe<OrganizationSubscription>
  termsAcceptedAt?: Maybe<Scalars['DateTime']>
  updatedAt?: Maybe<Scalars['DateTime']>
  userMappings: Array<OrganizationUser>
}

export type OrganizationAdminDetails = {
  __typename?: 'OrganizationAdminDetails'
  approved: Scalars['Boolean']
  email: Scalars['String']
  jobTitle?: Maybe<Scalars['String']>
  licenseKey?: Maybe<Scalars['String']>
  maxSeats: Scalars['Int']
  mdmPlatform?: Maybe<Scalars['String']>
  name?: Maybe<Scalars['String']>
  organizationDeletedAt?: Maybe<Scalars['DateTime']>
  organizationId: Scalars['String']
  organizationName: Scalars['String']
  organizationStatus: OrganizationStatus
  organizationType: Scalars['String']
  phone?: Maybe<Scalars['String']>
  subscriptionStatus?: Maybe<Scalars['String']>
  usedSeats: Scalars['Int']
}

export type OrganizationAdminQueryParams = {
  userId: Scalars['String']
}

export type OrganizationAdminSummary = {
  __typename?: 'OrganizationAdminSummary'
  email: Scalars['String']
  jobTitle?: Maybe<Scalars['String']>
  name?: Maybe<Scalars['String']>
  phone?: Maybe<Scalars['String']>
  userId: Scalars['String']
}

export type OrganizationDetails = {
  __typename?: 'OrganizationDetails'
  adminCreatorEmail?: Maybe<Scalars['String']>
  admins: Array<OrganizationAdminSummary>
  approved: Scalars['Boolean']
  approvedAt?: Maybe<Scalars['Timestamp']>
  contractAcceptedAt?: Maybe<Scalars['Timestamp']>
  createdAt: Scalars['Timestamp']
  deletedAt?: Maybe<Scalars['DateTime']>
  educationLevelsProvided: Array<EducationLevel>
  id: Scalars['String']
  industry?: Maybe<Scalars['String']>
  licenseKey?: Maybe<Scalars['String']>
  maxSeats: Scalars['Int']
  mdmPlatform?: Maybe<Scalars['String']>
  organizationName: Scalars['String']
  organizationType: Scalars['String']
  owner: OrganizationAdminSummary
  sentLicenseReminderEmailAt?: Maybe<Scalars['Timestamp']>
  status: OrganizationStatus
  subscriptionStatus: OrganizationSubscriptionStatus
  termsAcceptedAt?: Maybe<Scalars['Timestamp']>
  usedSeats: Scalars['Int']
}

export type OrganizationEmailEvents = {
  __typename?: 'OrganizationEmailEvents'
  count: Scalars['Float']
  events: Array<SendGridEvent>
}

export type OrganizationLicense = {
  __typename?: 'OrganizationLicense'
  createdAt: Scalars['DateTime']
  expiration: Scalars['DateTime']
  id: Scalars['String']
  maxSeats: Scalars['Float']
  organization: Organization
  updatedAt: Scalars['DateTime']
  usedSeats: Scalars['Float']
}

export enum OrganizationRole {
  Admin = 'ADMIN',
  Member = 'MEMBER',
  Owner = 'OWNER'
}

export enum OrganizationStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type OrganizationSubscription = {
  __typename?: 'OrganizationSubscription'
  canceledAt?: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  endedAt?: Maybe<Scalars['DateTime']>
  id: Scalars['ID']
  organization: Organization
  status: StripeSubscriptionStatus
  stripePriceId: Scalars['String']
  stripeProductId: Scalars['String']
  stripeSubscriptionId: Scalars['String']
  trialEndedAt?: Maybe<Scalars['DateTime']>
  updatedAt: Scalars['DateTime']
}

export enum OrganizationSubscriptionStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Expired = 'EXPIRED',
  None = 'NONE',
  Pending = 'PENDING',
  Refunded = 'REFUNDED'
}

export enum OrganizationType {
  B2B = 'B2B',
  Edu = 'EDU'
}

export type OrganizationUser = {
  __typename?: 'OrganizationUser'
  createdAt: Scalars['DateTime']
  /** @deprecated Use User.name instead */
  fullName?: Maybe<Scalars['String']>
  jobTitle?: Maybe<Scalars['String']>
  organization: Organization
  phone?: Maybe<Scalars['String']>
  role: OrganizationRole
  user: User
}

export type Organizer = {
  __typename?: 'Organizer'
  createdAt: Scalars['DateTime']
  id: Scalars['String']
  noteMetadatas: Array<CollabNoteMetadata>
  organizerType: OrganizerTypeKey
  parent?: Maybe<Organizer>
  parentId?: Maybe<Scalars['String']>
  siblingOrder: Scalars['Float']
  title: Scalars['String']
  updatedAt: Scalars['DateTime']
  user: User
}

export type OrganizerMutationResult = {
  __typename?: 'OrganizerMutationResult'
  appSettings?: Maybe<Scalars['JSONObject']>
  errorCode?: Maybe<Scalars['Float']>
  notes: Array<CollabNoteUserMetadata>
  organizers: Array<OrganizerType>
  success: Scalars['Boolean']
}

export type OrganizerType = Divider | Subject

export enum OrganizerTypeKey {
  Divider = 'DIVIDER',
  Subject = 'SUBJECT'
}

export type OrganizerV2 = {
  __typename?: 'OrganizerV2'
  id: Scalars['String']
  organizerType: OrganizerTypeKey
  parentId?: Maybe<Scalars['String']>
  siblingOrder: Scalars['Float']
  /** exists for Subjects only */
  subjectEmoji?: Maybe<Scalars['String']>
  /** exists for Subjects only */
  subjectHexColor?: Maybe<Scalars['String']>
  /** exists for Subjects only */
  subjectIsLocked?: Maybe<Scalars['Boolean']>
  title: Scalars['String']
  updatedAt: Scalars['Timestamp']
}

export type PagingParams = {
  limit?: Maybe<Scalars['Float']>
  offset?: Maybe<Scalars['Float']>
}

export type ParentNoteParams = {
  ancestorNoteIds: Array<Scalars['String']>
}

export type PermanentlyDeleteNote = {
  noteId: Scalars['String']
}

export type PermissionChange = {
  /** null to revoke permission */
  accessLevel?: Maybe<AccessLevel>
  userId: Scalars['String']
}

export enum PermissionScope {
  Public = 'PUBLIC',
  Restricted = 'RESTRICTED'
}

export type PermissionedUser = {
  __typename?: 'PermissionedUser'
  accessLevel: CollabNoteRole
  userId: Scalars['String']
}

export type PrepareMediaUploadParams = {
  md5Hash: Scalars['String']
  sha512Hash: Scalars['String']
  sizeInBytes: Scalars['Float']
}

export type PrepareMediaUploadResult = {
  __typename?: 'PrepareMediaUploadResult'
  mediaUploadSignedUrl?: Maybe<Scalars['String']>
  uploadStatus: Scalars['String']
}

export type ProfileParams = {
  name?: Maybe<Scalars['String']>
  screenname: Scalars['String']
}

export enum ProfileSection {
  Avatar = 'AVATAR',
  Description = 'DESCRIPTION',
  Multiple = 'MULTIPLE',
  SocialLinks = 'SOCIAL_LINKS'
}

export type PromoDraftParams = {
  id: Scalars['String']
  isDraft: Scalars['Boolean']
}

export type PromoNotification = {
  __typename?: 'PromoNotification'
  author: User
  endDate: Scalars['DateTime']
  href: Scalars['String']
  id: Scalars['ID']
  isDraft: Scalars['Boolean']
  notifications: Array<Notification>
  startDate: Scalars['DateTime']
  translationKey: Scalars['String']
}

export type PromoNotificationParams = {
  endDate: Scalars['DateTime']
  href: Scalars['String']
  id?: Maybe<Scalars['String']>
  startDate: Scalars['DateTime']
  translationKey: Scalars['String']
}

export type PublishParams = {
  audioDurationSeconds: Scalars['Float']
  categoryId?: Maybe<Scalars['String']>
  clientNoteId: Scalars['String']
  containsMedia?: Maybe<Scalars['Boolean']>
  containsPencil?: Maybe<Scalars['Boolean']>
  containsStudyTape?: Maybe<Scalars['Boolean']>
  contentType?: Maybe<Scalars['String']>
  description: Scalars['String']
  language?: Maybe<Scalars['String']>
  noteName: Scalars['String']
  pageCount: Scalars['Float']
  parentNoteId?: Maybe<Scalars['String']>
  previewCount: Scalars['Float']
  searchIndexes?: Maybe<SearchIndexParams>
  serverPublishId?: Maybe<Scalars['String']>
  tags: Array<Scalars['String']>
}

export type PublishResult = {
  __typename?: 'PublishResult'
  galleryNote: GalleryNote
  imageUploadPolicies: Array<Scalars['String']>
  noteUploadPolicy: Scalars['String']
  pdfUploadPolicy: Scalars['String']
}

export type Query = {
  __typename?: 'Query'
  adminFuzzyUserSearch: Array<Scalars['String']>
  adminGalleryNoteSearch: Array<GalleryNote>
  adminGetCurrentLearnUsage: AdminLearnQuotaResponse
  adminGetUserData: User
  batchGetUserSurveyResponses: Array<UserSurveyResponse>
  /** @deprecated enrollment limits are lifted */
  checkEnrollmentAvailability: EnrollmentLimits
  followedGalleryNoteSearch: Array<GalleryNote>
  galleryNoteSearch: Array<GalleryNote>
  getASRJob: AsrJobResult
  getAllCategories: Array<Category>
  getAllComments: Array<Comment>
  getAllOrganizations: AllOrganizationResults
  getAllPermissionedUsersForNote: AllPermissionedUsersForNoteResponse
  getAllSubscriptionInfo: SubscriptionInfo
  getAllSubscriptionsOverDeviceLimit: Array<GetAllSubscriptionsOverDeviceLimitResult>
  getBuildMetadata: GetBuildMetadataResult
  getChatAnswer: ExchangeResponse
  getChatHistory: Array<StudyChatMessage>
  getCollatedFlaggedNoteInfo: Array<GetCollatedFlaggedNoteInfoResult>
  getCollegeMajors: Array<CollegeMajor>
  getCurrentASRProcessorVersion: AsrProcessorVersion
  getCurrentQuotaUsage: QuotaUsage
  getExperimentEnrollmentOverrides: Array<ExperimentEnrollment>
  getFavoriteNotes: Array<CollabNoteMetadata>
  getFeatureFlagsForUser: Array<Scalars['String']>
  getFeaturedCollections: Array<NoteCollection>
  getFeaturedCollectionsAndNotes: Array<NoteCollectionWithCount>
  getFeaturedNotes: GalleryNoteResults
  getFuzzyScreennameMatches: Array<Scalars['String']>
  getInstitutions: GetInstitutionsResult
  getLearnQuotaUsage: LearnQuotaUsage
  getNoteCollection?: Maybe<NoteCollection>
  getNoteCollectionsForUser: NoteCollectionListResults
  getNoteRendererData?: Maybe<NoteRenderData>
  getNoteRootComments: Array<Comment>
  getNotes: Array<GalleryNote>
  getNotesForCollection: GalleryNoteResults
  getNotesForOfficialCollection: GalleryNoteResults
  getNotifications: Array<Notification>
  getOfficialNoteCollections: NoteCollectionListResults
  getOrganization: OrganizationDetails
  /** @deprecated Use getOrganization.owner field resolver */
  getOrganizationAdmin: OrganizationAdminDetails
  getOrganizationsAwaitingApproval: Array<Organization>
  getParentNote?: Maybe<GalleryNote>
  getPublishersFollowedByUser: Array<User>
  getQuestionableNoteContent: Array<SearchIndexFlagInfo>
  getQuizJobContent?: Maybe<Scalars['String']>
  getRecentCollabNotes: Array<CollabNoteMetadata>
  getSendGridEvents: OrganizationEmailEvents
  getSiteUserMappings: Array<SiteUserMapping>
  getStripeCustomerPortal: StripeCustomerPortal
  getStudyMaterialsBatch: StudyMaterialsBatch
  getSubscriptionInfoForUser: UserSubscriptionResult
  getSummaryJobContent?: Maybe<Scalars['String']>
  getTopTags: Array<TopTag>
  getTranslationMappings: Array<TranslationMapping>
  getUserAdminEvents: Array<UserAdminEvent>
  getUserIsFollowed: FollowPair
  getUserLikesNotes: Array<LikedNotePair>
  getUserNoteAdminEvents: Array<GalleryNoteAdminEvent>
  getUserSharedNotes: Array<Note>
  getUserSubscriptionInfo?: Maybe<UserSubscriptionResult>
  getUserSurveyResponse: UserSurveyResponse
  getUserTrialSubscription?: Maybe<TrialSubscription>
  getUsersFollowingPublisher: Array<User>
  getUsersWhoLikedNote: Array<User>
  getVPPEmailDomains: Array<VppAllowlistEmail>
  getViableSubscription?: Maybe<AppStoreSubscription>
  getWorldColleges: Array<College>
  hiddenProfiles: HiddenProfilesResults
  /** @deprecated Use user.isOrganizationOwner */
  isCurrentUserOrganizationAdmin: Scalars['Boolean']
  llmAddStyle: LlmTextTransformation
  llmIsCorrectAnswer: LlmTextTransformation
  llmMakeRhyme: LlmTextTransformation
  login: User
  me: User
  newFollowingNotesAvailable: Scalars['Boolean']
  /** @deprecated Deprecated by the User.library field resolver */
  retrieveMetadataLibrary: LibraryState
  triageNoteSearch: TriageSearchResults
  userDownloadedNotes: Array<GalleryNote>
  userFavoritedNotes: Array<GalleryNote>
  userNotes: Array<GalleryNote>
}

export type QueryAdminFuzzyUserSearchArgs = {
  adminFuzzyUserSearchParams: AdminFuzzyUserSearchParams
}

export type QueryAdminGalleryNoteSearchArgs = {
  searchParams: SearchParams
}

export type QueryAdminGetCurrentLearnUsageArgs = {
  adminGetCurrentLearnUsageParams: AdminGetCurrentLearnUsageParams
}

export type QueryAdminGetUserDataArgs = {
  adminGetUserDataParams: AdminGetUserDataParams
}

export type QueryBatchGetUserSurveyResponsesArgs = {
  batchGetUserSurveyResponsesParams: BatchGetUserSurveyResponsesParams
}

export type QueryCheckEnrollmentAvailabilityArgs = {
  params: CheckEnrollmentAvailabilityParams
}

export type QueryFollowedGalleryNoteSearchArgs = {
  followedNoteSearchParams: SearchParams
}

export type QueryGalleryNoteSearchArgs = {
  searchParams: SearchParams
}

export type QueryGetAsrJobArgs = {
  getASRJobParams: GetAsrJobParams
}

export type QueryGetAllCommentsArgs = {
  getAllCommentsParams: GetAllCommentsParams
}

export type QueryGetAllOrganizationsArgs = {
  getAllOrganizationsParams?: Maybe<GetAllOrganizationsParams>
}

export type QueryGetAllPermissionedUsersForNoteArgs = {
  allPermissionedUsersForNoteRequest: AllPermissionedUsersForNoteRequest
}

export type QueryGetAllSubscriptionInfoArgs = {
  getAllSubscriptionInfoParams: GetAllSubscriptionInfoParams
}

export type QueryGetAllSubscriptionsOverDeviceLimitArgs = {
  getAllSubscriptionsOverDeviceLimitParams: GetAllSubscriptionsOverDeviceLimitParams
}

export type QueryGetBuildMetadataArgs = {
  getBuildMetadataParams: GetBuildMetadataParams
}

export type QueryGetChatAnswerArgs = {
  getChatAnswerParams: GetChatAnswerParams
}

export type QueryGetChatHistoryArgs = {
  getChatHistoryParams: GetChatHistoryParams
}

export type QueryGetCollatedFlaggedNoteInfoArgs = {
  getCollatedFlaggedNoteInfoParams: GetCollatedFlaggedNoteInfoParams
}

export type QueryGetCurrentQuotaUsageArgs = {
  getCurrentQuotaUsageParams: GetCurrentQuotaUsageParams
}

export type QueryGetExperimentEnrollmentOverridesArgs = {
  experimentEnrollmentOverrideQueryParams: ExperimentEnrollmentOverrideQueryParams
}

export type QueryGetFavoriteNotesArgs = {
  favoriteNotesParams: FavoriteNotesParams
}

export type QueryGetFeaturedCollectionsAndNotesArgs = {
  featuredCollectionsAndNotesParams: FeaturedCollectionsAndNotesParams
}

export type QueryGetFeaturedNotesArgs = {
  featuredNotesParams: PagingParams
}

export type QueryGetFuzzyScreennameMatchesArgs = {
  getFuzzyScreennameMatchesParams: GetFuzzyScreennameMatchesParams
}

export type QueryGetInstitutionsArgs = {
  getInstitutionsParams: GetInstitutionsParams
}

export type QueryGetLearnQuotaUsageArgs = {
  getLearnQuotaUsageParams: GetLearnQuotaUsageParams
}

export type QueryGetNoteCollectionArgs = {
  noteCollectionParams: NoteCollectionParams
}

export type QueryGetNoteCollectionsForUserArgs = {
  userNoteCollectionsParams: UserNoteCollectionsParams
}

export type QueryGetNoteRendererDataArgs = {
  noteRendererParams: NoteRendererParams
}

export type QueryGetNoteRootCommentsArgs = {
  getNoteRootCommentsParams: GetNoteRootCommentsParams
}

export type QueryGetNotesArgs = {
  getNotesParams: GetNotesParameters
}

export type QueryGetNotesForCollectionArgs = {
  noteCollectionNotesParams: NoteCollectionNotesParams
}

export type QueryGetNotesForOfficialCollectionArgs = {
  officialCollectionNotesParams: OfficialCollectionNotesParams
}

export type QueryGetNotificationsArgs = {
  getNotificationsParams: GetNotificationsParams
}

export type QueryGetOfficialNoteCollectionsArgs = {
  pagingParams: PagingParams
}

export type QueryGetOrganizationArgs = {
  getOrganizationParams: GetOrganizationParams
}

export type QueryGetOrganizationAdminArgs = {
  organizationAdminQueryParams: OrganizationAdminQueryParams
}

export type QueryGetParentNoteArgs = {
  parentNoteParams: ParentNoteParams
}

export type QueryGetPublishersFollowedByUserArgs = {
  followingUsersParameters: FollowingUsersParameters
}

export type QueryGetQuestionableNoteContentArgs = {
  questionableNoteContentParams: QuestionableNoteContentParams
}

export type QueryGetQuizJobContentArgs = {
  getQuizJobContentParams: GetQuizJobContentParams
}

export type QueryGetRecentCollabNotesArgs = {
  recentNotesParams: RecentNotesParams
}

export type QueryGetSendGridEventsArgs = {
  getSendGridEventsParams: GetSendGridEventsParams
}

export type QueryGetSiteUserMappingsArgs = {
  siteUserMappingQueryParams: SiteUserMappingQueryParams
}

export type QueryGetStripeCustomerPortalArgs = {
  getStripeCustomerPortalParams: GetStripeCustomerPortalParams
}

export type QueryGetStudyMaterialsBatchArgs = {
  getStudyMaterialsBatchParams: GetStudyMaterialsBatchParams
}

export type QueryGetSummaryJobContentArgs = {
  getSummaryJobContentParams: GetSummaryJobContentParams
}

export type QueryGetTopTagsArgs = {
  getTopTagsParams?: Maybe<GetTopTagParams>
}

export type QueryGetTranslationMappingsArgs = {
  translationMappingParams: TranslationMappingParams
}

export type QueryGetUserAdminEventsArgs = {
  adminEventSearchParams: AdminEventSearchParams
}

export type QueryGetUserIsFollowedArgs = {
  getUserIsFollowedParams: GetUserIsFollowedParams
}

export type QueryGetUserLikesNotesArgs = {
  userLikesNotesParameters: UserLikesNotesParameters
}

export type QueryGetUserNoteAdminEventsArgs = {
  adminEventSearchParams: AdminEventSearchParams
}

export type QueryGetUserSharedNotesArgs = {
  getUserSharedNotesParams: GetUserSharedNotesParams
}

export type QueryGetUserSubscriptionInfoArgs = {
  getSubscriptionInfoParams: GetSubscriptionInfoParams
}

export type QueryGetUserTrialSubscriptionArgs = {
  getUserTrialSubscriptionParams: GetUserTrialSubscriptionParams
}

export type QueryGetUsersFollowingPublisherArgs = {
  followingUsersParameters: FollowingUsersParameters
}

export type QueryGetUsersWhoLikedNoteArgs = {
  likingUsersParameters: LikingUsersParameters
}

export type QueryGetVppEmailDomainsArgs = {
  getVPPEmailDomainParams: GetVppEmailDomainParams
}

export type QueryGetViableSubscriptionArgs = {
  getViableSubscriptionParams: GetViableSubscriptionParams
}

export type QueryHiddenProfilesArgs = {
  hiddenProfilesParams: HiddenProfilesParams
}

export type QueryLlmAddStyleArgs = {
  llmAddStyleParams: LlmAddStyleParams
}

export type QueryLlmIsCorrectAnswerArgs = {
  llmIsCorrectAnswerParams: LlmIsCorrectAnswerParams
}

export type QueryLlmMakeRhymeArgs = {
  llmMakeRhymeParams: LlmMakeRhymeParams
}

export type QueryLoginArgs = {
  loginParams: LoginParams
}

export type QueryMeArgs = {
  authParams?: Maybe<AuthParams>
}

export type QueryRetrieveMetadataLibraryArgs = {
  metadataLibraryRequest: MetadataLibraryRequest
}

export type QueryTriageNoteSearchArgs = {
  triageSearchParams: TriageSearchParams
}

export type QueryUserDownloadedNotesArgs = {
  userNotesParams: UserNotesParameters
}

export type QueryUserFavoritedNotesArgs = {
  userNotesParams: UserFavoritedNotesParameters
}

export type QueryUserNotesArgs = {
  userNotesParams: UserNotesParameters
}

export type QuestionableNoteContentParams = {
  noteId: Scalars['String']
}

export type QuizJob = {
  __typename?: 'QuizJob'
  cacheCreationInputTokensUsed: Scalars['Float']
  cacheReadInputTokensUsed: Scalars['Float']
  createdAt: Scalars['DateTime']
  deletedAt?: Maybe<Scalars['DateTime']>
  errorReason?: Maybe<LearnErrorReason>
  id: Scalars['String']
  inputTokensUsed: Scalars['Float']
  numQuestions?: Maybe<Scalars['Int']>
  outputTokensUsed: Scalars['Float']
  promptKey?: Maybe<Scalars['String']>
  status: QuizJobStatus
  studyMaterialsBatch?: Maybe<StudyMaterialsBatch>
  studyMaterialsBatchId: Scalars['String']
  subscriber?: Maybe<Subscriber>
  type: QuizJobType
  updatedAt: Scalars['DateTime']
}

export enum QuizJobStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  New = 'NEW',
  Processing = 'PROCESSING'
}

export enum QuizJobType {
  Flashcard = 'FLASHCARD',
  Quiz = 'QUIZ'
}

export type QuotaUsage = {
  __typename?: 'QuotaUsage'
  exceeded: Scalars['Boolean']
  quotaUsage: Scalars['String']
  retryAfter?: Maybe<Scalars['String']>
}

export type RecentNotesParams = {
  numberToGet?: Maybe<Scalars['Float']>
}

export type RemoveAppSettingParams = {
  key: Scalars['String']
}

export type RemoveExperimentEnrollmentOverrideParams = {
  experimentId: Scalars['String']
  screenname: Scalars['String']
}

export type RemoveNoteFromCollectionParams = {
  id: Scalars['String']
  noteId: Scalars['String']
}

export type RemoveUserSurveyResponseKeysParams = {
  keys: Array<Scalars['String']>
}

export type RenameUserParams = {
  newName: Scalars['String']
  userId: Scalars['String']
}

export type ReorderNoteCollectionNoteParams = {
  beforeNoteId?: Maybe<Scalars['String']>
  id: Scalars['String']
  noteId: Scalars['String']
}

export type ReportCommentParams = {
  commentId: Scalars['String']
  flaggingReason: Scalars['String']
}

export type ReprocessAsrJobParams = {
  audioCreationDateMs: Scalars['Float']
  audioDurationMs?: Maybe<Scalars['Float']>
  deviceId?: Maybe<Scalars['String']>
  extension?: Maybe<Scalars['String']>
  generateStudyJobs?: Maybe<Scalars['Boolean']>
  language?: Maybe<Scalars['String']>
  recordingCount?: Maybe<Scalars['Int']>
  sha512Hash: Scalars['String']
  subscriptionId?: Maybe<Scalars['String']>
}

export type ResetOrganizationSeatUsageParams = {
  licenseKey: Scalars['String']
}

export type ResponseLibraryId = {
  __typename?: 'ResponseLibraryId'
  icloudUserId?: Maybe<Scalars['String']>
  serverUserId?: Maybe<Scalars['String']>
  type: LibraryType
  workspaceId?: Maybe<Scalars['String']>
}

export type RestoreOrganizationParams = {
  organizationId: Scalars['String']
}

export type ReviewFlaggedProfileParam = {
  notes: Scalars['String']
  outcome: Scalars['String']
  profileOwnerId: Scalars['String']
}

export type ReviewOrganizationParams = {
  expiration?: Maybe<Scalars['DateTime']>
  isApproved: Scalars['Boolean']
  maxSeats?: Maybe<Scalars['Int']>
  organizationId: Scalars['String']
  rejectionReason?: Maybe<Scalars['String']>
}

export type RevokeCollabLinkParams = {
  token: Scalars['String']
}

export {SearchFilter}

export type SearchIndexFlagInfo = {
  __typename?: 'SearchIndexFlagInfo'
  content: Array<FlaggedContent>
  origin: Scalars['String']
  reason: Scalars['String']
}

export type SearchIndexParams = {
  handwritingIndex?: Maybe<Scalars['String']>
  imageIndex?: Maybe<Scalars['String']>
  pdfIndex?: Maybe<Scalars['String']>
  recordingIndex?: Maybe<Scalars['String']>
  textIndex?: Maybe<Scalars['String']>
}

export type SearchParams = {
  contentType?: Maybe<GalleryNoteContentType>
  filters?: Maybe<Array<SearchFilter>>
  followedToInclude?: Maybe<Array<Scalars['String']>>
  forUserInChina?: Maybe<Scalars['Boolean']>
  language?: Maybe<Scalars['String']>
  offset?: Maybe<Scalars['Float']>
  pageSize?: Maybe<Scalars['Float']>
  query?: Maybe<Scalars['String']>
  rootNoteId?: Maybe<Scalars['String']>
  screenname?: Maybe<Scalars['String']>
  searchType?: Maybe<Scalars['String']>
  sortingParam?: Maybe<NoteSortingKey>
  tags?: Maybe<Array<Scalars['String']>>
  trendingTimeframe?: Maybe<Scalars['Float']>
}

export type SendGridEvent = {
  __typename?: 'SendGridEvent'
  createdAt: Scalars['DateTime']
  email: Scalars['String']
  event: Scalars['JSONObject']
  id: Scalars['String']
}

export enum ServerMigrationErrorCode {
  MigratingDeviceExists = 'MigratingDeviceExists',
  ValidationError = 'ValidationError'
}

export type SetAppSettingParams = {
  key: Scalars['String']
  value?: Maybe<Scalars['String']>
}

export type SetCollegeAndMajorParams = {
  collegeId?: Maybe<Scalars['String']>
  educationLevel?: Maybe<EducationLevel>
  graduationYear?: Maybe<Scalars['Int']>
  majorCode?: Maybe<Scalars['Int']>
  useType?: Maybe<UserUseType>
}

export type SetGlobalOverrideValueParams = {
  key: Scalars['String']
  override: Scalars['String']
}

export type SetIgnoreFlagsParams = {
  ignoreFlags: Scalars['Boolean']
  userId: Scalars['ID']
}

export type SetLanguageParams = {
  id: Scalars['String']
  language?: Maybe<Scalars['String']>
}

export type SetLicenseEnforcementExpirationParams = {
  institutionId: Scalars['String']
  licenseEnforcementExpiration: Scalars['DateTime']
}

export type SetLicenseEnforcementParams = {
  institutionId: Scalars['String']
  licenseEnforcement: LicenseEnforcement
}

export type SetMigratingDeviceRequest = {
  controllingDeviceId: Scalars['String']
  controllingDeviceName: Scalars['String']
  id: Scalars['String']
  source: LibraryId
  startDate: Scalars['Timestamp']
  /** type should always be NotabilityServer */
  target: LibraryId
}

export type SetMigratingDeviceResponse = {
  __typename?: 'SetMigratingDeviceResponse'
  /** Null if success = true */
  errorCode?: Maybe<ServerMigrationErrorCode>
  /** Null if success = true */
  errorMessage?: Maybe<Scalars['String']>
  /** Null if success = false */
  migratingDevice?: Maybe<MigratingDevice>
  success: Scalars['Boolean']
}

export type SetUserSurveyResponseParams = {
  surveyFields: Array<UserSurveyFieldInput>
}

export type SimulateAsrQuotaParams = {
  simulateOverQuota: Scalars['Boolean']
}

export type SiteUserMapping = {
  __typename?: 'SiteUserMapping'
  siteIds: Array<Scalars['Int']>
  userId: Scalars['GqlUUID']
}

export type SiteUserMappingQueryParams = {
  noteId: Scalars['GqlUUID']
}

export type StopParams = {
  serverNoteId: Scalars['String']
}

export type StripeConsumerSubscription = {
  __typename?: 'StripeConsumerSubscription'
  cancelAt?: Maybe<Scalars['DateTime']>
  canceledAt?: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  endedAt?: Maybe<Scalars['DateTime']>
  id: Scalars['ID']
  isCanceled: Scalars['Boolean']
  isExpired: Scalars['Boolean']
  status: StripeSubscriptionStatus
  stripePriceId: Scalars['String']
  stripeProductId: Scalars['String']
  stripeSubscriptionId: Scalars['String']
  subscriptionRenewalDate?: Maybe<Scalars['DateTime']>
  tier: StripeConsumerSubscriptionTier
  trialEndedAt?: Maybe<Scalars['DateTime']>
  updatedAt: Scalars['DateTime']
  user: User
}

export enum StripeConsumerSubscriptionTier {
  Premium = 'premium',
  Pro = 'pro'
}

export type StripeCustomerPortal = {
  __typename?: 'StripeCustomerPortal'
  redirectUrl: Scalars['String']
  url: Scalars['String']
}

export enum StripeSubscriptionStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Incomplete = 'INCOMPLETE',
  IncompleteExpired = 'INCOMPLETE_EXPIRED',
  PastDue = 'PAST_DUE',
  Paused = 'PAUSED',
  Trialing = 'TRIALING',
  Unpaid = 'UNPAID'
}

export type StudyChatMessage = {
  __typename?: 'StudyChatMessage'
  content: Scalars['String']
  role: StudyChatMessageRole
  studyChatExchangeId: Scalars['String']
  timestamp: Scalars['DateTime']
}

export enum StudyChatMessageRole {
  Assistant = 'assistant',
  User = 'user'
}

export type StudyMaterial = {
  __typename?: 'StudyMaterial'
  contentHash: Scalars['String']
  createdAt: Scalars['DateTime']
  deletedAt?: Maybe<Scalars['DateTime']>
  id: Scalars['String']
  quizJob?: Maybe<QuizJob>
  source: StudyMaterialSource
  studyMaterialsBatch?: Maybe<StudyMaterialsBatch>
  studyMaterialsBatchId: Scalars['String']
  summaryJob?: Maybe<SummaryJob>
  updatedAt: Scalars['DateTime']
}

export enum StudyMaterialSource {
  NoteHandwriting = 'NOTE_HANDWRITING',
  NotePdf = 'NOTE_PDF',
  NoteText = 'NOTE_TEXT'
}

export type StudyMaterialsBatch = {
  __typename?: 'StudyMaterialsBatch'
  asrJobs?: Maybe<Array<AsrJob>>
  clientNoteId?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  deletedAt?: Maybe<Scalars['DateTime']>
  id: Scalars['String']
  language?: Maybe<Scalars['String']>
  promptGroup?: Maybe<Scalars['String']>
  quizJobs?: Maybe<Array<QuizJob>>
  studyMaterials?: Maybe<Array<StudyMaterial>>
  summaryOfSummaries?: Maybe<SummaryJob>
  updatedAt: Scalars['DateTime']
}

export type Subject = {
  __typename?: 'Subject'
  color: Scalars['String']
  createdAt: Scalars['DateTime']
  emoji?: Maybe<Scalars['String']>
  id: Scalars['String']
  locked: Scalars['Boolean']
  noteMetadatas: Array<CollabNoteMetadata>
  organizerType: OrganizerTypeKey
  parent?: Maybe<Organizer>
  parentId?: Maybe<Scalars['String']>
  siblingOrder: Scalars['Float']
  title: Scalars['String']
  updatedAt: Scalars['DateTime']
  user: User
}

export type Subscriber = {
  __typename?: 'Subscriber'
  appStoreSubscription?: Maybe<AppStoreSubscription>
  id: Scalars['String']
  user?: Maybe<User>
  userId: Scalars['String']
}

export type Subscription = {
  __typename?: 'Subscription'
  details: SubscriptionDetails
  expirationDate?: Maybe<Scalars['Timestamp']>
  gracePeriodEndDate?: Maybe<Scalars['Timestamp']>
  renewalDate?: Maybe<Scalars['Timestamp']>
  source: SubscriptionSource
  tier: SubscriptionTier
}

export type SubscriptionDetails =
  | AppStoreSubscription
  | StripeConsumerSubscription
  | SubscriptionOverride
  | TrialSubscription

export type SubscriptionInfo = {
  __typename?: 'SubscriptionInfo'
  bestSubscription?: Maybe<AppStoreSubscription>
  classicStatuses: Array<AppStoreClassicStatus>
  devices: Array<AppStoreSubscriptionDevice>
  overrides: Array<SubscriptionOverride>
  receipts: Array<AppStoreReceipt>
  subscriptions: Array<AppStoreSubscription>
  users: Array<User>
}

export type SubscriptionOverride = {
  __typename?: 'SubscriptionOverride'
  createdAt: Scalars['DateTime']
  createdBy?: Maybe<User>
  expirationDate: Scalars['DateTime']
  id: Scalars['String']
  overrideReason?: Maybe<Scalars['String']>
  overrideTier: SubscriptionTier
}

export type SubscriptionOverview = {
  __typename?: 'SubscriptionOverview'
  current?: Maybe<Subscription>
  prior?: Maybe<Subscription>
  tier: UserTier
}

export type SubscriptionResult = {
  __typename?: 'SubscriptionResult'
  error: Scalars['Int']
  isClassic: Scalars['Boolean']
  subscription?: Maybe<AppStoreSubscription>
}

/** Enum representing subscription sources */
export enum SubscriptionSource {
  AppStoreConsumer = 'AppStoreConsumer',
  CustomOverride = 'CustomOverride',
  CustomTrial = 'CustomTrial',
  StripeConsumer = 'StripeConsumer',
  StripeOrganization = 'StripeOrganization'
}

export enum SubscriptionTier {
  Legacy = 'legacy',
  Light = 'light',
  Premium = 'premium',
  Pro = 'pro',
  Starter = 'starter',
  Vpp = 'vpp'
}

export type SummaryJob = {
  __typename?: 'SummaryJob'
  cacheCreationInputTokensUsed: Scalars['Float']
  cacheReadInputTokensUsed: Scalars['Float']
  createdAt: Scalars['DateTime']
  deletedAt?: Maybe<Scalars['DateTime']>
  errorReason?: Maybe<LearnErrorReason>
  id: Scalars['String']
  inputTokensUsed: Scalars['Float']
  outputTokensUsed: Scalars['Float']
  promptKey?: Maybe<Scalars['String']>
  status: SummaryJobStatus
  studyMaterialsBatch?: Maybe<StudyMaterialsBatch>
  subscriber?: Maybe<Subscriber>
  updatedAt: Scalars['DateTime']
}

export enum SummaryJobStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  New = 'NEW',
  Processing = 'PROCESSING'
}

export type ToggleDeviceLimitEnforcementParams = {
  notes?: Maybe<Scalars['String']>
  originalTransactionId: Scalars['ID']
  setEnabled: Scalars['Boolean']
}

export type TopTag = {
  __typename?: 'TopTag'
  id: Scalars['String']
  name: Scalars['String']
  noteCount: Scalars['Float']
}

export type TranslationMapping = {
  __typename?: 'TranslationMapping'
  locale: Scalars['String']
  tKey: Scalars['String']
  text: Scalars['String']
}

export type TranslationMappingParams = {
  tKeys: Array<Scalars['String']>
}

export type TriageNoteParams = {
  adminNotes?: Maybe<Scalars['String']>
  noteId: Scalars['String']
  triageState: Scalars['String']
}

export type TriageResult = {
  __typename?: 'TriageResult'
  noteId: Scalars['String']
  notes?: Maybe<Scalars['String']>
  triageState: Scalars['String']
}

export type TriageSearchParams = {
  filter: Scalars['String']
  offset?: Maybe<Scalars['Float']>
  pageSize?: Maybe<Scalars['Float']>
}

export type TriageSearchResults = {
  __typename?: 'TriageSearchResults'
  results: Array<GalleryNote>
  totalCount: Scalars['Float']
}

export enum TriageState {
  Approved = 'APPROVED',
  AwaitingTriage = 'AWAITING_TRIAGE',
  Quarantined = 'QUARANTINED'
}

export type TrialSubscription = {
  __typename?: 'TrialSubscription'
  canceledAt?: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  daysRemainingOnTrial?: Maybe<Scalars['Float']>
  expirationDate: Scalars['DateTime']
  id: Scalars['ID']
  trialLengthInDays: Scalars['Float']
  updatedAt: Scalars['DateTime']
}

export type UndeleteNote = {
  noteId: Scalars['String']
}

export type UnfollowParams = {
  userIdToUnfollow: Scalars['String']
}

export type UnlockUserAccountParams = {
  userId: Scalars['String']
}

export type UnpublishParams = {
  serverPublishId: Scalars['String']
}

export type UpdateCookiesParams = {
  cookieStatus: Scalars['String']
}

export type UpdateNoteCollectionParams = {
  id: Scalars['String']
  isFeatured?: Maybe<Scalars['Boolean']>
  name: Scalars['String']
}

export type UpdateUserLanguageParams = {
  newLanguage: Scalars['String']
}

export type UploadParams = {
  clientModifiedDate: Scalars['String']
  clientNoteId: Scalars['String']
  noteName: Scalars['String']
  serverNoteId?: Maybe<Scalars['String']>
}

export type UploadResult = {
  __typename?: 'UploadResult'
  note: Note
  noteUploadPolicy: Scalars['String']
  pdfUploadPolicy: Scalars['String']
}

export type User = {
  __typename?: 'User'
  accountType: AccountType
  adminEvents?: Maybe<Array<UserAdminEvent>>
  authToken?: Maybe<Scalars['String']>
  baseSubscription?: Maybe<AppStoreSubscription>
  bestAvailableSubscription?: Maybe<AppStoreSubscription>
  classicStatus: Array<AppStoreClassicStatus>
  collections?: Maybe<Array<NoteCollection>>
  college?: Maybe<College>
  dismissGuidelines: Scalars['Boolean']
  educationLevel?: Maybe<EducationLevel>
  email: Scalars['String']
  emailVerifiedAt?: Maybe<Scalars['DateTime']>
  featureFlags: Array<Scalars['String']>
  following: Array<Following>
  followingMetadata?: Maybe<FollowingMetadata>
  galleryNotes: Array<GalleryNote>
  graduationYear?: Maybe<Scalars['Float']>
  id: Scalars['ID']
  isAdmin?: Maybe<Scalars['Boolean']>
  isBlocked: Scalars['Boolean']
  isEmailVerified: Scalars['Boolean']
  isLocked: Scalars['Boolean']
  isOrganizationOwner: Scalars['Boolean']
  legacyMigrations: Array<MigratingDevice>
  library: LibraryState
  major?: Maybe<CollegeMajor>
  name?: Maybe<Scalars['String']>
  newNotesAvailable: Scalars['Boolean']
  notes: Array<Note>
  notificationEvents: Array<NotificationEvent>
  notifications: Array<Notification>
  numComments: Scalars['Float']
  numHiddenComments: Scalars['Float']
  numNotificationsUnseen: Scalars['Float']
  profile?: Maybe<UserProfile>
  promoNotifications: Array<PromoNotification>
  settings?: Maybe<UserSettings>
  stripeConsumerSubscription?: Maybe<StripeConsumerSubscription>
  stripeCustomerId?: Maybe<Scalars['String']>
  subscriber?: Maybe<Subscriber>
  subscriptionOverrides: Array<SubscriptionOverride>
  subscriptionOverview: SubscriptionOverview
  subscriptions: Array<AppStoreSubscription>
  testEnrollments: Array<ExperimentEnrollment>
  trialSubscription?: Maybe<TrialSubscription>
  triggeredGalleryNoteAdminEvents?: Maybe<Array<GalleryNoteAdminEvent>>
  triggeredUserAdminEvents?: Maybe<Array<UserAdminEvent>>
  useType?: Maybe<UserUseType>
  userStatus: UserStatus
  verificationHash: Scalars['String']
}

export type UserLibraryArgs = {
  userLibraryRequest: UserLibraryRequest
}

export type UserAdminEvent = {
  __typename?: 'UserAdminEvent'
  createdAt: Scalars['DateTime']
  eventType: UsersAdminEventType
  id: Scalars['String']
  systemNotes?: Maybe<Scalars['String']>
  targetedUser?: Maybe<User>
  targetedUserEmail: Scalars['String']
  targetedUserScreenname?: Maybe<Scalars['String']>
  triggeringUser?: Maybe<User>
  triggeringUserEmail: Scalars['String']
  triggeringUserNotes?: Maybe<Scalars['String']>
}

export type UserEnrollmentParams = {
  email: Scalars['String']
  isFromWebApp?: Maybe<Scalars['Boolean']>
  name?: Maybe<Scalars['String']>
  password: Scalars['String']
  screenname?: Maybe<Scalars['String']>
  token?: Maybe<Scalars['String']>
}

export type UserFavoritedNotesParameters = {
  limit?: Maybe<Scalars['Float']>
  offset: Scalars['Float']
  screenname: Scalars['String']
}

export type UserLibraryRequest = {
  /** null to request a full state reset in the response */
  partialUpdateSequenceId?: Maybe<Scalars['Int']>
}

export type UserLikesNotesParameters = {
  noteIds: Array<Scalars['String']>
}

export type UserNoteCollectionsParams = {
  limit?: Maybe<Scalars['Float']>
  offset?: Maybe<Scalars['Float']>
  userId: Scalars['String']
}

export type UserNotesParameters = {
  limit: Scalars['Float']
  offset: Scalars['Float']
  screenname: Scalars['String']
}

export type UserPermission = {
  __typename?: 'UserPermission'
  ownerId: Scalars['String']
  /** true IFF explicitly permissioned from owner */
  sharedWithMe: Scalars['Boolean']
  userAccessLevel: AccessLevel
}

export type UserProfile = {
  __typename?: 'UserProfile'
  avatarUpdatedAt?: Maybe<Scalars['DateTime']>
  avatarUrl?: Maybe<Scalars['String']>
  bio?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  etsyUsername?: Maybe<Scalars['String']>
  id: Scalars['ID']
  ignoreFlagging: Scalars['Boolean']
  instagramUsername?: Maybe<Scalars['String']>
  screenname?: Maybe<Scalars['String']>
  tikTokUsername?: Maybe<Scalars['String']>
  twitterUsername?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
  user: User
  youtubeUrl?: Maybe<Scalars['String']>
}

export type UserSettings = {
  __typename?: 'UserSettings'
  appSettings?: Maybe<Scalars['JSONObject']>
  id: Scalars['ID']
  language?: Maybe<Scalars['String']>
  libraryCount: Scalars['Float']
  locale: Locale
  updatedAt: Scalars['DateTime']
  user: User
}

export enum UserStatus {
  Active = 'ACTIVE',
  PendingDeletion = 'PENDING_DELETION'
}

export type UserSubscriptionResult = {
  __typename?: 'UserSubscriptionResult'
  isClassicUser: Scalars['Boolean']
  subscriptionExpirationDate?: Maybe<Scalars['DateTime']>
  subscriptionRenewalDate?: Maybe<Scalars['DateTime']>
  subscriptionSource?: Maybe<Scalars['String']>
  subscriptionTier?: Maybe<Scalars['String']>
  trialExpirationDate?: Maybe<Scalars['DateTime']>
  trialLengthInDays?: Maybe<Scalars['Float']>
}

export type UserSurveyFieldInput = {
  key: Scalars['String']
  value?: Maybe<Scalars['String']>
}

export type UserSurveyFieldOutput = {
  __typename?: 'UserSurveyFieldOutput'
  key: Scalars['String']
  value?: Maybe<Scalars['String']>
}

export type UserSurveyResponse = {
  __typename?: 'UserSurveyResponse'
  surveyFields: Array<UserSurveyFieldOutput>
  userId: Scalars['String']
}

/** Enum representing all user tiers (basic and subscription) */
export enum UserTier {
  Classic = 'classic',
  Legacy = 'legacy',
  Light = 'light',
  Premium = 'premium',
  Pro = 'pro',
  Starter = 'starter',
  Vpp = 'vpp'
}

export enum UserUseType {
  Business = 'BUSINESS',
  Educator = 'EDUCATOR',
  Personal = 'PERSONAL',
  Student = 'STUDENT'
}

export {UsersAdminEventType}

export type VppAccountResult = {
  __typename?: 'VPPAccountResult'
  customerType: Scalars['String']
  error: Scalars['Int']
  institutionName?: Maybe<Scalars['String']>
  licenseEnforcement: LicenseEnforcement
  licenseEnforcementExpiration?: Maybe<Scalars['DateTime']>
  organizationId?: Maybe<Scalars['String']>
  organizationName?: Maybe<Scalars['String']>
  subscription?: Maybe<VppSubscription>
}

export type VppAllowlistEmail = {
  __typename?: 'VPPAllowlistEmail'
  createdAt: Scalars['DateTime']
  emailDomain: Scalars['String']
  id: Scalars['ID']
}

export type VppReceiptParams = {
  countryCode?: Maybe<Scalars['String']>
  deviceId?: Maybe<Scalars['String']>
  licenseKey?: Maybe<Scalars['String']>
  receipt: Scalars['String']
}

export type VppSubscription = {
  __typename?: 'VPPSubscription'
  active: Scalars['Boolean']
  expirationDate: Scalars['DateTime']
  productId: Scalars['String']
  tier: Scalars['String']
}

export type ViewedNoteParameters = {
  noteId: Scalars['String']
}

export type VisitCollabLinkParams = {
  token: Scalars['String']
}

export enum WhisperImplementation {
  Distil = 'DISTIL',
  Faster = 'FASTER',
  FasterBatched = 'FASTER_BATCHED'
}

export type Workspace = {
  __typename?: 'Workspace'
  id: Scalars['String']
  notes?: Maybe<Array<NoteV2>>
  organizers?: Maybe<Array<OrganizerV2>>
  title: Scalars['String']
  userPermission: UserPermission
}

export type GalleryNoteInfoFragment = {__typename?: 'GalleryNote'} & Pick<
  GalleryNote,
  | 'id'
  | 'name'
  | 'viewCount'
  | 'commentsEnabled'
  | 'previewCount'
  | 'description'
  | 'updatedAt'
  | 'createdAt'
  | 'triageState'
  | 'contentType'
  | 'parentNoteId'
  | 'rootNoteId'
  | 'likes'
  | 'remixCount'
  | 'clientId'
> & {
    user: {__typename?: 'User'} & Pick<User, 'id' | 'name'> & {
        profile?: Maybe<{__typename?: 'UserProfile'} & Pick<UserProfile, 'screenname' | 'avatarUpdatedAt'>>
      }
    tags?: Maybe<Array<{__typename?: 'GalleryNoteTag'} & Pick<GalleryNoteTag, 'name'>>>
  }

export type NoteCollectionInfoFragment = {__typename?: 'NoteCollection'} & Pick<
  NoteCollection,
  'id' | 'name' | 'isOfficialContent' | 'isFeatured'
>

export type CommentInfoFragment = {__typename?: 'Comment'} & Pick<Comment, 'id' | 'createdAt' | 'commentText'> & {
    parent?: Maybe<{__typename?: 'Comment'} & Pick<Comment, 'id'>>
    author: {__typename?: 'User'} & Pick<User, 'id'> & {
        profile?: Maybe<{__typename?: 'UserProfile'} & Pick<UserProfile, 'screenname' | 'avatarUrl'>>
      }
  }

export type PromoNotificationFragment = {__typename?: 'PromoNotification'} & Pick<
  PromoNotification,
  'id' | 'startDate' | 'endDate' | 'translationKey' | 'href' | 'isDraft'
> & {
    author: {__typename?: 'User'} & Pick<User, 'id' | 'name'> & {
        profile?: Maybe<{__typename?: 'UserProfile'} & Pick<UserProfile, 'screenname' | 'avatarUpdatedAt'>>
      }
  }

export type TestOverrideFragment = {__typename?: 'ExperimentEnrollment'} & Pick<
  ExperimentEnrollment,
  'inVariantGroup' | 'isOverride'
> & {
    user?: Maybe<
      {__typename?: 'User'} & {profile?: Maybe<{__typename?: 'UserProfile'} & Pick<UserProfile, 'screenname'>>}
    >
    experiment: {__typename?: 'Experiment'} & Pick<Experiment, 'id'>
  }

export type CreateCollectionMutationVariables = Exact<{
  createNoteCollectionParams: CreateNoteCollectionParams
}>

export type CreateCollectionMutation = {__typename?: 'Mutation'} & Pick<Mutation, 'createCollection'>

export type DeleteCollectionMutationVariables = Exact<{
  deleteNoteCollectionParams: DeleteNoteCollectionParams
}>

export type DeleteCollectionMutation = {__typename?: 'Mutation'} & Pick<Mutation, 'deleteCollection'>

export type AddNoteToCollectionMutationVariables = Exact<{
  addNoteToCollectionParams: AddNoteToCollectionParams
}>

export type AddNoteToCollectionMutation = {__typename?: 'Mutation'} & {
  addNoteToCollection: {__typename?: 'NoteCollection'} & NoteCollectionInfoFragment
}

export type ReorderNoteCollectionNoteMutationVariables = Exact<{
  reorderNoteCollectionNoteParams: ReorderNoteCollectionNoteParams
}>

export type ReorderNoteCollectionNoteMutation = {__typename?: 'Mutation'} & Pick<Mutation, 'reorderNoteCollectionNote'>

export type RemoveNoteFromCollectionMutationVariables = Exact<{
  removeNoteFromCollectionParams: RemoveNoteFromCollectionParams
}>

export type RemoveNoteFromCollectionMutation = {__typename?: 'Mutation'} & Pick<Mutation, 'removeNoteFromCollection'>

export type GetNoteCollectionQueryVariables = Exact<{
  noteCollectionParams: NoteCollectionParams
}>

export type GetNoteCollectionQuery = {__typename?: 'Query'} & {
  getNoteCollection?: Maybe<
    {__typename?: 'NoteCollection'} & Pick<NoteCollection, 'id' | 'name'> & {
        owner: {__typename?: 'User'} & Pick<User, 'name'> & {
            profile?: Maybe<{__typename?: 'UserProfile'} & Pick<UserProfile, 'screenname'>>
          }
      }
  >
}

export type GetOfficialNoteCollectionsQueryVariables = Exact<{
  pagingParams: PagingParams
}>

export type GetOfficialNoteCollectionsQuery = {__typename?: 'Query'} & {
  getOfficialNoteCollections: {__typename?: 'NoteCollectionListResults'} & Pick<
    NoteCollectionListResults,
    'totalCount'
  > & {results: Array<{__typename?: 'NoteCollection'} & Pick<NoteCollection, 'id' | 'name'>>}
}

export type GetNoteCollectionsForUserQueryVariables = Exact<{
  userNoteCollectionsParams: UserNoteCollectionsParams
}>

export type GetNoteCollectionsForUserQuery = {__typename?: 'Query'} & {
  getNoteCollectionsForUser: {__typename?: 'NoteCollectionListResults'} & Pick<
    NoteCollectionListResults,
    'totalCount'
  > & {results: Array<{__typename?: 'NoteCollection'} & Pick<NoteCollection, 'id' | 'name'>>}
}

export type UpdateCollectionMutationVariables = Exact<{
  updateNoteCollectionParams: UpdateNoteCollectionParams
}>

export type UpdateCollectionMutation = {__typename?: 'Mutation'} & {
  updateCollection: {__typename?: 'NoteCollection'} & NoteCollectionInfoFragment
}

export type GetNotesForCollectionQueryVariables = Exact<{
  noteCollectionNotesParams: NoteCollectionNotesParams
}>

export type GetNotesForCollectionQuery = {__typename?: 'Query'} & {
  getNotesForCollection: {__typename?: 'GalleryNoteResults'} & Pick<GalleryNoteResults, 'totalCount'> & {
      results: Array<{__typename?: 'GalleryNote'} & GalleryNoteInfoFragment>
    }
}

export type GetNotesForOfficialCollectionQueryVariables = Exact<{
  officialCollectionNotesParams: OfficialCollectionNotesParams
}>

export type GetNotesForOfficialCollectionQuery = {__typename?: 'Query'} & {
  getNotesForOfficialCollection: {__typename?: 'GalleryNoteResults'} & Pick<GalleryNoteResults, 'totalCount'> & {
      results: Array<{__typename?: 'GalleryNote'} & GalleryNoteInfoFragment>
    }
}

export type LikeNoteMutationVariables = Exact<{
  likeParams: LikeParams
}>

export type LikeNoteMutation = {__typename?: 'Mutation'} & {
  likeNote: {__typename?: 'GalleryNote'} & Pick<GalleryNote, 'id'>
}

export type FlagNoteMutationVariables = Exact<{
  flagParams: FlagParams
}>

export type FlagNoteMutation = {__typename?: 'Mutation'} & {
  flagNote: {__typename?: 'GalleryNote'} & Pick<GalleryNote, 'id'>
}

export type FlagNoteFamilyTreeMutationVariables = Exact<{
  flagParams: FlagParams
}>

export type FlagNoteFamilyTreeMutation = {__typename?: 'Mutation'} & {
  flagNoteFamilyTree: Array<{__typename?: 'GalleryNote'} & GalleryNoteInfoFragment>
}

export type GetNotesQueryVariables = Exact<{
  getNotesParams: GetNotesParameters
}>

export type GetNotesQuery = {__typename?: 'Query'} & {
  getNotes: Array<{__typename?: 'GalleryNote'} & GalleryNoteInfoFragment>
}

export type GetFeatureFlagsForUserQueryVariables = Exact<{[key: string]: never}>

export type GetFeatureFlagsForUserQuery = {__typename?: 'Query'} & Pick<Query, 'getFeatureFlagsForUser'>

export type MeQueryVariables = Exact<{[key: string]: never}>

export type MeQuery = {__typename?: 'Query'} & {
  me: {__typename?: 'User'} & Pick<User, 'id' | 'featureFlags'> & {
      profile?: Maybe<{__typename?: 'UserProfile'} & Pick<UserProfile, 'avatarUpdatedAt'>>
    }
}

export type UpdateProfileMutationVariables = Exact<{
  profileParams: ProfileParams
}>

export type UpdateProfileMutation = {__typename?: 'Mutation'} & {
  updateProfile: {__typename?: 'UserProfile'} & Pick<UserProfile, 'id' | 'screenname'>
}

export type FlagProfileMutationVariables = Exact<{
  flagProfileParams: FlagProfileParams
}>

export type FlagProfileMutation = {__typename?: 'Mutation'} & Pick<Mutation, 'flagProfile'>

export type ReviewFlaggedProfileMutationVariables = Exact<{
  reviewFlaggedProfileParams: ReviewFlaggedProfileParam
}>

export type ReviewFlaggedProfileMutation = {__typename?: 'Mutation'} & Pick<Mutation, 'reviewFlaggedProfile'>

export type FreeNamespaceMutationVariables = Exact<{
  freeNamespaceParams: FreeNamespaceParams
}>

export type FreeNamespaceMutation = {__typename?: 'Mutation'} & Pick<Mutation, 'freeNamespace'>

export type ReloadEnvironmentCacheMutationVariables = Exact<{[key: string]: never}>

export type ReloadEnvironmentCacheMutation = {__typename?: 'Mutation'} & Pick<Mutation, 'reloadEnvironmentCache'>

export type UpdateBioMutationVariables = Exact<{
  bioParams: BioParams
}>

export type UpdateBioMutation = {__typename?: 'Mutation'} & {
  updateBio: {__typename?: 'UserProfile'} & Pick<
    UserProfile,
    'id' | 'bio' | 'twitterUsername' | 'tikTokUsername' | 'instagramUsername' | 'youtubeUrl' | 'etsyUsername'
  >
}

export type CreateMagicLinkMutationVariables = Exact<{
  createMagicLinkParams: CreateMagicLinkParams
}>

export type CreateMagicLinkMutation = {__typename?: 'Mutation'} & Pick<Mutation, 'createMagicLink'>

export type GetUserNotesQueryVariables = Exact<{
  getNotesParams: UserNotesParameters
}>

export type GetUserNotesQuery = {__typename?: 'Query'} & {
  userNotes: Array<{__typename?: 'GalleryNote'} & GalleryNoteInfoFragment>
}

export type GetUserFavoritedNotesQueryVariables = Exact<{
  getNotesParams: UserFavoritedNotesParameters
}>

export type GetUserFavoritedNotesQuery = {__typename?: 'Query'} & {
  userFavoritedNotes: Array<{__typename?: 'GalleryNote'} & GalleryNoteInfoFragment>
}

export type GetUserDownloadedNotesQueryVariables = Exact<{
  getNotesParams: UserNotesParameters
}>

export type GetUserDownloadedNotesQuery = {__typename?: 'Query'} & {
  userDownloadedNotes: Array<{__typename?: 'GalleryNote'} & GalleryNoteInfoFragment>
}

export type EditNoteMutationVariables = Exact<{
  editNotesParams: EditParams
}>

export type EditNoteMutation = {__typename?: 'Mutation'} & {
  editNote: {__typename?: 'GalleryNote'} & Pick<
    GalleryNote,
    'id' | 'description' | 'language' | 'contentType' | 'name' | 'commentsEnabled'
  > & {
      tags?: Maybe<Array<{__typename?: 'GalleryNoteTag'} & Pick<GalleryNoteTag, 'name'>>>
      mentionedProfiles: Array<
        {__typename?: 'UserProfile'} & Pick<UserProfile, 'screenname' | 'avatarUpdatedAt'> & {
            user: {__typename?: 'User'} & Pick<User, 'id'>
          }
      >
    }
}

export type SetLanguageMutationVariables = Exact<{
  setLanguageParams: SetLanguageParams
}>

export type SetLanguageMutation = {__typename?: 'Mutation'} & {
  setLanguage: {__typename?: 'GalleryNote'} & Pick<GalleryNote, 'id' | 'language'>
}

export type GalleryNoteSearchQueryVariables = Exact<{
  searchParams: SearchParams
}>

export type GalleryNoteSearchQuery = {__typename?: 'Query'} & {
  galleryNoteSearch: Array<{__typename?: 'GalleryNote'} & Pick<GalleryNote, 'language'> & GalleryNoteInfoFragment>
}

export type TriageNoteMutationVariables = Exact<{
  triageNoteParams: TriageNoteParams
}>

export type TriageNoteMutation = {__typename?: 'Mutation'} & {
  triageNote: {__typename?: 'TriageResult'} & Pick<TriageResult, 'noteId' | 'triageState'>
}

export type TriageNoteSearchQueryVariables = Exact<{
  triageSearchParams: TriageSearchParams
}>

export type TriageNoteSearchQuery = {__typename?: 'Query'} & {
  triageNoteSearch: {__typename?: 'TriageSearchResults'} & Pick<TriageSearchResults, 'totalCount'> & {
      results: Array<{__typename?: 'GalleryNote'} & GalleryNoteInfoFragment>
    }
}

export type HiddenProfilesQueryVariables = Exact<{
  hiddenProfilesParams: HiddenProfilesParams
}>

export type HiddenProfilesQuery = {__typename?: 'Query'} & {
  hiddenProfiles: {__typename?: 'HiddenProfilesResults'} & Pick<HiddenProfilesResults, 'totalCount'> & {
      results: Array<
        {__typename?: 'UserProfile'} & Pick<UserProfile, 'id' | 'screenname'> & {
            user: {__typename?: 'User'} & Pick<User, 'id'> & {
                profile?: Maybe<{__typename?: 'UserProfile'} & Pick<UserProfile, 'screenname'>>
              }
          }
      >
    }
}

export type UnlikeNoteMutationVariables = Exact<{
  unlikeNoteParams: LikeParams
}>

export type UnlikeNoteMutation = {__typename?: 'Mutation'} & {
  unlikeNote: {__typename?: 'GalleryNote'} & Pick<GalleryNote, 'id'>
}

export type PreparePublishMutationVariables = Exact<{
  publishParams: PublishParams
}>

export type PreparePublishMutation = {__typename?: 'Mutation'} & {
  preparePublish: {__typename?: 'PublishResult'} & Pick<
    PublishResult,
    'noteUploadPolicy' | 'pdfUploadPolicy' | 'imageUploadPolicies'
  > & {galleryNote: {__typename?: 'GalleryNote'} & Pick<GalleryNote, 'id'>}
}

export type UnpublishMutationVariables = Exact<{
  unpublishParams: UnpublishParams
}>

export type UnpublishMutation = {__typename?: 'Mutation'} & Pick<Mutation, 'unpublish'>

export type NoteViewedMutationVariables = Exact<{
  viewedNoteParams: ViewedNoteParameters
}>

export type NoteViewedMutation = {__typename?: 'Mutation'} & Pick<Mutation, 'noteViewed'>

export type FollowUserMutationVariables = Exact<{
  followParams: FollowParams
}>

export type FollowUserMutation = {__typename?: 'Mutation'} & {
  followUser: {__typename?: 'FollowPair'} & Pick<FollowPair, 'followedId' | 'followerId' | 'isFollowing'>
}

export type UnfollowUserMutationVariables = Exact<{
  unfollowParams: UnfollowParams
}>

export type UnfollowUserMutation = {__typename?: 'Mutation'} & {
  unfollowUser: {__typename?: 'FollowPair'} & Pick<FollowPair, 'followedId' | 'followerId' | 'isFollowing'>
}

export type GetUserIsFollowedQueryVariables = Exact<{
  getUserIsFollowedParams: GetUserIsFollowedParams
}>

export type GetUserIsFollowedQuery = {__typename?: 'Query'} & {
  getUserIsFollowed: {__typename?: 'FollowPair'} & Pick<FollowPair, 'followedId' | 'followerId' | 'isFollowing'>
}

export type AdminGetUserDataQueryVariables = Exact<{
  adminGetUserDataParams: AdminGetUserDataParams
}>

export type AdminGetUserDataQuery = {__typename?: 'Query'} & {
  adminGetUserData: {__typename?: 'User'} & Pick<
    User,
    'id' | 'name' | 'email' | 'emailVerifiedAt' | 'isAdmin' | 'isBlocked' | 'numComments' | 'numHiddenComments'
  > & {
      bestAvailableSubscription?: Maybe<{__typename?: 'AppStoreSubscription'} & Pick<AppStoreSubscription, 'tier'>>
      baseSubscription?: Maybe<{__typename?: 'AppStoreSubscription'} & Pick<AppStoreSubscription, 'tier'>>
      subscriptions: Array<
        {__typename?: 'AppStoreSubscription'} & Pick<
          AppStoreSubscription,
          | 'originalTransactionId'
          | 'originalPurchaseDate'
          | 'productId'
          | 'expirationDate'
          | 'status'
          | 'isTrialPeriod'
          | 'isInIntroOfferPeriod'
          | 'refundedDate'
          | 'refundedReason'
          | 'deviceLimitEnforcementEnabled'
          | 'overDeviceLimit'
          | 'gracePeriodExpiresAt'
          | 'expirationIntent'
          | 'isInBillingRetryPeriod'
          | 'tier'
        >
      >
      subscriptionOverrides: Array<
        {__typename?: 'SubscriptionOverride'} & Pick<
          SubscriptionOverride,
          'id' | 'createdAt' | 'expirationDate' | 'overrideTier' | 'overrideReason'
        > & {createdBy?: Maybe<{__typename?: 'User'} & Pick<User, 'email'>>}
      >
      classicStatus: Array<
        {__typename?: 'AppStoreClassicStatus'} & Pick<
          AppStoreClassicStatus,
          | 'id'
          | 'originalApplicationVersion'
          | 'originalPurchaseDate'
          | 'deviceId'
          | 'likelyFraud'
          | 'createdAt'
          | 'updatedAt'
        >
      >
      profile?: Maybe<{__typename?: 'UserProfile'} & Pick<UserProfile, 'screenname' | 'ignoreFlagging'>>
    }
}

export type GetUserAdminEventsQueryVariables = Exact<{
  adminEventSearchParams: AdminEventSearchParams
}>

export type GetUserAdminEventsQuery = {__typename?: 'Query'} & {
  getUserAdminEvents: Array<
    {__typename?: 'UserAdminEvent'} & Pick<
      UserAdminEvent,
      'id' | 'eventType' | 'createdAt' | 'systemNotes' | 'triggeringUserEmail' | 'triggeringUserNotes'
    >
  >
}

export type GetUserNoteAdminEventsQueryVariables = Exact<{
  adminEventSearchParams: AdminEventSearchParams
}>

export type GetUserNoteAdminEventsQuery = {__typename?: 'Query'} & {
  getUserNoteAdminEvents: Array<
    {__typename?: 'GalleryNoteAdminEvent'} & Pick<
      GalleryNoteAdminEvent,
      'id' | 'eventType' | 'createdAt' | 'systemNotes' | 'triggeringUserEmail' | 'triggeringUserNotes' | 'flaggedReason'
    > & {galleryNote: {__typename?: 'GalleryNote'} & GalleryNoteInfoFragment}
  >
}

export type GetPublishersFollowedByUserQueryVariables = Exact<{
  followingUsersParameters: FollowingUsersParameters
}>

export type GetPublishersFollowedByUserQuery = {__typename?: 'Query'} & {
  getPublishersFollowedByUser: Array<
    {__typename?: 'User'} & Pick<User, 'id'> & {
        profile?: Maybe<{__typename?: 'UserProfile'} & Pick<UserProfile, 'screenname' | 'avatarUpdatedAt'>>
      }
  >
}

export type GetUsersFollowingPublisherQueryVariables = Exact<{
  followingUsersParameters: FollowingUsersParameters
}>

export type GetUsersFollowingPublisherQuery = {__typename?: 'Query'} & {
  getUsersFollowingPublisher: Array<
    {__typename?: 'User'} & Pick<User, 'id'> & {
        profile?: Maybe<{__typename?: 'UserProfile'} & Pick<UserProfile, 'screenname' | 'avatarUpdatedAt'>>
      }
  >
}

export type GetUsersWhoLikedNoteQueryVariables = Exact<{
  likingUsersParameters: LikingUsersParameters
}>

export type GetUsersWhoLikedNoteQuery = {__typename?: 'Query'} & {
  getUsersWhoLikedNote: Array<
    {__typename?: 'User'} & Pick<User, 'id'> & {
        profile?: Maybe<{__typename?: 'UserProfile'} & Pick<UserProfile, 'screenname' | 'avatarUpdatedAt'>>
      }
  >
}

export type GetNoteRendererDataQueryVariables = Exact<{
  noteRendererParams: NoteRendererParams
}>

export type GetNoteRendererDataQuery = {__typename?: 'Query'} & {
  getNoteRendererData?: Maybe<{__typename?: 'NoteRenderData'} & Pick<NoteRenderData, 'data'>>
}

export type GetQuestionableNoteContentQueryVariables = Exact<{
  questionableNoteContentParams: QuestionableNoteContentParams
}>

export type GetQuestionableNoteContentQuery = {__typename?: 'Query'} & {
  getQuestionableNoteContent: Array<
    {__typename?: 'SearchIndexFlagInfo'} & Pick<SearchIndexFlagInfo, 'reason' | 'origin'> & {
        content: Array<{__typename?: 'FlaggedContent'} & Pick<FlaggedContent, 'flaggedTerm' | 'context'>>
      }
  >
}

export type MarkFeedAsViewedMutationVariables = Exact<{
  markFeedAsViewedParams: MarkFeedAsViewedParams
}>

export type MarkFeedAsViewedMutation = {__typename?: 'Mutation'} & Pick<Mutation, 'markFeedAsViewed'>

export type UpdateCookiesMutationVariables = Exact<{
  updateCookiesParams: UpdateCookiesParams
}>

export type UpdateCookiesMutation = {__typename?: 'Mutation'} & Pick<Mutation, 'updateCookies'>

export type ChangeScreennameMutationVariables = Exact<{
  changeScreennameParams: ChangeScreennameParams
}>

export type ChangeScreennameMutation = {__typename?: 'Mutation'} & Pick<Mutation, 'changeScreenname'>

export type ChangeEmailMutationVariables = Exact<{
  changeEmailParams: ChangeEmailParams
}>

export type ChangeEmailMutation = {__typename?: 'Mutation'} & Pick<Mutation, 'changeEmail'>

export type ChangeAdminStatusMutationVariables = Exact<{
  changeAdminStatusParams: ChangeAdminStatusParams
}>

export type ChangeAdminStatusMutation = {__typename?: 'Mutation'} & Pick<Mutation, 'changeAdminStatus'>

export type ChangeBlockStatusMutationVariables = Exact<{
  changeBlockStatusParams: ChangeBlockStatusParams
}>

export type ChangeBlockStatusMutation = {__typename?: 'Mutation'} & Pick<Mutation, 'changeBlockStatus'>

export type GetFuzzyScreennameMatchesQueryVariables = Exact<{
  getFuzzyScreennameMatchesParams: GetFuzzyScreennameMatchesParams
}>

export type GetFuzzyScreennameMatchesQuery = {__typename?: 'Query'} & Pick<Query, 'getFuzzyScreennameMatches'>

export type AdminFuzzyUserSearchQueryVariables = Exact<{
  adminFuzzyUserSearchParams: AdminFuzzyUserSearchParams
}>

export type AdminFuzzyUserSearchQuery = {__typename?: 'Query'} & Pick<Query, 'adminFuzzyUserSearch'>

export type GetNotificationsQueryVariables = Exact<{
  getNotificationsParams: GetNotificationsParams
}>

export type GetNotificationsQuery = {__typename?: 'Query'} & {
  getNotifications: Array<
    {__typename?: 'Notification'} & Pick<
      Notification,
      'id' | 'type' | 'seen' | 'eventCount' | 'createdAt' | 'lastNotificationActionAt'
    > & {
        galleryNote?: Maybe<{__typename?: 'GalleryNote'} & Pick<GalleryNote, 'id' | 'name' | 'previewImages'>>
        promoNotification?: Maybe<
          {__typename?: 'PromoNotification'} & Pick<PromoNotification, 'translationKey' | 'href'>
        >
        notificationEvents: Array<
          {__typename?: 'NotificationEvent'} & Pick<NotificationEvent, 'id'> & {
              triggeringUser?: Maybe<
                {__typename?: 'User'} & Pick<User, 'id'> & {
                    profile?: Maybe<{__typename?: 'UserProfile'} & Pick<UserProfile, 'screenname' | 'avatarUpdatedAt'>>
                  }
              >
            }
        >
      }
  >
}

export type MarkNotificationsSeenMutationVariables = Exact<{
  markNotificationsSeenParams: MarkNotificationsSeenParams
}>

export type MarkNotificationsSeenMutation = {__typename?: 'Mutation'} & Pick<Mutation, 'markNotificationsSeen'>

export type CreatePromoNotificationMutationVariables = Exact<{
  promoNotificationParams: PromoNotificationParams
}>

export type CreatePromoNotificationMutation = {__typename?: 'Mutation'} & {
  createPromoNotification: {__typename?: 'PromoNotification'} & PromoNotificationFragment
}

export type DeletePromoNotificationMutationVariables = Exact<{
  deletePromoParams: DeletePromoParams
}>

export type DeletePromoNotificationMutation = {__typename?: 'Mutation'} & Pick<Mutation, 'deletePromoNotification'>

export type EditPromoNotificationMutationVariables = Exact<{
  promoNotificationParams: PromoNotificationParams
}>

export type EditPromoNotificationMutation = {__typename?: 'Mutation'} & {
  editPromoNotification: {__typename?: 'PromoNotification'} & PromoNotificationFragment
}

export type SetPromoAsDraftMutationVariables = Exact<{
  promoDraftParams: PromoDraftParams
}>

export type SetPromoAsDraftMutation = {__typename?: 'Mutation'} & {
  setPromoAsDraft: {__typename?: 'PromoNotification'} & PromoNotificationFragment
}

export type GetTranslationMappingsQueryVariables = Exact<{
  translationMappingParams: TranslationMappingParams
}>

export type GetTranslationMappingsQuery = {__typename?: 'Query'} & {
  getTranslationMappings: Array<
    {__typename?: 'TranslationMapping'} & Pick<TranslationMapping, 'locale' | 'tKey' | 'text'>
  >
}

export type GrantSubscriptionOverrideMutationVariables = Exact<{
  grantSubscriptionOverrideParams: GrantSubscriptionOverrideParams
}>

export type GrantSubscriptionOverrideMutation = {__typename?: 'Mutation'} & Pick<Mutation, 'grantSubscriptionOverride'>

export type DisableDevicesForSubscriptionsMutationVariables = Exact<{
  disableDevicesForSubscriptionsParams: DisableDevicesForSubscriptionsParams
}>

export type DisableDevicesForSubscriptionsMutation = {__typename?: 'Mutation'} & Pick<
  Mutation,
  'disableDevicesForSubscriptions'
>

export type GetUserLikesNotesQueryVariables = Exact<{
  userLikesNotesParameters: UserLikesNotesParameters
}>

export type GetUserLikesNotesQuery = {__typename?: 'Query'} & {
  getUserLikesNotes: Array<{__typename?: 'LikedNotePair'} & Pick<LikedNotePair, 'noteId' | 'likesNote'>>
}

export type GetAllCommentsQueryVariables = Exact<{
  getAllCommentsParams: GetAllCommentsParams
}>

export type GetAllCommentsQuery = {__typename?: 'Query'} & {
  getAllComments: Array<
    {__typename?: 'Comment'} & Pick<
      Comment,
      'id' | 'createdAt' | 'commentText' | 'approvalState' | 'rejectionReason'
    > & {
        parent?: Maybe<{__typename?: 'Comment'} & Pick<Comment, 'id'>>
        author: {__typename?: 'User'} & Pick<User, 'id'> & {
            profile?: Maybe<{__typename?: 'UserProfile'} & Pick<UserProfile, 'screenname' | 'avatarUrl'>>
          }
        galleryNote: {__typename?: 'GalleryNote'} & Pick<GalleryNote, 'id' | 'name'>
      }
  >
}

export type GetNoteRootCommentsQueryVariables = Exact<{
  getNoteRootCommentsParams: GetNoteRootCommentsParams
}>

export type GetNoteRootCommentsQuery = {__typename?: 'Query'} & {
  getNoteRootComments: Array<
    {__typename?: 'Comment'} & Pick<Comment, 'id' | 'createdAt' | 'commentText'> & {
        parent?: Maybe<{__typename?: 'Comment'} & Pick<Comment, 'id'>>
        author: {__typename?: 'User'} & Pick<User, 'id'> & {
            profile?: Maybe<{__typename?: 'UserProfile'} & Pick<UserProfile, 'screenname' | 'avatarUrl'>>
          }
      }
  >
}

export type ApproveCommentMutationVariables = Exact<{
  approveCommentParams: ApproveCommentParams
}>

export type ApproveCommentMutation = {__typename?: 'Mutation'} & Pick<Mutation, 'approveComment'>

export type SetGalleryDegradedMutationVariables = Exact<{
  degradedStateParams: DegradedStateParams
}>

export type SetGalleryDegradedMutation = {__typename?: 'Mutation'} & Pick<Mutation, 'setGalleryDegraded'>

export type HideCommentMutationVariables = Exact<{
  hideCommentParams: HideCommentParams
}>

export type HideCommentMutation = {__typename?: 'Mutation'} & Pick<Mutation, 'hideComment'>

export type CreateCommentMutationVariables = Exact<{
  createCommentParams: CreateCommentParams
}>

export type CreateCommentMutation = {__typename?: 'Mutation'} & {
  createComment: {__typename?: 'Comment'} & CommentInfoFragment
}

export type ReportCommentMutationVariables = Exact<{
  reportCommentParams: ReportCommentParams
}>

export type ReportCommentMutation = {__typename?: 'Mutation'} & Pick<Mutation, 'reportComment'>

export type DeleteCommentMutationVariables = Exact<{
  deleteCommentParams: DeleteCommentParams
}>

export type DeleteCommentMutation = {__typename?: 'Mutation'} & Pick<Mutation, 'deleteComment'>

export type GetAllSubscriptionsOverDeviceLimitQueryVariables = Exact<{
  getAllSubscriptionsOverDeviceLimitParams: GetAllSubscriptionsOverDeviceLimitParams
}>

export type GetAllSubscriptionsOverDeviceLimitQuery = {__typename?: 'Query'} & {
  getAllSubscriptionsOverDeviceLimit: Array<
    {__typename?: 'GetAllSubscriptionsOverDeviceLimitResult'} & Pick<
      GetAllSubscriptionsOverDeviceLimitResult,
      'subscriptionId' | 'numDevices' | 'deviceLimitEnforcementEnabled'
    >
  >
}

export type ToggleDeviceLimitEnforcementMutationVariables = Exact<{
  toggleDeviceLimitEnforcementParams: ToggleDeviceLimitEnforcementParams
}>

export type ToggleDeviceLimitEnforcementMutation = {__typename?: 'Mutation'} & {
  toggleDeviceLimitEnforcement: {__typename?: 'AppStoreSubscription'} & Pick<
    AppStoreSubscription,
    'deviceLimitEnforcementEnabled'
  >
}

export type DismissGuidelinesMutationVariables = Exact<{[key: string]: never}>

export type DismissGuidelinesMutation = {__typename?: 'Mutation'} & Pick<Mutation, 'dismissGuidelines'>

export type CreateExperimentMutationVariables = Exact<{
  experimentParams: ExperimentParams
}>

export type CreateExperimentMutation = {__typename?: 'Mutation'} & {
  createExperiment: {__typename?: 'Experiment'} & Pick<Experiment, 'id' | 'description' | 'targetEnrollmentPct'>
}

export type AssignAllUsersToExperimentsMutationVariables = Exact<{[key: string]: never}>

export type AssignAllUsersToExperimentsMutation = {__typename?: 'Mutation'} & Pick<
  Mutation,
  'assignAllUsersToExperiments'
>

export type EditExperimentMutationVariables = Exact<{
  experimentParams: ExperimentParams
}>

export type EditExperimentMutation = {__typename?: 'Mutation'} & Pick<Mutation, 'editExperiment'>

export type DeleteExperimentMutationVariables = Exact<{
  deleteExperimentParams: DeleteExperimentParams
}>

export type DeleteExperimentMutation = {__typename?: 'Mutation'} & Pick<Mutation, 'deleteExperiment'>

export type GetExperimentEnrollmentOverridesQueryVariables = Exact<{
  experimentEnrollmentOverrideQueryParams: ExperimentEnrollmentOverrideQueryParams
}>

export type GetExperimentEnrollmentOverridesQuery = {__typename?: 'Query'} & {
  getExperimentEnrollmentOverrides: Array<{__typename?: 'ExperimentEnrollment'} & TestOverrideFragment>
}

export type RemoveExperimentEnrollmentOverrideMutationVariables = Exact<{
  removeExperimentEnrollmentOverrideParams: RemoveExperimentEnrollmentOverrideParams
}>

export type RemoveExperimentEnrollmentOverrideMutation = {__typename?: 'Mutation'} & Pick<
  Mutation,
  'removeExperimentEnrollmentOverride'
>

export type UpdateUserExperimentEnrollmentOverrideMutationVariables = Exact<{
  experimentEnrollmentParams: ExperimentEnrollmentParams
}>

export type UpdateUserExperimentEnrollmentOverrideMutation = {__typename?: 'Mutation'} & {
  updateUserExperimentEnrollmentOverride: {__typename?: 'ExperimentEnrollment'} & TestOverrideFragment
}

export type CreateAsrJobMutationVariables = Exact<{
  createASRJobParams: CreateAsrJobParams
}>

export type CreateAsrJobMutation = {__typename?: 'Mutation'} & {
  createASRJob: {__typename?: 'ASRJobResult'} & Pick<AsrJobResult, 'success' | 'errorCode'> & {
      job?: Maybe<
        {__typename?: 'ASRJob'} & Pick<AsrJob, 'uploadPolicy' | 'status' | 'whisperImplementation' | 'beamSize'> & {
            results?: Maybe<
              {__typename?: 'ASRJobResults'} & Pick<AsrJobResults, 'text'> & {
                  segments: Array<
                    {__typename?: 'ASRJobResultSegment'} & Pick<
                      AsrJobResultSegment,
                      'startTime' | 'endTime' | 'confidence' | 'text'
                    >
                  >
                }
            >
          }
      >
    }
}

export type ReprocessAsrJobMutationVariables = Exact<{
  reprocessASRJobParams: ReprocessAsrJobParams
}>

export type ReprocessAsrJobMutation = {__typename?: 'Mutation'} & {
  reprocessASRJob: {__typename?: 'ASRJobResult'} & Pick<AsrJobResult, 'success' | 'errorCode'> & {
      job?: Maybe<
        {__typename?: 'ASRJob'} & Pick<AsrJob, 'uploadPolicy' | 'status'> & {
            results?: Maybe<
              {__typename?: 'ASRJobResults'} & Pick<AsrJobResults, 'text'> & {
                  segments: Array<
                    {__typename?: 'ASRJobResultSegment'} & Pick<
                      AsrJobResultSegment,
                      'startTime' | 'endTime' | 'confidence' | 'text'
                    >
                  >
                }
            >
          }
      >
    }
}

export type GetCurrentAsrProcessorVersionQueryVariables = Exact<{[key: string]: never}>

export type GetCurrentAsrProcessorVersionQuery = {__typename?: 'Query'} & {
  getCurrentASRProcessorVersion: {__typename?: 'ASRProcessorVersion'} & Pick<AsrProcessorVersion, 'processorVersion'>
}

export type GetAsrJobQueryVariables = Exact<{
  getASRJobParams: GetAsrJobParams
}>

export type GetAsrJobQuery = {__typename?: 'Query'} & {
  getASRJob: {__typename?: 'ASRJobResult'} & Pick<AsrJobResult, 'success' | 'errorCode'> & {
      job?: Maybe<
        {__typename?: 'ASRJob'} & Pick<
          AsrJob,
          'sha512Hash' | 'audioDurationMs' | 'status' | 'whisperImplementation' | 'beamSize'
        > & {
            results?: Maybe<
              {__typename?: 'ASRJobResults'} & Pick<AsrJobResults, 'text'> & {
                  segments: Array<
                    {__typename?: 'ASRJobResultSegment'} & Pick<
                      AsrJobResultSegment,
                      'startTime' | 'endTime' | 'confidence' | 'text'
                    >
                  >
                }
            >
            quizJobs?: Maybe<Array<{__typename?: 'QuizJob'} & Pick<QuizJob, 'id' | 'status' | 'errorReason'>>>
            summaryJobs?: Maybe<Array<{__typename?: 'SummaryJob'} & Pick<SummaryJob, 'id' | 'status' | 'errorReason'>>>
          }
      >
    }
}

export type GetAsrJobMetaQueryVariables = Exact<{
  getASRJobParams: GetAsrJobParams
}>

export type GetAsrJobMetaQuery = {__typename?: 'Query'} & {
  getASRJob: {__typename?: 'ASRJobResult'} & Pick<AsrJobResult, 'success' | 'errorCode'> & {
      job?: Maybe<
        {__typename?: 'ASRJob'} & Pick<
          AsrJob,
          | 'sha512Hash'
          | 'audioDurationMs'
          | 'status'
          | 'whisperImplementation'
          | 'beamSize'
          | 'audioCreationDate'
          | 'language'
        > & {
            quizJobs?: Maybe<Array<{__typename?: 'QuizJob'} & Pick<QuizJob, 'id' | 'status' | 'errorReason'>>>
            summaryJobs?: Maybe<Array<{__typename?: 'SummaryJob'} & Pick<SummaryJob, 'id' | 'status' | 'errorReason'>>>
          }
      >
    }
}

export type GetUserSharedNotesQueryVariables = Exact<{
  getUserSharedNotesParams: GetUserSharedNotesParams
}>

export type GetUserSharedNotesQuery = {__typename?: 'Query'} & {
  getUserSharedNotes: Array<{__typename?: 'Note'} & Pick<Note, 'name' | 'createdDate' | 'id'>>
}

export type SetIgnoreFlagsMutationVariables = Exact<{
  setIgnoreFlagsParams: SetIgnoreFlagsParams
}>

export type SetIgnoreFlagsMutation = {__typename?: 'Mutation'} & {
  setIgnoreFlags: {__typename?: 'UserProfile'} & Pick<UserProfile, 'id' | 'ignoreFlagging'>
}

export type UpdateUserLanguageMutationVariables = Exact<{
  updateUserLanguageParams: UpdateUserLanguageParams
}>

export type UpdateUserLanguageMutation = {__typename?: 'Mutation'} & Pick<Mutation, 'updateUserLanguage'>

export type GetAllSubscriptionInfoQueryVariables = Exact<{
  getAllSubscriptionInfoParams: GetAllSubscriptionInfoParams
}>

export type GetAllSubscriptionInfoQuery = {__typename?: 'Query'} & {
  getAllSubscriptionInfo: {__typename?: 'SubscriptionInfo'} & {
    bestSubscription?: Maybe<
      {__typename?: 'AppStoreSubscription'} & Pick<
        AppStoreSubscription,
        | 'deviceLimitEnforcementEnabled'
        | 'originalTransactionId'
        | 'originalPurchaseDate'
        | 'productId'
        | 'expirationDate'
        | 'gracePeriodExpiresAt'
        | 'expirationIntent'
        | 'status'
        | 'isTrialPeriod'
        | 'isInIntroOfferPeriod'
        | 'isInBillingRetryPeriod'
        | 'promotionalOfferId'
        | 'offerCodeRefName'
        | 'refundedDate'
        | 'refundedReason'
        | 'tier'
      > & {
          user?: Maybe<
            {__typename?: 'User'} & Pick<User, 'id'> & {
                profile?: Maybe<{__typename?: 'UserProfile'} & Pick<UserProfile, 'screenname'>>
              }
          >
          devices: Array<
            {__typename?: 'AppStoreSubscriptionDevice'} & Pick<
              AppStoreSubscriptionDevice,
              'id' | 'deviceId' | 'countryCode' | 'latestReceiptAt' | 'deactivatedAt' | 'createdAt' | 'updatedAt'
            >
          >
        }
    >
    subscriptions: Array<
      {__typename?: 'AppStoreSubscription'} & Pick<
        AppStoreSubscription,
        | 'deviceLimitEnforcementEnabled'
        | 'originalTransactionId'
        | 'originalPurchaseDate'
        | 'productId'
        | 'expirationDate'
        | 'gracePeriodExpiresAt'
        | 'expirationIntent'
        | 'status'
        | 'isTrialPeriod'
        | 'isInIntroOfferPeriod'
        | 'isInBillingRetryPeriod'
        | 'promotionalOfferId'
        | 'offerCodeRefName'
        | 'refundedDate'
        | 'refundedReason'
        | 'tier'
      >
    >
    devices: Array<
      {__typename?: 'AppStoreSubscriptionDevice'} & Pick<
        AppStoreSubscriptionDevice,
        'id' | 'deviceId' | 'countryCode' | 'latestReceiptAt' | 'deactivatedAt' | 'createdAt' | 'updatedAt'
      >
    >
    users: Array<
      {__typename?: 'User'} & Pick<User, 'id' | 'email'> & {
          profile?: Maybe<{__typename?: 'UserProfile'} & Pick<UserProfile, 'screenname'>>
        }
    >
    overrides: Array<
      {__typename?: 'SubscriptionOverride'} & Pick<
        SubscriptionOverride,
        'id' | 'createdAt' | 'expirationDate' | 'overrideTier' | 'overrideReason'
      > & {createdBy?: Maybe<{__typename?: 'User'} & Pick<User, 'id' | 'email'>>}
    >
    classicStatuses: Array<
      {__typename?: 'AppStoreClassicStatus'} & Pick<
        AppStoreClassicStatus,
        | 'id'
        | 'deviceId'
        | 'originalApplicationVersion'
        | 'originalPurchaseDate'
        | 'likelyFraud'
        | 'createdAt'
        | 'updatedAt'
      >
    >
    receipts: Array<
      {__typename?: 'AppStoreReceipt'} & Pick<
        AppStoreReceipt,
        | 'id'
        | 'parsedReceipt'
        | 'deviceId'
        | 'environment'
        | 'isValid'
        | 'originalTransactionId'
        | 'receipt'
        | 'receiptCreationDate'
        | 'updatedAt'
      >
    >
  }
}

export type GetCollatedFlaggedNoteInfoQueryVariables = Exact<{
  getCollatedFlaggedNoteInfoParams: GetCollatedFlaggedNoteInfoParams
}>

export type GetCollatedFlaggedNoteInfoQuery = {__typename?: 'Query'} & {
  getCollatedFlaggedNoteInfo: Array<
    {__typename?: 'GetCollatedFlaggedNoteInfoResult'} & {
      flaggingUser: {__typename?: 'User'} & Pick<User, 'id' | 'email'> & {
          profile?: Maybe<{__typename?: 'UserProfile'} & Pick<UserProfile, 'screenname' | 'ignoreFlagging'>>
        }
      flaggedNotes: Array<{__typename?: 'GalleryNote'} & Pick<GalleryNote, 'id' | 'name'>>
    }
  >
}

export type ComputeTopTagsMutationVariables = Exact<{[key: string]: never}>

export type ComputeTopTagsMutation = {__typename?: 'Mutation'} & Pick<Mutation, 'computeTopTags'>

export type SetGlobalOverrideValueMutationVariables = Exact<{
  setGlobalOverrideValueParams: SetGlobalOverrideValueParams
}>

export type SetGlobalOverrideValueMutation = {__typename?: 'Mutation'} & Pick<Mutation, 'setGlobalOverrideValue'>

export type DeleteGlobalOverrideValueMutationVariables = Exact<{
  deleteGlobalOverrideValueParams: DeleteGlobalOverrideValueParams
}>

export type DeleteGlobalOverrideValueMutation = {__typename?: 'Mutation'} & Pick<Mutation, 'deleteGlobalOverrideValue'>

export type AdminSimulateQuotaMutationVariables = Exact<{
  simulateASRQuotaParams: SimulateAsrQuotaParams
}>

export type AdminSimulateQuotaMutation = {__typename?: 'Mutation'} & Pick<Mutation, 'adminSimulateQuota'>

export type GetCurrentQuotaUsageQueryVariables = Exact<{
  getCurrentQuotaUsageParams: GetCurrentQuotaUsageParams
}>

export type GetCurrentQuotaUsageQuery = {__typename?: 'Query'} & {
  getCurrentQuotaUsage: {__typename?: 'QuotaUsage'} & Pick<QuotaUsage, 'exceeded' | 'quotaUsage' | 'retryAfter'>
}

export type OrganizationDetailsFragment = {__typename?: 'OrganizationDetails'} & Pick<
  OrganizationDetails,
  | 'id'
  | 'organizationName'
  | 'organizationType'
  | 'licenseKey'
  | 'educationLevelsProvided'
  | 'industry'
  | 'usedSeats'
  | 'maxSeats'
  | 'createdAt'
  | 'mdmPlatform'
  | 'approved'
  | 'deletedAt'
  | 'contractAcceptedAt'
  | 'adminCreatorEmail'
  | 'subscriptionStatus'
> & {
    admins: Array<
      {__typename?: 'OrganizationAdminSummary'} & Pick<
        OrganizationAdminSummary,
        'userId' | 'name' | 'email' | 'jobTitle'
      >
    >
  }

export type GetAllOrganizationsQueryVariables = Exact<{
  getAllOrganizationsParams: GetAllOrganizationsParams
}>

export type GetAllOrganizationsQuery = {__typename?: 'Query'} & {
  getAllOrganizations: {__typename?: 'AllOrganizationResults'} & Pick<AllOrganizationResults, 'organizationCount'> & {
      organizations: Array<{__typename?: 'OrganizationDetails'} & OrganizationDetailsFragment>
    }
}

export type OrganizationFragment = {__typename?: 'Organization'} & Pick<
  Organization,
  | 'id'
  | 'name'
  | 'organizationType'
  | 'approved'
  | 'educationLevelsProvided'
  | 'isAsmEnrolled'
  | 'mdmPlatform'
  | 'comments'
  | 'createdAt'
  | 'updatedAt'
  | 'deletedAt'
  | 'industry'
> & {
    license?: Maybe<{__typename?: 'OrganizationLicense'} & Pick<OrganizationLicense, 'id' | 'maxSeats'>>
    userMappings: Array<
      {__typename?: 'OrganizationUser'} & Pick<OrganizationUser, 'jobTitle' | 'role'> & {
          user: {__typename?: 'User'} & Pick<User, 'name' | 'email'>
        }
    >
  }

export type GetOrganizationsAwaitingApprovalQueryVariables = Exact<{[key: string]: never}>

export type GetOrganizationsAwaitingApprovalQuery = {__typename?: 'Query'} & {
  getOrganizationsAwaitingApproval: Array<{__typename?: 'Organization'} & OrganizationFragment>
}

export type ReviewOrganizationMutationVariables = Exact<{
  reviewOrganizationParams: ReviewOrganizationParams
}>

export type ReviewOrganizationMutation = {__typename?: 'Mutation'} & Pick<Mutation, 'reviewOrganization'>

export type RestoreOrganizationMutationVariables = Exact<{
  restoreOrganizationParams: RestoreOrganizationParams
}>

export type RestoreOrganizationMutation = {__typename?: 'Mutation'} & Pick<Mutation, 'restoreOrganization'>

export type GetOrganizationAdminQueryVariables = Exact<{
  organizationAdminQueryParams: OrganizationAdminQueryParams
}>

export type GetOrganizationAdminQuery = {__typename?: 'Query'} & {
  getOrganizationAdmin: {__typename?: 'OrganizationAdminDetails'} & Pick<
    OrganizationAdminDetails,
    | 'name'
    | 'email'
    | 'jobTitle'
    | 'organizationName'
    | 'organizationType'
    | 'organizationId'
    | 'licenseKey'
    | 'maxSeats'
    | 'usedSeats'
    | 'subscriptionStatus'
    | 'approved'
    | 'organizationDeletedAt'
    | 'organizationStatus'
    | 'mdmPlatform'
  >
}

export type RenameUserMutationVariables = Exact<{
  renameUserParams: RenameUserParams
}>

export type RenameUserMutation = {__typename?: 'Mutation'} & Pick<Mutation, 'renameUser'>

export type GetOrganizationQueryVariables = Exact<{
  getOrganizationParams: GetOrganizationParams
}>

export type GetOrganizationQuery = {__typename?: 'Query'} & {
  getOrganization: {__typename?: 'OrganizationDetails'} & OrganizationDetailsFragment
}

export type ModifyOrganizationLicenseMutationVariables = Exact<{
  modifyOrganizationLicenseParams: ModifyOrganizationLicenseParams
}>

export type ModifyOrganizationLicenseMutation = {__typename?: 'Mutation'} & Pick<Mutation, 'modifyOrganizationLicense'>

export type ResetOrganizationSeatUsageMutationVariables = Exact<{
  resetOrganizationSeatUsageParams: ResetOrganizationSeatUsageParams
}>

export type ResetOrganizationSeatUsageMutation = {__typename?: 'Mutation'} & Pick<
  Mutation,
  'resetOrganizationSeatUsage'
>

export type GetSummaryJobContentQueryVariables = Exact<{
  getSummaryJobContentParams: GetSummaryJobContentParams
}>

export type GetSummaryJobContentQuery = {__typename?: 'Query'} & Pick<Query, 'getSummaryJobContent'>

export type GetQuizJobContentQueryVariables = Exact<{
  getQuizJobContentParams: GetQuizJobContentParams
}>

export type GetQuizJobContentQuery = {__typename?: 'Query'} & Pick<Query, 'getQuizJobContent'>

export type GetInstitutionsQueryVariables = Exact<{
  getInstitutionsParams: GetInstitutionsParams
}>

export type GetInstitutionsQuery = {__typename?: 'Query'} & {
  getInstitutions: {__typename?: 'GetInstitutionsResult'} & Pick<GetInstitutionsResult, 'count'> & {
      institutions: Array<
        {__typename?: 'InstitutionWithDeviceCount'} & Pick<
          InstitutionWithDeviceCount,
          'id' | 'name' | 'deviceCount' | 'createdAt' | 'licenseEnforcement' | 'licenseEnforcementExpiration'
        >
      >
    }
}

export type SetLicenseEnforcementMutationVariables = Exact<{
  setLicenseEnforcementParams: SetLicenseEnforcementParams
}>

export type SetLicenseEnforcementMutation = {__typename?: 'Mutation'} & Pick<Mutation, 'setLicenseEnforcement'>

export type SetLicenseEnforcementExpirationMutationVariables = Exact<{
  setLicenseEnforcementExpirationParams: SetLicenseEnforcementExpirationParams
}>

export type SetLicenseEnforcementExpirationMutation = {__typename?: 'Mutation'} & Pick<
  Mutation,
  'setLicenseEnforcementExpiration'
>

export type GenerateStudyMaterialsBatchMutationVariables = Exact<{
  generateStudyMaterialsBatchParams: GenerateStudyMaterialsBatchParams
}>

export type GenerateStudyMaterialsBatchMutation = {__typename?: 'Mutation'} & {
  generateStudyMaterialsBatch: {__typename?: 'StudyMaterialsBatch'} & Pick<
    StudyMaterialsBatch,
    'id' | 'promptGroup' | 'language'
  > & {
      studyMaterials?: Maybe<
        Array<
          {__typename?: 'StudyMaterial'} & Pick<StudyMaterial, 'contentHash' | 'source'> & {
              quizJob?: Maybe<{__typename?: 'QuizJob'} & Pick<QuizJob, 'id' | 'status' | 'errorReason'>>
              summaryJob?: Maybe<{__typename?: 'SummaryJob'} & Pick<SummaryJob, 'id' | 'status' | 'errorReason'>>
            }
        >
      >
    }
}

export type GetStudyMaterialsBatchQueryVariables = Exact<{
  getStudyMaterialsBatchParams: GetStudyMaterialsBatchParams
}>

export type GetStudyMaterialsBatchQuery = {__typename?: 'Query'} & {
  getStudyMaterialsBatch: {__typename?: 'StudyMaterialsBatch'} & Pick<
    StudyMaterialsBatch,
    'id' | 'promptGroup' | 'language'
  > & {
      studyMaterials?: Maybe<
        Array<
          {__typename?: 'StudyMaterial'} & Pick<StudyMaterial, 'contentHash' | 'source'> & {
              quizJob?: Maybe<{__typename?: 'QuizJob'} & Pick<QuizJob, 'id' | 'status' | 'errorReason'>>
              summaryJob?: Maybe<{__typename?: 'SummaryJob'} & Pick<SummaryJob, 'id' | 'status' | 'errorReason'>>
            }
        >
      >
    }
}

export type CreateOrganizationMutationVariables = Exact<{
  createOrgParams: CreateOrgParams
}>

export type CreateOrganizationMutation = {__typename?: 'Mutation'} & {
  createOrganization: {__typename?: 'Organization'} & Pick<
    Organization,
    | 'id'
    | 'name'
    | 'approved'
    | 'isAsmEnrolled'
    | 'educationLevelsProvided'
    | 'mdmPlatform'
    | 'organizationType'
    | 'industry'
    | 'contractAcceptedAt'
  > & {license?: Maybe<{__typename?: 'OrganizationLicense'} & Pick<OrganizationLicense, 'id' | 'maxSeats'>>}
}

export type GetViableSubscriptionQueryVariables = Exact<{
  getViableSubscriptionParams: GetViableSubscriptionParams
}>

export type GetViableSubscriptionQuery = {__typename?: 'Query'} & {
  getViableSubscription?: Maybe<
    {__typename?: 'AppStoreSubscription'} & Pick<
      AppStoreSubscription,
      | 'originalTransactionId'
      | 'originalPurchaseDate'
      | 'productId'
      | 'expirationDate'
      | 'status'
      | 'isTrialPeriod'
      | 'isInIntroOfferPeriod'
      | 'refundedDate'
      | 'refundedReason'
      | 'overDeviceLimit'
      | 'gracePeriodExpiresAt'
      | 'expirationIntent'
      | 'isInBillingRetryPeriod'
      | 'tier'
    >
  >
}

export type GetSendGridEventsQueryVariables = Exact<{
  getSendGridEventsParams: GetSendGridEventsParams
}>

export type GetSendGridEventsQuery = {__typename?: 'Query'} & {
  getSendGridEvents: {__typename?: 'OrganizationEmailEvents'} & Pick<OrganizationEmailEvents, 'count'> & {
      events: Array<{__typename?: 'SendGridEvent'} & Pick<SendGridEvent, 'id' | 'email' | 'createdAt' | 'event'>>
    }
}

export type GetSubscriptionInfoForUserQueryVariables = Exact<{[key: string]: never}>

export type GetSubscriptionInfoForUserQuery = {__typename?: 'Query'} & {
  subscriptionInfo: {__typename?: 'UserSubscriptionResult'} & Pick<
    UserSubscriptionResult,
    | 'isClassicUser'
    | 'subscriptionTier'
    | 'subscriptionSource'
    | 'trialLengthInDays'
    | 'trialExpirationDate'
    | 'subscriptionRenewalDate'
  >
}

export const GalleryNoteInfoFragmentDoc = gql`
  fragment galleryNoteInfo on GalleryNote {
    id
    name
    user {
      id
      name
      profile {
        screenname
        avatarUpdatedAt
      }
    }
    viewCount
    commentsEnabled
    previewCount
    description
    updatedAt
    createdAt
    triageState
    contentType
    tags {
      name
    }
    parentNoteId
    rootNoteId
    likes
    remixCount
    clientId
  }
`
export const NoteCollectionInfoFragmentDoc = gql`
  fragment noteCollectionInfo on NoteCollection {
    id
    name
    isOfficialContent
    isFeatured
  }
`
export const CommentInfoFragmentDoc = gql`
  fragment commentInfo on Comment {
    id
    parent {
      id
    }
    author {
      id
      profile {
        screenname
        avatarUrl
      }
    }
    createdAt
    commentText
  }
`
export const PromoNotificationFragmentDoc = gql`
  fragment promoNotification on PromoNotification {
    id
    author {
      id
      name
      profile {
        screenname
        avatarUpdatedAt
      }
    }
    startDate
    endDate
    translationKey
    href
    isDraft
  }
`
export const TestOverrideFragmentDoc = gql`
  fragment testOverride on ExperimentEnrollment {
    inVariantGroup
    isOverride
    user {
      profile {
        screenname
      }
    }
    experiment {
      id
    }
  }
`
export const OrganizationDetailsFragmentDoc = gql`
  fragment organizationDetails on OrganizationDetails {
    id
    admins {
      userId
      name
      email
      jobTitle
    }
    organizationName
    organizationType
    licenseKey
    educationLevelsProvided
    industry
    usedSeats
    maxSeats
    createdAt
    mdmPlatform
    approved
    deletedAt
    contractAcceptedAt
    adminCreatorEmail
    subscriptionStatus
  }
`
export const OrganizationFragmentDoc = gql`
  fragment organization on Organization {
    id
    name
    organizationType
    approved
    educationLevelsProvided
    isAsmEnrolled
    mdmPlatform
    comments
    createdAt
    updatedAt
    deletedAt
    industry
    license {
      id
      maxSeats
    }
    userMappings {
      user {
        name
        email
      }
      jobTitle
      role
    }
  }
`
export const CreateCollectionDocument = gql`
  mutation createCollection($createNoteCollectionParams: CreateNoteCollectionParams!) {
    createCollection(createNoteCollectionParams: $createNoteCollectionParams)
  }
`
export type CreateCollectionMutationFn = Apollo.MutationFunction<
  CreateCollectionMutation,
  CreateCollectionMutationVariables
>

/**
 * __useCreateCollectionMutation__
 *
 * To run a mutation, you first call `useCreateCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCollectionMutation, { data, loading, error }] = useCreateCollectionMutation({
 *   variables: {
 *      createNoteCollectionParams: // value for 'createNoteCollectionParams'
 *   },
 * });
 */
export function useCreateCollectionMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateCollectionMutation, CreateCollectionMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<CreateCollectionMutation, CreateCollectionMutationVariables>(
    CreateCollectionDocument,
    options
  )
}
export type CreateCollectionMutationHookResult = ReturnType<typeof useCreateCollectionMutation>
export type CreateCollectionMutationResult = Apollo.MutationResult<CreateCollectionMutation>
export type CreateCollectionMutationOptions = Apollo.BaseMutationOptions<
  CreateCollectionMutation,
  CreateCollectionMutationVariables
>
export const DeleteCollectionDocument = gql`
  mutation deleteCollection($deleteNoteCollectionParams: DeleteNoteCollectionParams!) {
    deleteCollection(deleteNoteCollectionParams: $deleteNoteCollectionParams)
  }
`
export type DeleteCollectionMutationFn = Apollo.MutationFunction<
  DeleteCollectionMutation,
  DeleteCollectionMutationVariables
>

/**
 * __useDeleteCollectionMutation__
 *
 * To run a mutation, you first call `useDeleteCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCollectionMutation, { data, loading, error }] = useDeleteCollectionMutation({
 *   variables: {
 *      deleteNoteCollectionParams: // value for 'deleteNoteCollectionParams'
 *   },
 * });
 */
export function useDeleteCollectionMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteCollectionMutation, DeleteCollectionMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<DeleteCollectionMutation, DeleteCollectionMutationVariables>(
    DeleteCollectionDocument,
    options
  )
}
export type DeleteCollectionMutationHookResult = ReturnType<typeof useDeleteCollectionMutation>
export type DeleteCollectionMutationResult = Apollo.MutationResult<DeleteCollectionMutation>
export type DeleteCollectionMutationOptions = Apollo.BaseMutationOptions<
  DeleteCollectionMutation,
  DeleteCollectionMutationVariables
>
export const AddNoteToCollectionDocument = gql`
  mutation addNoteToCollection($addNoteToCollectionParams: AddNoteToCollectionParams!) {
    addNoteToCollection(addNoteToCollectionParams: $addNoteToCollectionParams) {
      ...noteCollectionInfo
    }
  }
  ${NoteCollectionInfoFragmentDoc}
`
export type AddNoteToCollectionMutationFn = Apollo.MutationFunction<
  AddNoteToCollectionMutation,
  AddNoteToCollectionMutationVariables
>

/**
 * __useAddNoteToCollectionMutation__
 *
 * To run a mutation, you first call `useAddNoteToCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNoteToCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNoteToCollectionMutation, { data, loading, error }] = useAddNoteToCollectionMutation({
 *   variables: {
 *      addNoteToCollectionParams: // value for 'addNoteToCollectionParams'
 *   },
 * });
 */
export function useAddNoteToCollectionMutation(
  baseOptions?: Apollo.MutationHookOptions<AddNoteToCollectionMutation, AddNoteToCollectionMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<AddNoteToCollectionMutation, AddNoteToCollectionMutationVariables>(
    AddNoteToCollectionDocument,
    options
  )
}
export type AddNoteToCollectionMutationHookResult = ReturnType<typeof useAddNoteToCollectionMutation>
export type AddNoteToCollectionMutationResult = Apollo.MutationResult<AddNoteToCollectionMutation>
export type AddNoteToCollectionMutationOptions = Apollo.BaseMutationOptions<
  AddNoteToCollectionMutation,
  AddNoteToCollectionMutationVariables
>
export const ReorderNoteCollectionNoteDocument = gql`
  mutation reorderNoteCollectionNote($reorderNoteCollectionNoteParams: ReorderNoteCollectionNoteParams!) {
    reorderNoteCollectionNote(reorderNoteCollectionNoteParams: $reorderNoteCollectionNoteParams)
  }
`
export type ReorderNoteCollectionNoteMutationFn = Apollo.MutationFunction<
  ReorderNoteCollectionNoteMutation,
  ReorderNoteCollectionNoteMutationVariables
>

/**
 * __useReorderNoteCollectionNoteMutation__
 *
 * To run a mutation, you first call `useReorderNoteCollectionNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderNoteCollectionNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderNoteCollectionNoteMutation, { data, loading, error }] = useReorderNoteCollectionNoteMutation({
 *   variables: {
 *      reorderNoteCollectionNoteParams: // value for 'reorderNoteCollectionNoteParams'
 *   },
 * });
 */
export function useReorderNoteCollectionNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReorderNoteCollectionNoteMutation,
    ReorderNoteCollectionNoteMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<ReorderNoteCollectionNoteMutation, ReorderNoteCollectionNoteMutationVariables>(
    ReorderNoteCollectionNoteDocument,
    options
  )
}
export type ReorderNoteCollectionNoteMutationHookResult = ReturnType<typeof useReorderNoteCollectionNoteMutation>
export type ReorderNoteCollectionNoteMutationResult = Apollo.MutationResult<ReorderNoteCollectionNoteMutation>
export type ReorderNoteCollectionNoteMutationOptions = Apollo.BaseMutationOptions<
  ReorderNoteCollectionNoteMutation,
  ReorderNoteCollectionNoteMutationVariables
>
export const RemoveNoteFromCollectionDocument = gql`
  mutation removeNoteFromCollection($removeNoteFromCollectionParams: RemoveNoteFromCollectionParams!) {
    removeNoteFromCollection(removeNoteFromCollectionParams: $removeNoteFromCollectionParams)
  }
`
export type RemoveNoteFromCollectionMutationFn = Apollo.MutationFunction<
  RemoveNoteFromCollectionMutation,
  RemoveNoteFromCollectionMutationVariables
>

/**
 * __useRemoveNoteFromCollectionMutation__
 *
 * To run a mutation, you first call `useRemoveNoteFromCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveNoteFromCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeNoteFromCollectionMutation, { data, loading, error }] = useRemoveNoteFromCollectionMutation({
 *   variables: {
 *      removeNoteFromCollectionParams: // value for 'removeNoteFromCollectionParams'
 *   },
 * });
 */
export function useRemoveNoteFromCollectionMutation(
  baseOptions?: Apollo.MutationHookOptions<RemoveNoteFromCollectionMutation, RemoveNoteFromCollectionMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<RemoveNoteFromCollectionMutation, RemoveNoteFromCollectionMutationVariables>(
    RemoveNoteFromCollectionDocument,
    options
  )
}
export type RemoveNoteFromCollectionMutationHookResult = ReturnType<typeof useRemoveNoteFromCollectionMutation>
export type RemoveNoteFromCollectionMutationResult = Apollo.MutationResult<RemoveNoteFromCollectionMutation>
export type RemoveNoteFromCollectionMutationOptions = Apollo.BaseMutationOptions<
  RemoveNoteFromCollectionMutation,
  RemoveNoteFromCollectionMutationVariables
>
export const GetNoteCollectionDocument = gql`
  query getNoteCollection($noteCollectionParams: NoteCollectionParams!) {
    getNoteCollection(noteCollectionParams: $noteCollectionParams) {
      id
      name
      owner {
        name
        profile {
          screenname
        }
      }
    }
  }
`

/**
 * __useGetNoteCollectionQuery__
 *
 * To run a query within a React component, call `useGetNoteCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNoteCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNoteCollectionQuery({
 *   variables: {
 *      noteCollectionParams: // value for 'noteCollectionParams'
 *   },
 * });
 */
export function useGetNoteCollectionQuery(
  baseOptions: Apollo.QueryHookOptions<GetNoteCollectionQuery, GetNoteCollectionQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetNoteCollectionQuery, GetNoteCollectionQueryVariables>(GetNoteCollectionDocument, options)
}
export function useGetNoteCollectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetNoteCollectionQuery, GetNoteCollectionQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetNoteCollectionQuery, GetNoteCollectionQueryVariables>(
    GetNoteCollectionDocument,
    options
  )
}
export type GetNoteCollectionQueryHookResult = ReturnType<typeof useGetNoteCollectionQuery>
export type GetNoteCollectionLazyQueryHookResult = ReturnType<typeof useGetNoteCollectionLazyQuery>
export type GetNoteCollectionQueryResult = Apollo.QueryResult<GetNoteCollectionQuery, GetNoteCollectionQueryVariables>
export const GetOfficialNoteCollectionsDocument = gql`
  query getOfficialNoteCollections($pagingParams: PagingParams!) {
    getOfficialNoteCollections(pagingParams: $pagingParams) {
      results {
        id
        name
      }
      totalCount
    }
  }
`

/**
 * __useGetOfficialNoteCollectionsQuery__
 *
 * To run a query within a React component, call `useGetOfficialNoteCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfficialNoteCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfficialNoteCollectionsQuery({
 *   variables: {
 *      pagingParams: // value for 'pagingParams'
 *   },
 * });
 */
export function useGetOfficialNoteCollectionsQuery(
  baseOptions: Apollo.QueryHookOptions<GetOfficialNoteCollectionsQuery, GetOfficialNoteCollectionsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetOfficialNoteCollectionsQuery, GetOfficialNoteCollectionsQueryVariables>(
    GetOfficialNoteCollectionsDocument,
    options
  )
}
export function useGetOfficialNoteCollectionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetOfficialNoteCollectionsQuery, GetOfficialNoteCollectionsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetOfficialNoteCollectionsQuery, GetOfficialNoteCollectionsQueryVariables>(
    GetOfficialNoteCollectionsDocument,
    options
  )
}
export type GetOfficialNoteCollectionsQueryHookResult = ReturnType<typeof useGetOfficialNoteCollectionsQuery>
export type GetOfficialNoteCollectionsLazyQueryHookResult = ReturnType<typeof useGetOfficialNoteCollectionsLazyQuery>
export type GetOfficialNoteCollectionsQueryResult = Apollo.QueryResult<
  GetOfficialNoteCollectionsQuery,
  GetOfficialNoteCollectionsQueryVariables
>
export const GetNoteCollectionsForUserDocument = gql`
  query getNoteCollectionsForUser($userNoteCollectionsParams: UserNoteCollectionsParams!) {
    getNoteCollectionsForUser(userNoteCollectionsParams: $userNoteCollectionsParams) {
      results {
        id
        name
      }
      totalCount
    }
  }
`

/**
 * __useGetNoteCollectionsForUserQuery__
 *
 * To run a query within a React component, call `useGetNoteCollectionsForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNoteCollectionsForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNoteCollectionsForUserQuery({
 *   variables: {
 *      userNoteCollectionsParams: // value for 'userNoteCollectionsParams'
 *   },
 * });
 */
export function useGetNoteCollectionsForUserQuery(
  baseOptions: Apollo.QueryHookOptions<GetNoteCollectionsForUserQuery, GetNoteCollectionsForUserQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetNoteCollectionsForUserQuery, GetNoteCollectionsForUserQueryVariables>(
    GetNoteCollectionsForUserDocument,
    options
  )
}
export function useGetNoteCollectionsForUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetNoteCollectionsForUserQuery, GetNoteCollectionsForUserQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetNoteCollectionsForUserQuery, GetNoteCollectionsForUserQueryVariables>(
    GetNoteCollectionsForUserDocument,
    options
  )
}
export type GetNoteCollectionsForUserQueryHookResult = ReturnType<typeof useGetNoteCollectionsForUserQuery>
export type GetNoteCollectionsForUserLazyQueryHookResult = ReturnType<typeof useGetNoteCollectionsForUserLazyQuery>
export type GetNoteCollectionsForUserQueryResult = Apollo.QueryResult<
  GetNoteCollectionsForUserQuery,
  GetNoteCollectionsForUserQueryVariables
>
export const UpdateCollectionDocument = gql`
  mutation updateCollection($updateNoteCollectionParams: UpdateNoteCollectionParams!) {
    updateCollection(updateNoteCollectionParams: $updateNoteCollectionParams) {
      ...noteCollectionInfo
    }
  }
  ${NoteCollectionInfoFragmentDoc}
`
export type UpdateCollectionMutationFn = Apollo.MutationFunction<
  UpdateCollectionMutation,
  UpdateCollectionMutationVariables
>

/**
 * __useUpdateCollectionMutation__
 *
 * To run a mutation, you first call `useUpdateCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCollectionMutation, { data, loading, error }] = useUpdateCollectionMutation({
 *   variables: {
 *      updateNoteCollectionParams: // value for 'updateNoteCollectionParams'
 *   },
 * });
 */
export function useUpdateCollectionMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateCollectionMutation, UpdateCollectionMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<UpdateCollectionMutation, UpdateCollectionMutationVariables>(
    UpdateCollectionDocument,
    options
  )
}
export type UpdateCollectionMutationHookResult = ReturnType<typeof useUpdateCollectionMutation>
export type UpdateCollectionMutationResult = Apollo.MutationResult<UpdateCollectionMutation>
export type UpdateCollectionMutationOptions = Apollo.BaseMutationOptions<
  UpdateCollectionMutation,
  UpdateCollectionMutationVariables
>
export const GetNotesForCollectionDocument = gql`
  query getNotesForCollection($noteCollectionNotesParams: NoteCollectionNotesParams!) {
    getNotesForCollection(noteCollectionNotesParams: $noteCollectionNotesParams) {
      results {
        ...galleryNoteInfo
      }
      totalCount
    }
  }
  ${GalleryNoteInfoFragmentDoc}
`

/**
 * __useGetNotesForCollectionQuery__
 *
 * To run a query within a React component, call `useGetNotesForCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotesForCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotesForCollectionQuery({
 *   variables: {
 *      noteCollectionNotesParams: // value for 'noteCollectionNotesParams'
 *   },
 * });
 */
export function useGetNotesForCollectionQuery(
  baseOptions: Apollo.QueryHookOptions<GetNotesForCollectionQuery, GetNotesForCollectionQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetNotesForCollectionQuery, GetNotesForCollectionQueryVariables>(
    GetNotesForCollectionDocument,
    options
  )
}
export function useGetNotesForCollectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetNotesForCollectionQuery, GetNotesForCollectionQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetNotesForCollectionQuery, GetNotesForCollectionQueryVariables>(
    GetNotesForCollectionDocument,
    options
  )
}
export type GetNotesForCollectionQueryHookResult = ReturnType<typeof useGetNotesForCollectionQuery>
export type GetNotesForCollectionLazyQueryHookResult = ReturnType<typeof useGetNotesForCollectionLazyQuery>
export type GetNotesForCollectionQueryResult = Apollo.QueryResult<
  GetNotesForCollectionQuery,
  GetNotesForCollectionQueryVariables
>
export const GetNotesForOfficialCollectionDocument = gql`
  query getNotesForOfficialCollection($officialCollectionNotesParams: OfficialCollectionNotesParams!) {
    getNotesForOfficialCollection(officialCollectionNotesParams: $officialCollectionNotesParams) {
      results {
        ...galleryNoteInfo
      }
      totalCount
    }
  }
  ${GalleryNoteInfoFragmentDoc}
`

/**
 * __useGetNotesForOfficialCollectionQuery__
 *
 * To run a query within a React component, call `useGetNotesForOfficialCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotesForOfficialCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotesForOfficialCollectionQuery({
 *   variables: {
 *      officialCollectionNotesParams: // value for 'officialCollectionNotesParams'
 *   },
 * });
 */
export function useGetNotesForOfficialCollectionQuery(
  baseOptions: Apollo.QueryHookOptions<GetNotesForOfficialCollectionQuery, GetNotesForOfficialCollectionQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetNotesForOfficialCollectionQuery, GetNotesForOfficialCollectionQueryVariables>(
    GetNotesForOfficialCollectionDocument,
    options
  )
}
export function useGetNotesForOfficialCollectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetNotesForOfficialCollectionQuery,
    GetNotesForOfficialCollectionQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetNotesForOfficialCollectionQuery, GetNotesForOfficialCollectionQueryVariables>(
    GetNotesForOfficialCollectionDocument,
    options
  )
}
export type GetNotesForOfficialCollectionQueryHookResult = ReturnType<typeof useGetNotesForOfficialCollectionQuery>
export type GetNotesForOfficialCollectionLazyQueryHookResult = ReturnType<
  typeof useGetNotesForOfficialCollectionLazyQuery
>
export type GetNotesForOfficialCollectionQueryResult = Apollo.QueryResult<
  GetNotesForOfficialCollectionQuery,
  GetNotesForOfficialCollectionQueryVariables
>
export const LikeNoteDocument = gql`
  mutation likeNote($likeParams: LikeParams!) {
    likeNote(likeParams: $likeParams) {
      id
    }
  }
`
export type LikeNoteMutationFn = Apollo.MutationFunction<LikeNoteMutation, LikeNoteMutationVariables>

/**
 * __useLikeNoteMutation__
 *
 * To run a mutation, you first call `useLikeNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLikeNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [likeNoteMutation, { data, loading, error }] = useLikeNoteMutation({
 *   variables: {
 *      likeParams: // value for 'likeParams'
 *   },
 * });
 */
export function useLikeNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<LikeNoteMutation, LikeNoteMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<LikeNoteMutation, LikeNoteMutationVariables>(LikeNoteDocument, options)
}
export type LikeNoteMutationHookResult = ReturnType<typeof useLikeNoteMutation>
export type LikeNoteMutationResult = Apollo.MutationResult<LikeNoteMutation>
export type LikeNoteMutationOptions = Apollo.BaseMutationOptions<LikeNoteMutation, LikeNoteMutationVariables>
export const FlagNoteDocument = gql`
  mutation flagNote($flagParams: FlagParams!) {
    flagNote(flagParams: $flagParams) {
      id
    }
  }
`
export type FlagNoteMutationFn = Apollo.MutationFunction<FlagNoteMutation, FlagNoteMutationVariables>

/**
 * __useFlagNoteMutation__
 *
 * To run a mutation, you first call `useFlagNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFlagNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [flagNoteMutation, { data, loading, error }] = useFlagNoteMutation({
 *   variables: {
 *      flagParams: // value for 'flagParams'
 *   },
 * });
 */
export function useFlagNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<FlagNoteMutation, FlagNoteMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<FlagNoteMutation, FlagNoteMutationVariables>(FlagNoteDocument, options)
}
export type FlagNoteMutationHookResult = ReturnType<typeof useFlagNoteMutation>
export type FlagNoteMutationResult = Apollo.MutationResult<FlagNoteMutation>
export type FlagNoteMutationOptions = Apollo.BaseMutationOptions<FlagNoteMutation, FlagNoteMutationVariables>
export const FlagNoteFamilyTreeDocument = gql`
  mutation flagNoteFamilyTree($flagParams: FlagParams!) {
    flagNoteFamilyTree(flagParams: $flagParams) {
      ...galleryNoteInfo
    }
  }
  ${GalleryNoteInfoFragmentDoc}
`
export type FlagNoteFamilyTreeMutationFn = Apollo.MutationFunction<
  FlagNoteFamilyTreeMutation,
  FlagNoteFamilyTreeMutationVariables
>

/**
 * __useFlagNoteFamilyTreeMutation__
 *
 * To run a mutation, you first call `useFlagNoteFamilyTreeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFlagNoteFamilyTreeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [flagNoteFamilyTreeMutation, { data, loading, error }] = useFlagNoteFamilyTreeMutation({
 *   variables: {
 *      flagParams: // value for 'flagParams'
 *   },
 * });
 */
export function useFlagNoteFamilyTreeMutation(
  baseOptions?: Apollo.MutationHookOptions<FlagNoteFamilyTreeMutation, FlagNoteFamilyTreeMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<FlagNoteFamilyTreeMutation, FlagNoteFamilyTreeMutationVariables>(
    FlagNoteFamilyTreeDocument,
    options
  )
}
export type FlagNoteFamilyTreeMutationHookResult = ReturnType<typeof useFlagNoteFamilyTreeMutation>
export type FlagNoteFamilyTreeMutationResult = Apollo.MutationResult<FlagNoteFamilyTreeMutation>
export type FlagNoteFamilyTreeMutationOptions = Apollo.BaseMutationOptions<
  FlagNoteFamilyTreeMutation,
  FlagNoteFamilyTreeMutationVariables
>
export const GetNotesDocument = gql`
  query getNotes($getNotesParams: GetNotesParameters!) {
    getNotes(getNotesParams: $getNotesParams) {
      ...galleryNoteInfo
    }
  }
  ${GalleryNoteInfoFragmentDoc}
`

/**
 * __useGetNotesQuery__
 *
 * To run a query within a React component, call `useGetNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotesQuery({
 *   variables: {
 *      getNotesParams: // value for 'getNotesParams'
 *   },
 * });
 */
export function useGetNotesQuery(baseOptions: Apollo.QueryHookOptions<GetNotesQuery, GetNotesQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetNotesQuery, GetNotesQueryVariables>(GetNotesDocument, options)
}
export function useGetNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotesQuery, GetNotesQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetNotesQuery, GetNotesQueryVariables>(GetNotesDocument, options)
}
export type GetNotesQueryHookResult = ReturnType<typeof useGetNotesQuery>
export type GetNotesLazyQueryHookResult = ReturnType<typeof useGetNotesLazyQuery>
export type GetNotesQueryResult = Apollo.QueryResult<GetNotesQuery, GetNotesQueryVariables>
export const GetFeatureFlagsForUserDocument = gql`
  query getFeatureFlagsForUser {
    getFeatureFlagsForUser
  }
`

/**
 * __useGetFeatureFlagsForUserQuery__
 *
 * To run a query within a React component, call `useGetFeatureFlagsForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeatureFlagsForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeatureFlagsForUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFeatureFlagsForUserQuery(
  baseOptions?: Apollo.QueryHookOptions<GetFeatureFlagsForUserQuery, GetFeatureFlagsForUserQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetFeatureFlagsForUserQuery, GetFeatureFlagsForUserQueryVariables>(
    GetFeatureFlagsForUserDocument,
    options
  )
}
export function useGetFeatureFlagsForUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetFeatureFlagsForUserQuery, GetFeatureFlagsForUserQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetFeatureFlagsForUserQuery, GetFeatureFlagsForUserQueryVariables>(
    GetFeatureFlagsForUserDocument,
    options
  )
}
export type GetFeatureFlagsForUserQueryHookResult = ReturnType<typeof useGetFeatureFlagsForUserQuery>
export type GetFeatureFlagsForUserLazyQueryHookResult = ReturnType<typeof useGetFeatureFlagsForUserLazyQuery>
export type GetFeatureFlagsForUserQueryResult = Apollo.QueryResult<
  GetFeatureFlagsForUserQuery,
  GetFeatureFlagsForUserQueryVariables
>
export const MeDocument = gql`
  query me {
    me {
      id
      featureFlags
      profile {
        avatarUpdatedAt
      }
    }
  }
`

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options)
}
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options)
}
export type MeQueryHookResult = ReturnType<typeof useMeQuery>
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>
export const UpdateProfileDocument = gql`
  mutation updateProfile($profileParams: ProfileParams!) {
    updateProfile(profileParams: $profileParams) {
      id
      screenname
    }
  }
`
export type UpdateProfileMutationFn = Apollo.MutationFunction<UpdateProfileMutation, UpdateProfileMutationVariables>

/**
 * __useUpdateProfileMutation__
 *
 * To run a mutation, you first call `useUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileMutation, { data, loading, error }] = useUpdateProfileMutation({
 *   variables: {
 *      profileParams: // value for 'profileParams'
 *   },
 * });
 */
export function useUpdateProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateProfileMutation, UpdateProfileMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<UpdateProfileMutation, UpdateProfileMutationVariables>(UpdateProfileDocument, options)
}
export type UpdateProfileMutationHookResult = ReturnType<typeof useUpdateProfileMutation>
export type UpdateProfileMutationResult = Apollo.MutationResult<UpdateProfileMutation>
export type UpdateProfileMutationOptions = Apollo.BaseMutationOptions<
  UpdateProfileMutation,
  UpdateProfileMutationVariables
>
export const FlagProfileDocument = gql`
  mutation flagProfile($flagProfileParams: FlagProfileParams!) {
    flagProfile(flagProfileParams: $flagProfileParams)
  }
`
export type FlagProfileMutationFn = Apollo.MutationFunction<FlagProfileMutation, FlagProfileMutationVariables>

/**
 * __useFlagProfileMutation__
 *
 * To run a mutation, you first call `useFlagProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFlagProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [flagProfileMutation, { data, loading, error }] = useFlagProfileMutation({
 *   variables: {
 *      flagProfileParams: // value for 'flagProfileParams'
 *   },
 * });
 */
export function useFlagProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<FlagProfileMutation, FlagProfileMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<FlagProfileMutation, FlagProfileMutationVariables>(FlagProfileDocument, options)
}
export type FlagProfileMutationHookResult = ReturnType<typeof useFlagProfileMutation>
export type FlagProfileMutationResult = Apollo.MutationResult<FlagProfileMutation>
export type FlagProfileMutationOptions = Apollo.BaseMutationOptions<FlagProfileMutation, FlagProfileMutationVariables>
export const ReviewFlaggedProfileDocument = gql`
  mutation reviewFlaggedProfile($reviewFlaggedProfileParams: ReviewFlaggedProfileParam!) {
    reviewFlaggedProfile(reviewFlaggedProfileParams: $reviewFlaggedProfileParams)
  }
`
export type ReviewFlaggedProfileMutationFn = Apollo.MutationFunction<
  ReviewFlaggedProfileMutation,
  ReviewFlaggedProfileMutationVariables
>

/**
 * __useReviewFlaggedProfileMutation__
 *
 * To run a mutation, you first call `useReviewFlaggedProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewFlaggedProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewFlaggedProfileMutation, { data, loading, error }] = useReviewFlaggedProfileMutation({
 *   variables: {
 *      reviewFlaggedProfileParams: // value for 'reviewFlaggedProfileParams'
 *   },
 * });
 */
export function useReviewFlaggedProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<ReviewFlaggedProfileMutation, ReviewFlaggedProfileMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<ReviewFlaggedProfileMutation, ReviewFlaggedProfileMutationVariables>(
    ReviewFlaggedProfileDocument,
    options
  )
}
export type ReviewFlaggedProfileMutationHookResult = ReturnType<typeof useReviewFlaggedProfileMutation>
export type ReviewFlaggedProfileMutationResult = Apollo.MutationResult<ReviewFlaggedProfileMutation>
export type ReviewFlaggedProfileMutationOptions = Apollo.BaseMutationOptions<
  ReviewFlaggedProfileMutation,
  ReviewFlaggedProfileMutationVariables
>
export const FreeNamespaceDocument = gql`
  mutation freeNamespace($freeNamespaceParams: FreeNamespaceParams!) {
    freeNamespace(freeNamespaceParams: $freeNamespaceParams)
  }
`
export type FreeNamespaceMutationFn = Apollo.MutationFunction<FreeNamespaceMutation, FreeNamespaceMutationVariables>

/**
 * __useFreeNamespaceMutation__
 *
 * To run a mutation, you first call `useFreeNamespaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFreeNamespaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [freeNamespaceMutation, { data, loading, error }] = useFreeNamespaceMutation({
 *   variables: {
 *      freeNamespaceParams: // value for 'freeNamespaceParams'
 *   },
 * });
 */
export function useFreeNamespaceMutation(
  baseOptions?: Apollo.MutationHookOptions<FreeNamespaceMutation, FreeNamespaceMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<FreeNamespaceMutation, FreeNamespaceMutationVariables>(FreeNamespaceDocument, options)
}
export type FreeNamespaceMutationHookResult = ReturnType<typeof useFreeNamespaceMutation>
export type FreeNamespaceMutationResult = Apollo.MutationResult<FreeNamespaceMutation>
export type FreeNamespaceMutationOptions = Apollo.BaseMutationOptions<
  FreeNamespaceMutation,
  FreeNamespaceMutationVariables
>
export const ReloadEnvironmentCacheDocument = gql`
  mutation reloadEnvironmentCache {
    reloadEnvironmentCache
  }
`
export type ReloadEnvironmentCacheMutationFn = Apollo.MutationFunction<
  ReloadEnvironmentCacheMutation,
  ReloadEnvironmentCacheMutationVariables
>

/**
 * __useReloadEnvironmentCacheMutation__
 *
 * To run a mutation, you first call `useReloadEnvironmentCacheMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReloadEnvironmentCacheMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reloadEnvironmentCacheMutation, { data, loading, error }] = useReloadEnvironmentCacheMutation({
 *   variables: {
 *   },
 * });
 */
export function useReloadEnvironmentCacheMutation(
  baseOptions?: Apollo.MutationHookOptions<ReloadEnvironmentCacheMutation, ReloadEnvironmentCacheMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<ReloadEnvironmentCacheMutation, ReloadEnvironmentCacheMutationVariables>(
    ReloadEnvironmentCacheDocument,
    options
  )
}
export type ReloadEnvironmentCacheMutationHookResult = ReturnType<typeof useReloadEnvironmentCacheMutation>
export type ReloadEnvironmentCacheMutationResult = Apollo.MutationResult<ReloadEnvironmentCacheMutation>
export type ReloadEnvironmentCacheMutationOptions = Apollo.BaseMutationOptions<
  ReloadEnvironmentCacheMutation,
  ReloadEnvironmentCacheMutationVariables
>
export const UpdateBioDocument = gql`
  mutation updateBio($bioParams: BioParams!) {
    updateBio(bioParams: $bioParams) {
      id
      bio
      twitterUsername
      tikTokUsername
      instagramUsername
      youtubeUrl
      etsyUsername
    }
  }
`
export type UpdateBioMutationFn = Apollo.MutationFunction<UpdateBioMutation, UpdateBioMutationVariables>

/**
 * __useUpdateBioMutation__
 *
 * To run a mutation, you first call `useUpdateBioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBioMutation, { data, loading, error }] = useUpdateBioMutation({
 *   variables: {
 *      bioParams: // value for 'bioParams'
 *   },
 * });
 */
export function useUpdateBioMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateBioMutation, UpdateBioMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<UpdateBioMutation, UpdateBioMutationVariables>(UpdateBioDocument, options)
}
export type UpdateBioMutationHookResult = ReturnType<typeof useUpdateBioMutation>
export type UpdateBioMutationResult = Apollo.MutationResult<UpdateBioMutation>
export type UpdateBioMutationOptions = Apollo.BaseMutationOptions<UpdateBioMutation, UpdateBioMutationVariables>
export const CreateMagicLinkDocument = gql`
  mutation createMagicLink($createMagicLinkParams: CreateMagicLinkParams!) {
    createMagicLink(createMagicLinkParams: $createMagicLinkParams)
  }
`
export type CreateMagicLinkMutationFn = Apollo.MutationFunction<
  CreateMagicLinkMutation,
  CreateMagicLinkMutationVariables
>

/**
 * __useCreateMagicLinkMutation__
 *
 * To run a mutation, you first call `useCreateMagicLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMagicLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMagicLinkMutation, { data, loading, error }] = useCreateMagicLinkMutation({
 *   variables: {
 *      createMagicLinkParams: // value for 'createMagicLinkParams'
 *   },
 * });
 */
export function useCreateMagicLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateMagicLinkMutation, CreateMagicLinkMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<CreateMagicLinkMutation, CreateMagicLinkMutationVariables>(CreateMagicLinkDocument, options)
}
export type CreateMagicLinkMutationHookResult = ReturnType<typeof useCreateMagicLinkMutation>
export type CreateMagicLinkMutationResult = Apollo.MutationResult<CreateMagicLinkMutation>
export type CreateMagicLinkMutationOptions = Apollo.BaseMutationOptions<
  CreateMagicLinkMutation,
  CreateMagicLinkMutationVariables
>
export const GetUserNotesDocument = gql`
  query getUserNotes($getNotesParams: UserNotesParameters!) {
    userNotes(userNotesParams: $getNotesParams) {
      ...galleryNoteInfo
    }
  }
  ${GalleryNoteInfoFragmentDoc}
`

/**
 * __useGetUserNotesQuery__
 *
 * To run a query within a React component, call `useGetUserNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserNotesQuery({
 *   variables: {
 *      getNotesParams: // value for 'getNotesParams'
 *   },
 * });
 */
export function useGetUserNotesQuery(
  baseOptions: Apollo.QueryHookOptions<GetUserNotesQuery, GetUserNotesQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetUserNotesQuery, GetUserNotesQueryVariables>(GetUserNotesDocument, options)
}
export function useGetUserNotesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserNotesQuery, GetUserNotesQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetUserNotesQuery, GetUserNotesQueryVariables>(GetUserNotesDocument, options)
}
export type GetUserNotesQueryHookResult = ReturnType<typeof useGetUserNotesQuery>
export type GetUserNotesLazyQueryHookResult = ReturnType<typeof useGetUserNotesLazyQuery>
export type GetUserNotesQueryResult = Apollo.QueryResult<GetUserNotesQuery, GetUserNotesQueryVariables>
export const GetUserFavoritedNotesDocument = gql`
  query getUserFavoritedNotes($getNotesParams: UserFavoritedNotesParameters!) {
    userFavoritedNotes(userNotesParams: $getNotesParams) {
      ...galleryNoteInfo
    }
  }
  ${GalleryNoteInfoFragmentDoc}
`

/**
 * __useGetUserFavoritedNotesQuery__
 *
 * To run a query within a React component, call `useGetUserFavoritedNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserFavoritedNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserFavoritedNotesQuery({
 *   variables: {
 *      getNotesParams: // value for 'getNotesParams'
 *   },
 * });
 */
export function useGetUserFavoritedNotesQuery(
  baseOptions: Apollo.QueryHookOptions<GetUserFavoritedNotesQuery, GetUserFavoritedNotesQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetUserFavoritedNotesQuery, GetUserFavoritedNotesQueryVariables>(
    GetUserFavoritedNotesDocument,
    options
  )
}
export function useGetUserFavoritedNotesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserFavoritedNotesQuery, GetUserFavoritedNotesQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetUserFavoritedNotesQuery, GetUserFavoritedNotesQueryVariables>(
    GetUserFavoritedNotesDocument,
    options
  )
}
export type GetUserFavoritedNotesQueryHookResult = ReturnType<typeof useGetUserFavoritedNotesQuery>
export type GetUserFavoritedNotesLazyQueryHookResult = ReturnType<typeof useGetUserFavoritedNotesLazyQuery>
export type GetUserFavoritedNotesQueryResult = Apollo.QueryResult<
  GetUserFavoritedNotesQuery,
  GetUserFavoritedNotesQueryVariables
>
export const GetUserDownloadedNotesDocument = gql`
  query getUserDownloadedNotes($getNotesParams: UserNotesParameters!) {
    userDownloadedNotes(userNotesParams: $getNotesParams) {
      ...galleryNoteInfo
    }
  }
  ${GalleryNoteInfoFragmentDoc}
`

/**
 * __useGetUserDownloadedNotesQuery__
 *
 * To run a query within a React component, call `useGetUserDownloadedNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDownloadedNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserDownloadedNotesQuery({
 *   variables: {
 *      getNotesParams: // value for 'getNotesParams'
 *   },
 * });
 */
export function useGetUserDownloadedNotesQuery(
  baseOptions: Apollo.QueryHookOptions<GetUserDownloadedNotesQuery, GetUserDownloadedNotesQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetUserDownloadedNotesQuery, GetUserDownloadedNotesQueryVariables>(
    GetUserDownloadedNotesDocument,
    options
  )
}
export function useGetUserDownloadedNotesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserDownloadedNotesQuery, GetUserDownloadedNotesQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetUserDownloadedNotesQuery, GetUserDownloadedNotesQueryVariables>(
    GetUserDownloadedNotesDocument,
    options
  )
}
export type GetUserDownloadedNotesQueryHookResult = ReturnType<typeof useGetUserDownloadedNotesQuery>
export type GetUserDownloadedNotesLazyQueryHookResult = ReturnType<typeof useGetUserDownloadedNotesLazyQuery>
export type GetUserDownloadedNotesQueryResult = Apollo.QueryResult<
  GetUserDownloadedNotesQuery,
  GetUserDownloadedNotesQueryVariables
>
export const EditNoteDocument = gql`
  mutation editNote($editNotesParams: EditParams!) {
    editNote(editParams: $editNotesParams) {
      id
      description
      language
      tags {
        name
      }
      contentType
      name
      commentsEnabled
      mentionedProfiles {
        screenname
        avatarUpdatedAt
        user {
          id
        }
      }
    }
  }
`
export type EditNoteMutationFn = Apollo.MutationFunction<EditNoteMutation, EditNoteMutationVariables>

/**
 * __useEditNoteMutation__
 *
 * To run a mutation, you first call `useEditNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editNoteMutation, { data, loading, error }] = useEditNoteMutation({
 *   variables: {
 *      editNotesParams: // value for 'editNotesParams'
 *   },
 * });
 */
export function useEditNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<EditNoteMutation, EditNoteMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<EditNoteMutation, EditNoteMutationVariables>(EditNoteDocument, options)
}
export type EditNoteMutationHookResult = ReturnType<typeof useEditNoteMutation>
export type EditNoteMutationResult = Apollo.MutationResult<EditNoteMutation>
export type EditNoteMutationOptions = Apollo.BaseMutationOptions<EditNoteMutation, EditNoteMutationVariables>
export const SetLanguageDocument = gql`
  mutation setLanguage($setLanguageParams: SetLanguageParams!) {
    setLanguage(languageParams: $setLanguageParams) {
      id
      language
    }
  }
`
export type SetLanguageMutationFn = Apollo.MutationFunction<SetLanguageMutation, SetLanguageMutationVariables>

/**
 * __useSetLanguageMutation__
 *
 * To run a mutation, you first call `useSetLanguageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetLanguageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setLanguageMutation, { data, loading, error }] = useSetLanguageMutation({
 *   variables: {
 *      setLanguageParams: // value for 'setLanguageParams'
 *   },
 * });
 */
export function useSetLanguageMutation(
  baseOptions?: Apollo.MutationHookOptions<SetLanguageMutation, SetLanguageMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<SetLanguageMutation, SetLanguageMutationVariables>(SetLanguageDocument, options)
}
export type SetLanguageMutationHookResult = ReturnType<typeof useSetLanguageMutation>
export type SetLanguageMutationResult = Apollo.MutationResult<SetLanguageMutation>
export type SetLanguageMutationOptions = Apollo.BaseMutationOptions<SetLanguageMutation, SetLanguageMutationVariables>
export const GalleryNoteSearchDocument = gql`
  query galleryNoteSearch($searchParams: SearchParams!) {
    galleryNoteSearch(searchParams: $searchParams) {
      ...galleryNoteInfo
      language
    }
  }
  ${GalleryNoteInfoFragmentDoc}
`

/**
 * __useGalleryNoteSearchQuery__
 *
 * To run a query within a React component, call `useGalleryNoteSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGalleryNoteSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGalleryNoteSearchQuery({
 *   variables: {
 *      searchParams: // value for 'searchParams'
 *   },
 * });
 */
export function useGalleryNoteSearchQuery(
  baseOptions: Apollo.QueryHookOptions<GalleryNoteSearchQuery, GalleryNoteSearchQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GalleryNoteSearchQuery, GalleryNoteSearchQueryVariables>(GalleryNoteSearchDocument, options)
}
export function useGalleryNoteSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GalleryNoteSearchQuery, GalleryNoteSearchQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GalleryNoteSearchQuery, GalleryNoteSearchQueryVariables>(
    GalleryNoteSearchDocument,
    options
  )
}
export type GalleryNoteSearchQueryHookResult = ReturnType<typeof useGalleryNoteSearchQuery>
export type GalleryNoteSearchLazyQueryHookResult = ReturnType<typeof useGalleryNoteSearchLazyQuery>
export type GalleryNoteSearchQueryResult = Apollo.QueryResult<GalleryNoteSearchQuery, GalleryNoteSearchQueryVariables>
export const TriageNoteDocument = gql`
  mutation triageNote($triageNoteParams: TriageNoteParams!) {
    triageNote(triageNoteParams: $triageNoteParams) {
      noteId
      triageState
    }
  }
`
export type TriageNoteMutationFn = Apollo.MutationFunction<TriageNoteMutation, TriageNoteMutationVariables>

/**
 * __useTriageNoteMutation__
 *
 * To run a mutation, you first call `useTriageNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriageNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triageNoteMutation, { data, loading, error }] = useTriageNoteMutation({
 *   variables: {
 *      triageNoteParams: // value for 'triageNoteParams'
 *   },
 * });
 */
export function useTriageNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<TriageNoteMutation, TriageNoteMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<TriageNoteMutation, TriageNoteMutationVariables>(TriageNoteDocument, options)
}
export type TriageNoteMutationHookResult = ReturnType<typeof useTriageNoteMutation>
export type TriageNoteMutationResult = Apollo.MutationResult<TriageNoteMutation>
export type TriageNoteMutationOptions = Apollo.BaseMutationOptions<TriageNoteMutation, TriageNoteMutationVariables>
export const TriageNoteSearchDocument = gql`
  query triageNoteSearch($triageSearchParams: TriageSearchParams!) {
    triageNoteSearch(triageSearchParams: $triageSearchParams) {
      totalCount
      results {
        ...galleryNoteInfo
      }
    }
  }
  ${GalleryNoteInfoFragmentDoc}
`

/**
 * __useTriageNoteSearchQuery__
 *
 * To run a query within a React component, call `useTriageNoteSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useTriageNoteSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTriageNoteSearchQuery({
 *   variables: {
 *      triageSearchParams: // value for 'triageSearchParams'
 *   },
 * });
 */
export function useTriageNoteSearchQuery(
  baseOptions: Apollo.QueryHookOptions<TriageNoteSearchQuery, TriageNoteSearchQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<TriageNoteSearchQuery, TriageNoteSearchQueryVariables>(TriageNoteSearchDocument, options)
}
export function useTriageNoteSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TriageNoteSearchQuery, TriageNoteSearchQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<TriageNoteSearchQuery, TriageNoteSearchQueryVariables>(TriageNoteSearchDocument, options)
}
export type TriageNoteSearchQueryHookResult = ReturnType<typeof useTriageNoteSearchQuery>
export type TriageNoteSearchLazyQueryHookResult = ReturnType<typeof useTriageNoteSearchLazyQuery>
export type TriageNoteSearchQueryResult = Apollo.QueryResult<TriageNoteSearchQuery, TriageNoteSearchQueryVariables>
export const HiddenProfilesDocument = gql`
  query hiddenProfiles($hiddenProfilesParams: HiddenProfilesParams!) {
    hiddenProfiles(hiddenProfilesParams: $hiddenProfilesParams) {
      totalCount
      results {
        id
        screenname
        user {
          id
          profile {
            screenname
          }
        }
      }
    }
  }
`

/**
 * __useHiddenProfilesQuery__
 *
 * To run a query within a React component, call `useHiddenProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHiddenProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHiddenProfilesQuery({
 *   variables: {
 *      hiddenProfilesParams: // value for 'hiddenProfilesParams'
 *   },
 * });
 */
export function useHiddenProfilesQuery(
  baseOptions: Apollo.QueryHookOptions<HiddenProfilesQuery, HiddenProfilesQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<HiddenProfilesQuery, HiddenProfilesQueryVariables>(HiddenProfilesDocument, options)
}
export function useHiddenProfilesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<HiddenProfilesQuery, HiddenProfilesQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<HiddenProfilesQuery, HiddenProfilesQueryVariables>(HiddenProfilesDocument, options)
}
export type HiddenProfilesQueryHookResult = ReturnType<typeof useHiddenProfilesQuery>
export type HiddenProfilesLazyQueryHookResult = ReturnType<typeof useHiddenProfilesLazyQuery>
export type HiddenProfilesQueryResult = Apollo.QueryResult<HiddenProfilesQuery, HiddenProfilesQueryVariables>
export const UnlikeNoteDocument = gql`
  mutation unlikeNote($unlikeNoteParams: LikeParams!) {
    unlikeNote(unlikeParams: $unlikeNoteParams) {
      id
    }
  }
`
export type UnlikeNoteMutationFn = Apollo.MutationFunction<UnlikeNoteMutation, UnlikeNoteMutationVariables>

/**
 * __useUnlikeNoteMutation__
 *
 * To run a mutation, you first call `useUnlikeNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlikeNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlikeNoteMutation, { data, loading, error }] = useUnlikeNoteMutation({
 *   variables: {
 *      unlikeNoteParams: // value for 'unlikeNoteParams'
 *   },
 * });
 */
export function useUnlikeNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<UnlikeNoteMutation, UnlikeNoteMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<UnlikeNoteMutation, UnlikeNoteMutationVariables>(UnlikeNoteDocument, options)
}
export type UnlikeNoteMutationHookResult = ReturnType<typeof useUnlikeNoteMutation>
export type UnlikeNoteMutationResult = Apollo.MutationResult<UnlikeNoteMutation>
export type UnlikeNoteMutationOptions = Apollo.BaseMutationOptions<UnlikeNoteMutation, UnlikeNoteMutationVariables>
export const PreparePublishDocument = gql`
  mutation preparePublish($publishParams: PublishParams!) {
    preparePublish(publishParams: $publishParams) {
      galleryNote {
        id
      }
      noteUploadPolicy
      pdfUploadPolicy
      imageUploadPolicies
    }
  }
`
export type PreparePublishMutationFn = Apollo.MutationFunction<PreparePublishMutation, PreparePublishMutationVariables>

/**
 * __usePreparePublishMutation__
 *
 * To run a mutation, you first call `usePreparePublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreparePublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [preparePublishMutation, { data, loading, error }] = usePreparePublishMutation({
 *   variables: {
 *      publishParams: // value for 'publishParams'
 *   },
 * });
 */
export function usePreparePublishMutation(
  baseOptions?: Apollo.MutationHookOptions<PreparePublishMutation, PreparePublishMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<PreparePublishMutation, PreparePublishMutationVariables>(PreparePublishDocument, options)
}
export type PreparePublishMutationHookResult = ReturnType<typeof usePreparePublishMutation>
export type PreparePublishMutationResult = Apollo.MutationResult<PreparePublishMutation>
export type PreparePublishMutationOptions = Apollo.BaseMutationOptions<
  PreparePublishMutation,
  PreparePublishMutationVariables
>
export const UnpublishDocument = gql`
  mutation unpublish($unpublishParams: UnpublishParams!) {
    unpublish(unpublishParams: $unpublishParams)
  }
`
export type UnpublishMutationFn = Apollo.MutationFunction<UnpublishMutation, UnpublishMutationVariables>

/**
 * __useUnpublishMutation__
 *
 * To run a mutation, you first call `useUnpublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpublishMutation, { data, loading, error }] = useUnpublishMutation({
 *   variables: {
 *      unpublishParams: // value for 'unpublishParams'
 *   },
 * });
 */
export function useUnpublishMutation(
  baseOptions?: Apollo.MutationHookOptions<UnpublishMutation, UnpublishMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<UnpublishMutation, UnpublishMutationVariables>(UnpublishDocument, options)
}
export type UnpublishMutationHookResult = ReturnType<typeof useUnpublishMutation>
export type UnpublishMutationResult = Apollo.MutationResult<UnpublishMutation>
export type UnpublishMutationOptions = Apollo.BaseMutationOptions<UnpublishMutation, UnpublishMutationVariables>
export const NoteViewedDocument = gql`
  mutation noteViewed($viewedNoteParams: ViewedNoteParameters!) {
    noteViewed(viewedNote: $viewedNoteParams)
  }
`
export type NoteViewedMutationFn = Apollo.MutationFunction<NoteViewedMutation, NoteViewedMutationVariables>

/**
 * __useNoteViewedMutation__
 *
 * To run a mutation, you first call `useNoteViewedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNoteViewedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [noteViewedMutation, { data, loading, error }] = useNoteViewedMutation({
 *   variables: {
 *      viewedNoteParams: // value for 'viewedNoteParams'
 *   },
 * });
 */
export function useNoteViewedMutation(
  baseOptions?: Apollo.MutationHookOptions<NoteViewedMutation, NoteViewedMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<NoteViewedMutation, NoteViewedMutationVariables>(NoteViewedDocument, options)
}
export type NoteViewedMutationHookResult = ReturnType<typeof useNoteViewedMutation>
export type NoteViewedMutationResult = Apollo.MutationResult<NoteViewedMutation>
export type NoteViewedMutationOptions = Apollo.BaseMutationOptions<NoteViewedMutation, NoteViewedMutationVariables>
export const FollowUserDocument = gql`
  mutation followUser($followParams: FollowParams!) {
    followUser(followParams: $followParams) {
      followedId
      followerId
      isFollowing
    }
  }
`
export type FollowUserMutationFn = Apollo.MutationFunction<FollowUserMutation, FollowUserMutationVariables>

/**
 * __useFollowUserMutation__
 *
 * To run a mutation, you first call `useFollowUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followUserMutation, { data, loading, error }] = useFollowUserMutation({
 *   variables: {
 *      followParams: // value for 'followParams'
 *   },
 * });
 */
export function useFollowUserMutation(
  baseOptions?: Apollo.MutationHookOptions<FollowUserMutation, FollowUserMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<FollowUserMutation, FollowUserMutationVariables>(FollowUserDocument, options)
}
export type FollowUserMutationHookResult = ReturnType<typeof useFollowUserMutation>
export type FollowUserMutationResult = Apollo.MutationResult<FollowUserMutation>
export type FollowUserMutationOptions = Apollo.BaseMutationOptions<FollowUserMutation, FollowUserMutationVariables>
export const UnfollowUserDocument = gql`
  mutation unfollowUser($unfollowParams: UnfollowParams!) {
    unfollowUser(unfollowParams: $unfollowParams) {
      followedId
      followerId
      isFollowing
    }
  }
`
export type UnfollowUserMutationFn = Apollo.MutationFunction<UnfollowUserMutation, UnfollowUserMutationVariables>

/**
 * __useUnfollowUserMutation__
 *
 * To run a mutation, you first call `useUnfollowUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnfollowUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unfollowUserMutation, { data, loading, error }] = useUnfollowUserMutation({
 *   variables: {
 *      unfollowParams: // value for 'unfollowParams'
 *   },
 * });
 */
export function useUnfollowUserMutation(
  baseOptions?: Apollo.MutationHookOptions<UnfollowUserMutation, UnfollowUserMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<UnfollowUserMutation, UnfollowUserMutationVariables>(UnfollowUserDocument, options)
}
export type UnfollowUserMutationHookResult = ReturnType<typeof useUnfollowUserMutation>
export type UnfollowUserMutationResult = Apollo.MutationResult<UnfollowUserMutation>
export type UnfollowUserMutationOptions = Apollo.BaseMutationOptions<
  UnfollowUserMutation,
  UnfollowUserMutationVariables
>
export const GetUserIsFollowedDocument = gql`
  query getUserIsFollowed($getUserIsFollowedParams: GetUserIsFollowedParams!) {
    getUserIsFollowed(getUserIsFollowedParams: $getUserIsFollowedParams) {
      followedId
      followerId
      isFollowing
    }
  }
`

/**
 * __useGetUserIsFollowedQuery__
 *
 * To run a query within a React component, call `useGetUserIsFollowedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserIsFollowedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserIsFollowedQuery({
 *   variables: {
 *      getUserIsFollowedParams: // value for 'getUserIsFollowedParams'
 *   },
 * });
 */
export function useGetUserIsFollowedQuery(
  baseOptions: Apollo.QueryHookOptions<GetUserIsFollowedQuery, GetUserIsFollowedQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetUserIsFollowedQuery, GetUserIsFollowedQueryVariables>(GetUserIsFollowedDocument, options)
}
export function useGetUserIsFollowedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserIsFollowedQuery, GetUserIsFollowedQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetUserIsFollowedQuery, GetUserIsFollowedQueryVariables>(
    GetUserIsFollowedDocument,
    options
  )
}
export type GetUserIsFollowedQueryHookResult = ReturnType<typeof useGetUserIsFollowedQuery>
export type GetUserIsFollowedLazyQueryHookResult = ReturnType<typeof useGetUserIsFollowedLazyQuery>
export type GetUserIsFollowedQueryResult = Apollo.QueryResult<GetUserIsFollowedQuery, GetUserIsFollowedQueryVariables>
export const AdminGetUserDataDocument = gql`
  query adminGetUserData($adminGetUserDataParams: AdminGetUserDataParams!) {
    adminGetUserData(adminGetUserDataParams: $adminGetUserDataParams) {
      id
      name
      email
      emailVerifiedAt
      isAdmin
      isBlocked
      bestAvailableSubscription {
        tier
      }
      baseSubscription {
        tier
      }
      numComments
      numHiddenComments
      subscriptions {
        originalTransactionId
        originalPurchaseDate
        productId
        expirationDate
        status
        isTrialPeriod
        isInIntroOfferPeriod
        refundedDate
        refundedReason
        deviceLimitEnforcementEnabled
        overDeviceLimit
        gracePeriodExpiresAt
        expirationIntent
        isInBillingRetryPeriod
        tier
      }
      subscriptionOverrides {
        id
        createdAt
        expirationDate
        overrideTier
        overrideReason
        createdBy {
          email
        }
      }
      classicStatus {
        id
        originalApplicationVersion
        originalPurchaseDate
        deviceId
        likelyFraud
        createdAt
        updatedAt
      }
      profile {
        screenname
        ignoreFlagging
      }
    }
  }
`

/**
 * __useAdminGetUserDataQuery__
 *
 * To run a query within a React component, call `useAdminGetUserDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetUserDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetUserDataQuery({
 *   variables: {
 *      adminGetUserDataParams: // value for 'adminGetUserDataParams'
 *   },
 * });
 */
export function useAdminGetUserDataQuery(
  baseOptions: Apollo.QueryHookOptions<AdminGetUserDataQuery, AdminGetUserDataQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<AdminGetUserDataQuery, AdminGetUserDataQueryVariables>(AdminGetUserDataDocument, options)
}
export function useAdminGetUserDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AdminGetUserDataQuery, AdminGetUserDataQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<AdminGetUserDataQuery, AdminGetUserDataQueryVariables>(AdminGetUserDataDocument, options)
}
export type AdminGetUserDataQueryHookResult = ReturnType<typeof useAdminGetUserDataQuery>
export type AdminGetUserDataLazyQueryHookResult = ReturnType<typeof useAdminGetUserDataLazyQuery>
export type AdminGetUserDataQueryResult = Apollo.QueryResult<AdminGetUserDataQuery, AdminGetUserDataQueryVariables>
export const GetUserAdminEventsDocument = gql`
  query getUserAdminEvents($adminEventSearchParams: AdminEventSearchParams!) {
    getUserAdminEvents(adminEventSearchParams: $adminEventSearchParams) {
      id
      eventType
      createdAt
      systemNotes
      triggeringUserEmail
      triggeringUserNotes
    }
  }
`

/**
 * __useGetUserAdminEventsQuery__
 *
 * To run a query within a React component, call `useGetUserAdminEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAdminEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAdminEventsQuery({
 *   variables: {
 *      adminEventSearchParams: // value for 'adminEventSearchParams'
 *   },
 * });
 */
export function useGetUserAdminEventsQuery(
  baseOptions: Apollo.QueryHookOptions<GetUserAdminEventsQuery, GetUserAdminEventsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetUserAdminEventsQuery, GetUserAdminEventsQueryVariables>(GetUserAdminEventsDocument, options)
}
export function useGetUserAdminEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserAdminEventsQuery, GetUserAdminEventsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetUserAdminEventsQuery, GetUserAdminEventsQueryVariables>(
    GetUserAdminEventsDocument,
    options
  )
}
export type GetUserAdminEventsQueryHookResult = ReturnType<typeof useGetUserAdminEventsQuery>
export type GetUserAdminEventsLazyQueryHookResult = ReturnType<typeof useGetUserAdminEventsLazyQuery>
export type GetUserAdminEventsQueryResult = Apollo.QueryResult<
  GetUserAdminEventsQuery,
  GetUserAdminEventsQueryVariables
>
export const GetUserNoteAdminEventsDocument = gql`
  query getUserNoteAdminEvents($adminEventSearchParams: AdminEventSearchParams!) {
    getUserNoteAdminEvents(adminEventSearchParams: $adminEventSearchParams) {
      id
      eventType
      createdAt
      systemNotes
      triggeringUserEmail
      triggeringUserNotes
      galleryNote {
        ...galleryNoteInfo
      }
      flaggedReason
    }
  }
  ${GalleryNoteInfoFragmentDoc}
`

/**
 * __useGetUserNoteAdminEventsQuery__
 *
 * To run a query within a React component, call `useGetUserNoteAdminEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserNoteAdminEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserNoteAdminEventsQuery({
 *   variables: {
 *      adminEventSearchParams: // value for 'adminEventSearchParams'
 *   },
 * });
 */
export function useGetUserNoteAdminEventsQuery(
  baseOptions: Apollo.QueryHookOptions<GetUserNoteAdminEventsQuery, GetUserNoteAdminEventsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetUserNoteAdminEventsQuery, GetUserNoteAdminEventsQueryVariables>(
    GetUserNoteAdminEventsDocument,
    options
  )
}
export function useGetUserNoteAdminEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserNoteAdminEventsQuery, GetUserNoteAdminEventsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetUserNoteAdminEventsQuery, GetUserNoteAdminEventsQueryVariables>(
    GetUserNoteAdminEventsDocument,
    options
  )
}
export type GetUserNoteAdminEventsQueryHookResult = ReturnType<typeof useGetUserNoteAdminEventsQuery>
export type GetUserNoteAdminEventsLazyQueryHookResult = ReturnType<typeof useGetUserNoteAdminEventsLazyQuery>
export type GetUserNoteAdminEventsQueryResult = Apollo.QueryResult<
  GetUserNoteAdminEventsQuery,
  GetUserNoteAdminEventsQueryVariables
>
export const GetPublishersFollowedByUserDocument = gql`
  query getPublishersFollowedByUser($followingUsersParameters: FollowingUsersParameters!) {
    getPublishersFollowedByUser(followingUsersParameters: $followingUsersParameters) {
      id
      profile {
        screenname
        avatarUpdatedAt
      }
    }
  }
`

/**
 * __useGetPublishersFollowedByUserQuery__
 *
 * To run a query within a React component, call `useGetPublishersFollowedByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublishersFollowedByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublishersFollowedByUserQuery({
 *   variables: {
 *      followingUsersParameters: // value for 'followingUsersParameters'
 *   },
 * });
 */
export function useGetPublishersFollowedByUserQuery(
  baseOptions: Apollo.QueryHookOptions<GetPublishersFollowedByUserQuery, GetPublishersFollowedByUserQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetPublishersFollowedByUserQuery, GetPublishersFollowedByUserQueryVariables>(
    GetPublishersFollowedByUserDocument,
    options
  )
}
export function useGetPublishersFollowedByUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPublishersFollowedByUserQuery, GetPublishersFollowedByUserQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetPublishersFollowedByUserQuery, GetPublishersFollowedByUserQueryVariables>(
    GetPublishersFollowedByUserDocument,
    options
  )
}
export type GetPublishersFollowedByUserQueryHookResult = ReturnType<typeof useGetPublishersFollowedByUserQuery>
export type GetPublishersFollowedByUserLazyQueryHookResult = ReturnType<typeof useGetPublishersFollowedByUserLazyQuery>
export type GetPublishersFollowedByUserQueryResult = Apollo.QueryResult<
  GetPublishersFollowedByUserQuery,
  GetPublishersFollowedByUserQueryVariables
>
export const GetUsersFollowingPublisherDocument = gql`
  query getUsersFollowingPublisher($followingUsersParameters: FollowingUsersParameters!) {
    getUsersFollowingPublisher(followingUsersParameters: $followingUsersParameters) {
      id
      profile {
        screenname
        avatarUpdatedAt
      }
    }
  }
`

/**
 * __useGetUsersFollowingPublisherQuery__
 *
 * To run a query within a React component, call `useGetUsersFollowingPublisherQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersFollowingPublisherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersFollowingPublisherQuery({
 *   variables: {
 *      followingUsersParameters: // value for 'followingUsersParameters'
 *   },
 * });
 */
export function useGetUsersFollowingPublisherQuery(
  baseOptions: Apollo.QueryHookOptions<GetUsersFollowingPublisherQuery, GetUsersFollowingPublisherQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetUsersFollowingPublisherQuery, GetUsersFollowingPublisherQueryVariables>(
    GetUsersFollowingPublisherDocument,
    options
  )
}
export function useGetUsersFollowingPublisherLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUsersFollowingPublisherQuery, GetUsersFollowingPublisherQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetUsersFollowingPublisherQuery, GetUsersFollowingPublisherQueryVariables>(
    GetUsersFollowingPublisherDocument,
    options
  )
}
export type GetUsersFollowingPublisherQueryHookResult = ReturnType<typeof useGetUsersFollowingPublisherQuery>
export type GetUsersFollowingPublisherLazyQueryHookResult = ReturnType<typeof useGetUsersFollowingPublisherLazyQuery>
export type GetUsersFollowingPublisherQueryResult = Apollo.QueryResult<
  GetUsersFollowingPublisherQuery,
  GetUsersFollowingPublisherQueryVariables
>
export const GetUsersWhoLikedNoteDocument = gql`
  query getUsersWhoLikedNote($likingUsersParameters: LikingUsersParameters!) {
    getUsersWhoLikedNote(likingUsersParameters: $likingUsersParameters) {
      id
      profile {
        screenname
        avatarUpdatedAt
      }
    }
  }
`

/**
 * __useGetUsersWhoLikedNoteQuery__
 *
 * To run a query within a React component, call `useGetUsersWhoLikedNoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersWhoLikedNoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersWhoLikedNoteQuery({
 *   variables: {
 *      likingUsersParameters: // value for 'likingUsersParameters'
 *   },
 * });
 */
export function useGetUsersWhoLikedNoteQuery(
  baseOptions: Apollo.QueryHookOptions<GetUsersWhoLikedNoteQuery, GetUsersWhoLikedNoteQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetUsersWhoLikedNoteQuery, GetUsersWhoLikedNoteQueryVariables>(
    GetUsersWhoLikedNoteDocument,
    options
  )
}
export function useGetUsersWhoLikedNoteLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUsersWhoLikedNoteQuery, GetUsersWhoLikedNoteQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetUsersWhoLikedNoteQuery, GetUsersWhoLikedNoteQueryVariables>(
    GetUsersWhoLikedNoteDocument,
    options
  )
}
export type GetUsersWhoLikedNoteQueryHookResult = ReturnType<typeof useGetUsersWhoLikedNoteQuery>
export type GetUsersWhoLikedNoteLazyQueryHookResult = ReturnType<typeof useGetUsersWhoLikedNoteLazyQuery>
export type GetUsersWhoLikedNoteQueryResult = Apollo.QueryResult<
  GetUsersWhoLikedNoteQuery,
  GetUsersWhoLikedNoteQueryVariables
>
export const GetNoteRendererDataDocument = gql`
  query getNoteRendererData($noteRendererParams: NoteRendererParams!) {
    getNoteRendererData(noteRendererParams: $noteRendererParams) {
      data
    }
  }
`

/**
 * __useGetNoteRendererDataQuery__
 *
 * To run a query within a React component, call `useGetNoteRendererDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNoteRendererDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNoteRendererDataQuery({
 *   variables: {
 *      noteRendererParams: // value for 'noteRendererParams'
 *   },
 * });
 */
export function useGetNoteRendererDataQuery(
  baseOptions: Apollo.QueryHookOptions<GetNoteRendererDataQuery, GetNoteRendererDataQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetNoteRendererDataQuery, GetNoteRendererDataQueryVariables>(
    GetNoteRendererDataDocument,
    options
  )
}
export function useGetNoteRendererDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetNoteRendererDataQuery, GetNoteRendererDataQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetNoteRendererDataQuery, GetNoteRendererDataQueryVariables>(
    GetNoteRendererDataDocument,
    options
  )
}
export type GetNoteRendererDataQueryHookResult = ReturnType<typeof useGetNoteRendererDataQuery>
export type GetNoteRendererDataLazyQueryHookResult = ReturnType<typeof useGetNoteRendererDataLazyQuery>
export type GetNoteRendererDataQueryResult = Apollo.QueryResult<
  GetNoteRendererDataQuery,
  GetNoteRendererDataQueryVariables
>
export const GetQuestionableNoteContentDocument = gql`
  query getQuestionableNoteContent($questionableNoteContentParams: QuestionableNoteContentParams!) {
    getQuestionableNoteContent(questionableNoteContentParams: $questionableNoteContentParams) {
      reason
      origin
      content {
        flaggedTerm
        context
      }
    }
  }
`

/**
 * __useGetQuestionableNoteContentQuery__
 *
 * To run a query within a React component, call `useGetQuestionableNoteContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionableNoteContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionableNoteContentQuery({
 *   variables: {
 *      questionableNoteContentParams: // value for 'questionableNoteContentParams'
 *   },
 * });
 */
export function useGetQuestionableNoteContentQuery(
  baseOptions: Apollo.QueryHookOptions<GetQuestionableNoteContentQuery, GetQuestionableNoteContentQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetQuestionableNoteContentQuery, GetQuestionableNoteContentQueryVariables>(
    GetQuestionableNoteContentDocument,
    options
  )
}
export function useGetQuestionableNoteContentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetQuestionableNoteContentQuery, GetQuestionableNoteContentQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetQuestionableNoteContentQuery, GetQuestionableNoteContentQueryVariables>(
    GetQuestionableNoteContentDocument,
    options
  )
}
export type GetQuestionableNoteContentQueryHookResult = ReturnType<typeof useGetQuestionableNoteContentQuery>
export type GetQuestionableNoteContentLazyQueryHookResult = ReturnType<typeof useGetQuestionableNoteContentLazyQuery>
export type GetQuestionableNoteContentQueryResult = Apollo.QueryResult<
  GetQuestionableNoteContentQuery,
  GetQuestionableNoteContentQueryVariables
>
export const MarkFeedAsViewedDocument = gql`
  mutation markFeedAsViewed($markFeedAsViewedParams: MarkFeedAsViewedParams!) {
    markFeedAsViewed(markFeedAsViewedParams: $markFeedAsViewedParams)
  }
`
export type MarkFeedAsViewedMutationFn = Apollo.MutationFunction<
  MarkFeedAsViewedMutation,
  MarkFeedAsViewedMutationVariables
>

/**
 * __useMarkFeedAsViewedMutation__
 *
 * To run a mutation, you first call `useMarkFeedAsViewedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkFeedAsViewedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markFeedAsViewedMutation, { data, loading, error }] = useMarkFeedAsViewedMutation({
 *   variables: {
 *      markFeedAsViewedParams: // value for 'markFeedAsViewedParams'
 *   },
 * });
 */
export function useMarkFeedAsViewedMutation(
  baseOptions?: Apollo.MutationHookOptions<MarkFeedAsViewedMutation, MarkFeedAsViewedMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<MarkFeedAsViewedMutation, MarkFeedAsViewedMutationVariables>(
    MarkFeedAsViewedDocument,
    options
  )
}
export type MarkFeedAsViewedMutationHookResult = ReturnType<typeof useMarkFeedAsViewedMutation>
export type MarkFeedAsViewedMutationResult = Apollo.MutationResult<MarkFeedAsViewedMutation>
export type MarkFeedAsViewedMutationOptions = Apollo.BaseMutationOptions<
  MarkFeedAsViewedMutation,
  MarkFeedAsViewedMutationVariables
>
export const UpdateCookiesDocument = gql`
  mutation updateCookies($updateCookiesParams: UpdateCookiesParams!) {
    updateCookies(updateCookiesParams: $updateCookiesParams)
  }
`
export type UpdateCookiesMutationFn = Apollo.MutationFunction<UpdateCookiesMutation, UpdateCookiesMutationVariables>

/**
 * __useUpdateCookiesMutation__
 *
 * To run a mutation, you first call `useUpdateCookiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCookiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCookiesMutation, { data, loading, error }] = useUpdateCookiesMutation({
 *   variables: {
 *      updateCookiesParams: // value for 'updateCookiesParams'
 *   },
 * });
 */
export function useUpdateCookiesMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateCookiesMutation, UpdateCookiesMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<UpdateCookiesMutation, UpdateCookiesMutationVariables>(UpdateCookiesDocument, options)
}
export type UpdateCookiesMutationHookResult = ReturnType<typeof useUpdateCookiesMutation>
export type UpdateCookiesMutationResult = Apollo.MutationResult<UpdateCookiesMutation>
export type UpdateCookiesMutationOptions = Apollo.BaseMutationOptions<
  UpdateCookiesMutation,
  UpdateCookiesMutationVariables
>
export const ChangeScreennameDocument = gql`
  mutation changeScreenname($changeScreennameParams: ChangeScreennameParams!) {
    changeScreenname(changeScreennameParams: $changeScreennameParams)
  }
`
export type ChangeScreennameMutationFn = Apollo.MutationFunction<
  ChangeScreennameMutation,
  ChangeScreennameMutationVariables
>

/**
 * __useChangeScreennameMutation__
 *
 * To run a mutation, you first call `useChangeScreennameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeScreennameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeScreennameMutation, { data, loading, error }] = useChangeScreennameMutation({
 *   variables: {
 *      changeScreennameParams: // value for 'changeScreennameParams'
 *   },
 * });
 */
export function useChangeScreennameMutation(
  baseOptions?: Apollo.MutationHookOptions<ChangeScreennameMutation, ChangeScreennameMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<ChangeScreennameMutation, ChangeScreennameMutationVariables>(
    ChangeScreennameDocument,
    options
  )
}
export type ChangeScreennameMutationHookResult = ReturnType<typeof useChangeScreennameMutation>
export type ChangeScreennameMutationResult = Apollo.MutationResult<ChangeScreennameMutation>
export type ChangeScreennameMutationOptions = Apollo.BaseMutationOptions<
  ChangeScreennameMutation,
  ChangeScreennameMutationVariables
>
export const ChangeEmailDocument = gql`
  mutation changeEmail($changeEmailParams: ChangeEmailParams!) {
    changeEmail(changeEmailParams: $changeEmailParams)
  }
`
export type ChangeEmailMutationFn = Apollo.MutationFunction<ChangeEmailMutation, ChangeEmailMutationVariables>

/**
 * __useChangeEmailMutation__
 *
 * To run a mutation, you first call `useChangeEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeEmailMutation, { data, loading, error }] = useChangeEmailMutation({
 *   variables: {
 *      changeEmailParams: // value for 'changeEmailParams'
 *   },
 * });
 */
export function useChangeEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<ChangeEmailMutation, ChangeEmailMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<ChangeEmailMutation, ChangeEmailMutationVariables>(ChangeEmailDocument, options)
}
export type ChangeEmailMutationHookResult = ReturnType<typeof useChangeEmailMutation>
export type ChangeEmailMutationResult = Apollo.MutationResult<ChangeEmailMutation>
export type ChangeEmailMutationOptions = Apollo.BaseMutationOptions<ChangeEmailMutation, ChangeEmailMutationVariables>
export const ChangeAdminStatusDocument = gql`
  mutation changeAdminStatus($changeAdminStatusParams: ChangeAdminStatusParams!) {
    changeAdminStatus(changeAdminStatusParams: $changeAdminStatusParams)
  }
`
export type ChangeAdminStatusMutationFn = Apollo.MutationFunction<
  ChangeAdminStatusMutation,
  ChangeAdminStatusMutationVariables
>

/**
 * __useChangeAdminStatusMutation__
 *
 * To run a mutation, you first call `useChangeAdminStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeAdminStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeAdminStatusMutation, { data, loading, error }] = useChangeAdminStatusMutation({
 *   variables: {
 *      changeAdminStatusParams: // value for 'changeAdminStatusParams'
 *   },
 * });
 */
export function useChangeAdminStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<ChangeAdminStatusMutation, ChangeAdminStatusMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<ChangeAdminStatusMutation, ChangeAdminStatusMutationVariables>(
    ChangeAdminStatusDocument,
    options
  )
}
export type ChangeAdminStatusMutationHookResult = ReturnType<typeof useChangeAdminStatusMutation>
export type ChangeAdminStatusMutationResult = Apollo.MutationResult<ChangeAdminStatusMutation>
export type ChangeAdminStatusMutationOptions = Apollo.BaseMutationOptions<
  ChangeAdminStatusMutation,
  ChangeAdminStatusMutationVariables
>
export const ChangeBlockStatusDocument = gql`
  mutation changeBlockStatus($changeBlockStatusParams: ChangeBlockStatusParams!) {
    changeBlockStatus(changeBlockStatusParams: $changeBlockStatusParams)
  }
`
export type ChangeBlockStatusMutationFn = Apollo.MutationFunction<
  ChangeBlockStatusMutation,
  ChangeBlockStatusMutationVariables
>

/**
 * __useChangeBlockStatusMutation__
 *
 * To run a mutation, you first call `useChangeBlockStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeBlockStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeBlockStatusMutation, { data, loading, error }] = useChangeBlockStatusMutation({
 *   variables: {
 *      changeBlockStatusParams: // value for 'changeBlockStatusParams'
 *   },
 * });
 */
export function useChangeBlockStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<ChangeBlockStatusMutation, ChangeBlockStatusMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<ChangeBlockStatusMutation, ChangeBlockStatusMutationVariables>(
    ChangeBlockStatusDocument,
    options
  )
}
export type ChangeBlockStatusMutationHookResult = ReturnType<typeof useChangeBlockStatusMutation>
export type ChangeBlockStatusMutationResult = Apollo.MutationResult<ChangeBlockStatusMutation>
export type ChangeBlockStatusMutationOptions = Apollo.BaseMutationOptions<
  ChangeBlockStatusMutation,
  ChangeBlockStatusMutationVariables
>
export const GetFuzzyScreennameMatchesDocument = gql`
  query getFuzzyScreennameMatches($getFuzzyScreennameMatchesParams: GetFuzzyScreennameMatchesParams!) {
    getFuzzyScreennameMatches(getFuzzyScreennameMatchesParams: $getFuzzyScreennameMatchesParams)
  }
`

/**
 * __useGetFuzzyScreennameMatchesQuery__
 *
 * To run a query within a React component, call `useGetFuzzyScreennameMatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFuzzyScreennameMatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFuzzyScreennameMatchesQuery({
 *   variables: {
 *      getFuzzyScreennameMatchesParams: // value for 'getFuzzyScreennameMatchesParams'
 *   },
 * });
 */
export function useGetFuzzyScreennameMatchesQuery(
  baseOptions: Apollo.QueryHookOptions<GetFuzzyScreennameMatchesQuery, GetFuzzyScreennameMatchesQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetFuzzyScreennameMatchesQuery, GetFuzzyScreennameMatchesQueryVariables>(
    GetFuzzyScreennameMatchesDocument,
    options
  )
}
export function useGetFuzzyScreennameMatchesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetFuzzyScreennameMatchesQuery, GetFuzzyScreennameMatchesQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetFuzzyScreennameMatchesQuery, GetFuzzyScreennameMatchesQueryVariables>(
    GetFuzzyScreennameMatchesDocument,
    options
  )
}
export type GetFuzzyScreennameMatchesQueryHookResult = ReturnType<typeof useGetFuzzyScreennameMatchesQuery>
export type GetFuzzyScreennameMatchesLazyQueryHookResult = ReturnType<typeof useGetFuzzyScreennameMatchesLazyQuery>
export type GetFuzzyScreennameMatchesQueryResult = Apollo.QueryResult<
  GetFuzzyScreennameMatchesQuery,
  GetFuzzyScreennameMatchesQueryVariables
>
export const AdminFuzzyUserSearchDocument = gql`
  query adminFuzzyUserSearch($adminFuzzyUserSearchParams: AdminFuzzyUserSearchParams!) {
    adminFuzzyUserSearch(adminFuzzyUserSearchParams: $adminFuzzyUserSearchParams)
  }
`

/**
 * __useAdminFuzzyUserSearchQuery__
 *
 * To run a query within a React component, call `useAdminFuzzyUserSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminFuzzyUserSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminFuzzyUserSearchQuery({
 *   variables: {
 *      adminFuzzyUserSearchParams: // value for 'adminFuzzyUserSearchParams'
 *   },
 * });
 */
export function useAdminFuzzyUserSearchQuery(
  baseOptions: Apollo.QueryHookOptions<AdminFuzzyUserSearchQuery, AdminFuzzyUserSearchQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<AdminFuzzyUserSearchQuery, AdminFuzzyUserSearchQueryVariables>(
    AdminFuzzyUserSearchDocument,
    options
  )
}
export function useAdminFuzzyUserSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AdminFuzzyUserSearchQuery, AdminFuzzyUserSearchQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<AdminFuzzyUserSearchQuery, AdminFuzzyUserSearchQueryVariables>(
    AdminFuzzyUserSearchDocument,
    options
  )
}
export type AdminFuzzyUserSearchQueryHookResult = ReturnType<typeof useAdminFuzzyUserSearchQuery>
export type AdminFuzzyUserSearchLazyQueryHookResult = ReturnType<typeof useAdminFuzzyUserSearchLazyQuery>
export type AdminFuzzyUserSearchQueryResult = Apollo.QueryResult<
  AdminFuzzyUserSearchQuery,
  AdminFuzzyUserSearchQueryVariables
>
export const GetNotificationsDocument = gql`
  query getNotifications($getNotificationsParams: GetNotificationsParams!) {
    getNotifications(getNotificationsParams: $getNotificationsParams) {
      id
      type
      seen
      eventCount
      createdAt
      lastNotificationActionAt
      galleryNote {
        id
        name
        previewImages
      }
      promoNotification {
        translationKey
        href
      }
      notificationEvents {
        id
        triggeringUser {
          id
          profile {
            screenname
            avatarUpdatedAt
          }
        }
      }
    }
  }
`

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *      getNotificationsParams: // value for 'getNotificationsParams'
 *   },
 * });
 */
export function useGetNotificationsQuery(
  baseOptions: Apollo.QueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options)
}
export function useGetNotificationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options)
}
export type GetNotificationsQueryHookResult = ReturnType<typeof useGetNotificationsQuery>
export type GetNotificationsLazyQueryHookResult = ReturnType<typeof useGetNotificationsLazyQuery>
export type GetNotificationsQueryResult = Apollo.QueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>
export const MarkNotificationsSeenDocument = gql`
  mutation markNotificationsSeen($markNotificationsSeenParams: MarkNotificationsSeenParams!) {
    markNotificationsSeen(markNotificationsSeenParams: $markNotificationsSeenParams)
  }
`
export type MarkNotificationsSeenMutationFn = Apollo.MutationFunction<
  MarkNotificationsSeenMutation,
  MarkNotificationsSeenMutationVariables
>

/**
 * __useMarkNotificationsSeenMutation__
 *
 * To run a mutation, you first call `useMarkNotificationsSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationsSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationsSeenMutation, { data, loading, error }] = useMarkNotificationsSeenMutation({
 *   variables: {
 *      markNotificationsSeenParams: // value for 'markNotificationsSeenParams'
 *   },
 * });
 */
export function useMarkNotificationsSeenMutation(
  baseOptions?: Apollo.MutationHookOptions<MarkNotificationsSeenMutation, MarkNotificationsSeenMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<MarkNotificationsSeenMutation, MarkNotificationsSeenMutationVariables>(
    MarkNotificationsSeenDocument,
    options
  )
}
export type MarkNotificationsSeenMutationHookResult = ReturnType<typeof useMarkNotificationsSeenMutation>
export type MarkNotificationsSeenMutationResult = Apollo.MutationResult<MarkNotificationsSeenMutation>
export type MarkNotificationsSeenMutationOptions = Apollo.BaseMutationOptions<
  MarkNotificationsSeenMutation,
  MarkNotificationsSeenMutationVariables
>
export const CreatePromoNotificationDocument = gql`
  mutation createPromoNotification($promoNotificationParams: PromoNotificationParams!) {
    createPromoNotification(promoNotificationParams: $promoNotificationParams) {
      ...promoNotification
    }
  }
  ${PromoNotificationFragmentDoc}
`
export type CreatePromoNotificationMutationFn = Apollo.MutationFunction<
  CreatePromoNotificationMutation,
  CreatePromoNotificationMutationVariables
>

/**
 * __useCreatePromoNotificationMutation__
 *
 * To run a mutation, you first call `useCreatePromoNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePromoNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPromoNotificationMutation, { data, loading, error }] = useCreatePromoNotificationMutation({
 *   variables: {
 *      promoNotificationParams: // value for 'promoNotificationParams'
 *   },
 * });
 */
export function useCreatePromoNotificationMutation(
  baseOptions?: Apollo.MutationHookOptions<CreatePromoNotificationMutation, CreatePromoNotificationMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<CreatePromoNotificationMutation, CreatePromoNotificationMutationVariables>(
    CreatePromoNotificationDocument,
    options
  )
}
export type CreatePromoNotificationMutationHookResult = ReturnType<typeof useCreatePromoNotificationMutation>
export type CreatePromoNotificationMutationResult = Apollo.MutationResult<CreatePromoNotificationMutation>
export type CreatePromoNotificationMutationOptions = Apollo.BaseMutationOptions<
  CreatePromoNotificationMutation,
  CreatePromoNotificationMutationVariables
>
export const DeletePromoNotificationDocument = gql`
  mutation deletePromoNotification($deletePromoParams: DeletePromoParams!) {
    deletePromoNotification(deletePromoParams: $deletePromoParams)
  }
`
export type DeletePromoNotificationMutationFn = Apollo.MutationFunction<
  DeletePromoNotificationMutation,
  DeletePromoNotificationMutationVariables
>

/**
 * __useDeletePromoNotificationMutation__
 *
 * To run a mutation, you first call `useDeletePromoNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePromoNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePromoNotificationMutation, { data, loading, error }] = useDeletePromoNotificationMutation({
 *   variables: {
 *      deletePromoParams: // value for 'deletePromoParams'
 *   },
 * });
 */
export function useDeletePromoNotificationMutation(
  baseOptions?: Apollo.MutationHookOptions<DeletePromoNotificationMutation, DeletePromoNotificationMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<DeletePromoNotificationMutation, DeletePromoNotificationMutationVariables>(
    DeletePromoNotificationDocument,
    options
  )
}
export type DeletePromoNotificationMutationHookResult = ReturnType<typeof useDeletePromoNotificationMutation>
export type DeletePromoNotificationMutationResult = Apollo.MutationResult<DeletePromoNotificationMutation>
export type DeletePromoNotificationMutationOptions = Apollo.BaseMutationOptions<
  DeletePromoNotificationMutation,
  DeletePromoNotificationMutationVariables
>
export const EditPromoNotificationDocument = gql`
  mutation editPromoNotification($promoNotificationParams: PromoNotificationParams!) {
    editPromoNotification(promoNotificationParams: $promoNotificationParams) {
      ...promoNotification
    }
  }
  ${PromoNotificationFragmentDoc}
`
export type EditPromoNotificationMutationFn = Apollo.MutationFunction<
  EditPromoNotificationMutation,
  EditPromoNotificationMutationVariables
>

/**
 * __useEditPromoNotificationMutation__
 *
 * To run a mutation, you first call `useEditPromoNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPromoNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPromoNotificationMutation, { data, loading, error }] = useEditPromoNotificationMutation({
 *   variables: {
 *      promoNotificationParams: // value for 'promoNotificationParams'
 *   },
 * });
 */
export function useEditPromoNotificationMutation(
  baseOptions?: Apollo.MutationHookOptions<EditPromoNotificationMutation, EditPromoNotificationMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<EditPromoNotificationMutation, EditPromoNotificationMutationVariables>(
    EditPromoNotificationDocument,
    options
  )
}
export type EditPromoNotificationMutationHookResult = ReturnType<typeof useEditPromoNotificationMutation>
export type EditPromoNotificationMutationResult = Apollo.MutationResult<EditPromoNotificationMutation>
export type EditPromoNotificationMutationOptions = Apollo.BaseMutationOptions<
  EditPromoNotificationMutation,
  EditPromoNotificationMutationVariables
>
export const SetPromoAsDraftDocument = gql`
  mutation setPromoAsDraft($promoDraftParams: PromoDraftParams!) {
    setPromoAsDraft(promoDraftParams: $promoDraftParams) {
      ...promoNotification
    }
  }
  ${PromoNotificationFragmentDoc}
`
export type SetPromoAsDraftMutationFn = Apollo.MutationFunction<
  SetPromoAsDraftMutation,
  SetPromoAsDraftMutationVariables
>

/**
 * __useSetPromoAsDraftMutation__
 *
 * To run a mutation, you first call `useSetPromoAsDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPromoAsDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPromoAsDraftMutation, { data, loading, error }] = useSetPromoAsDraftMutation({
 *   variables: {
 *      promoDraftParams: // value for 'promoDraftParams'
 *   },
 * });
 */
export function useSetPromoAsDraftMutation(
  baseOptions?: Apollo.MutationHookOptions<SetPromoAsDraftMutation, SetPromoAsDraftMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<SetPromoAsDraftMutation, SetPromoAsDraftMutationVariables>(SetPromoAsDraftDocument, options)
}
export type SetPromoAsDraftMutationHookResult = ReturnType<typeof useSetPromoAsDraftMutation>
export type SetPromoAsDraftMutationResult = Apollo.MutationResult<SetPromoAsDraftMutation>
export type SetPromoAsDraftMutationOptions = Apollo.BaseMutationOptions<
  SetPromoAsDraftMutation,
  SetPromoAsDraftMutationVariables
>
export const GetTranslationMappingsDocument = gql`
  query getTranslationMappings($translationMappingParams: TranslationMappingParams!) {
    getTranslationMappings(translationMappingParams: $translationMappingParams) {
      locale
      tKey
      text
    }
  }
`

/**
 * __useGetTranslationMappingsQuery__
 *
 * To run a query within a React component, call `useGetTranslationMappingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTranslationMappingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTranslationMappingsQuery({
 *   variables: {
 *      translationMappingParams: // value for 'translationMappingParams'
 *   },
 * });
 */
export function useGetTranslationMappingsQuery(
  baseOptions: Apollo.QueryHookOptions<GetTranslationMappingsQuery, GetTranslationMappingsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetTranslationMappingsQuery, GetTranslationMappingsQueryVariables>(
    GetTranslationMappingsDocument,
    options
  )
}
export function useGetTranslationMappingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTranslationMappingsQuery, GetTranslationMappingsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetTranslationMappingsQuery, GetTranslationMappingsQueryVariables>(
    GetTranslationMappingsDocument,
    options
  )
}
export type GetTranslationMappingsQueryHookResult = ReturnType<typeof useGetTranslationMappingsQuery>
export type GetTranslationMappingsLazyQueryHookResult = ReturnType<typeof useGetTranslationMappingsLazyQuery>
export type GetTranslationMappingsQueryResult = Apollo.QueryResult<
  GetTranslationMappingsQuery,
  GetTranslationMappingsQueryVariables
>
export const GrantSubscriptionOverrideDocument = gql`
  mutation grantSubscriptionOverride($grantSubscriptionOverrideParams: GrantSubscriptionOverrideParams!) {
    grantSubscriptionOverride(grantSubscriptionOverrideParams: $grantSubscriptionOverrideParams)
  }
`
export type GrantSubscriptionOverrideMutationFn = Apollo.MutationFunction<
  GrantSubscriptionOverrideMutation,
  GrantSubscriptionOverrideMutationVariables
>

/**
 * __useGrantSubscriptionOverrideMutation__
 *
 * To run a mutation, you first call `useGrantSubscriptionOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGrantSubscriptionOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [grantSubscriptionOverrideMutation, { data, loading, error }] = useGrantSubscriptionOverrideMutation({
 *   variables: {
 *      grantSubscriptionOverrideParams: // value for 'grantSubscriptionOverrideParams'
 *   },
 * });
 */
export function useGrantSubscriptionOverrideMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GrantSubscriptionOverrideMutation,
    GrantSubscriptionOverrideMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<GrantSubscriptionOverrideMutation, GrantSubscriptionOverrideMutationVariables>(
    GrantSubscriptionOverrideDocument,
    options
  )
}
export type GrantSubscriptionOverrideMutationHookResult = ReturnType<typeof useGrantSubscriptionOverrideMutation>
export type GrantSubscriptionOverrideMutationResult = Apollo.MutationResult<GrantSubscriptionOverrideMutation>
export type GrantSubscriptionOverrideMutationOptions = Apollo.BaseMutationOptions<
  GrantSubscriptionOverrideMutation,
  GrantSubscriptionOverrideMutationVariables
>
export const DisableDevicesForSubscriptionsDocument = gql`
  mutation disableDevicesForSubscriptions(
    $disableDevicesForSubscriptionsParams: DisableDevicesForSubscriptionsParams!
  ) {
    disableDevicesForSubscriptions(disableDevicesForSubscriptionsParams: $disableDevicesForSubscriptionsParams)
  }
`
export type DisableDevicesForSubscriptionsMutationFn = Apollo.MutationFunction<
  DisableDevicesForSubscriptionsMutation,
  DisableDevicesForSubscriptionsMutationVariables
>

/**
 * __useDisableDevicesForSubscriptionsMutation__
 *
 * To run a mutation, you first call `useDisableDevicesForSubscriptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableDevicesForSubscriptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableDevicesForSubscriptionsMutation, { data, loading, error }] = useDisableDevicesForSubscriptionsMutation({
 *   variables: {
 *      disableDevicesForSubscriptionsParams: // value for 'disableDevicesForSubscriptionsParams'
 *   },
 * });
 */
export function useDisableDevicesForSubscriptionsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DisableDevicesForSubscriptionsMutation,
    DisableDevicesForSubscriptionsMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<DisableDevicesForSubscriptionsMutation, DisableDevicesForSubscriptionsMutationVariables>(
    DisableDevicesForSubscriptionsDocument,
    options
  )
}
export type DisableDevicesForSubscriptionsMutationHookResult = ReturnType<
  typeof useDisableDevicesForSubscriptionsMutation
>
export type DisableDevicesForSubscriptionsMutationResult = Apollo.MutationResult<DisableDevicesForSubscriptionsMutation>
export type DisableDevicesForSubscriptionsMutationOptions = Apollo.BaseMutationOptions<
  DisableDevicesForSubscriptionsMutation,
  DisableDevicesForSubscriptionsMutationVariables
>
export const GetUserLikesNotesDocument = gql`
  query getUserLikesNotes($userLikesNotesParameters: UserLikesNotesParameters!) {
    getUserLikesNotes(userLikesNotesParameters: $userLikesNotesParameters) {
      noteId
      likesNote
    }
  }
`

/**
 * __useGetUserLikesNotesQuery__
 *
 * To run a query within a React component, call `useGetUserLikesNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserLikesNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserLikesNotesQuery({
 *   variables: {
 *      userLikesNotesParameters: // value for 'userLikesNotesParameters'
 *   },
 * });
 */
export function useGetUserLikesNotesQuery(
  baseOptions: Apollo.QueryHookOptions<GetUserLikesNotesQuery, GetUserLikesNotesQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetUserLikesNotesQuery, GetUserLikesNotesQueryVariables>(GetUserLikesNotesDocument, options)
}
export function useGetUserLikesNotesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserLikesNotesQuery, GetUserLikesNotesQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetUserLikesNotesQuery, GetUserLikesNotesQueryVariables>(
    GetUserLikesNotesDocument,
    options
  )
}
export type GetUserLikesNotesQueryHookResult = ReturnType<typeof useGetUserLikesNotesQuery>
export type GetUserLikesNotesLazyQueryHookResult = ReturnType<typeof useGetUserLikesNotesLazyQuery>
export type GetUserLikesNotesQueryResult = Apollo.QueryResult<GetUserLikesNotesQuery, GetUserLikesNotesQueryVariables>
export const GetAllCommentsDocument = gql`
  query getAllComments($getAllCommentsParams: GetAllCommentsParams!) {
    getAllComments(getAllCommentsParams: $getAllCommentsParams) {
      id
      parent {
        id
      }
      author {
        id
        profile {
          screenname
          avatarUrl
        }
      }
      galleryNote {
        id
        name
      }
      createdAt
      commentText
      approvalState
      rejectionReason
    }
  }
`

/**
 * __useGetAllCommentsQuery__
 *
 * To run a query within a React component, call `useGetAllCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCommentsQuery({
 *   variables: {
 *      getAllCommentsParams: // value for 'getAllCommentsParams'
 *   },
 * });
 */
export function useGetAllCommentsQuery(
  baseOptions: Apollo.QueryHookOptions<GetAllCommentsQuery, GetAllCommentsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetAllCommentsQuery, GetAllCommentsQueryVariables>(GetAllCommentsDocument, options)
}
export function useGetAllCommentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAllCommentsQuery, GetAllCommentsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetAllCommentsQuery, GetAllCommentsQueryVariables>(GetAllCommentsDocument, options)
}
export type GetAllCommentsQueryHookResult = ReturnType<typeof useGetAllCommentsQuery>
export type GetAllCommentsLazyQueryHookResult = ReturnType<typeof useGetAllCommentsLazyQuery>
export type GetAllCommentsQueryResult = Apollo.QueryResult<GetAllCommentsQuery, GetAllCommentsQueryVariables>
export const GetNoteRootCommentsDocument = gql`
  query getNoteRootComments($getNoteRootCommentsParams: GetNoteRootCommentsParams!) {
    getNoteRootComments(getNoteRootCommentsParams: $getNoteRootCommentsParams) {
      id
      parent {
        id
      }
      author {
        id
        profile {
          screenname
          avatarUrl
        }
      }
      createdAt
      commentText
    }
  }
`

/**
 * __useGetNoteRootCommentsQuery__
 *
 * To run a query within a React component, call `useGetNoteRootCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNoteRootCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNoteRootCommentsQuery({
 *   variables: {
 *      getNoteRootCommentsParams: // value for 'getNoteRootCommentsParams'
 *   },
 * });
 */
export function useGetNoteRootCommentsQuery(
  baseOptions: Apollo.QueryHookOptions<GetNoteRootCommentsQuery, GetNoteRootCommentsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetNoteRootCommentsQuery, GetNoteRootCommentsQueryVariables>(
    GetNoteRootCommentsDocument,
    options
  )
}
export function useGetNoteRootCommentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetNoteRootCommentsQuery, GetNoteRootCommentsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetNoteRootCommentsQuery, GetNoteRootCommentsQueryVariables>(
    GetNoteRootCommentsDocument,
    options
  )
}
export type GetNoteRootCommentsQueryHookResult = ReturnType<typeof useGetNoteRootCommentsQuery>
export type GetNoteRootCommentsLazyQueryHookResult = ReturnType<typeof useGetNoteRootCommentsLazyQuery>
export type GetNoteRootCommentsQueryResult = Apollo.QueryResult<
  GetNoteRootCommentsQuery,
  GetNoteRootCommentsQueryVariables
>
export const ApproveCommentDocument = gql`
  mutation approveComment($approveCommentParams: ApproveCommentParams!) {
    approveComment(approveCommentParams: $approveCommentParams)
  }
`
export type ApproveCommentMutationFn = Apollo.MutationFunction<ApproveCommentMutation, ApproveCommentMutationVariables>

/**
 * __useApproveCommentMutation__
 *
 * To run a mutation, you first call `useApproveCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveCommentMutation, { data, loading, error }] = useApproveCommentMutation({
 *   variables: {
 *      approveCommentParams: // value for 'approveCommentParams'
 *   },
 * });
 */
export function useApproveCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<ApproveCommentMutation, ApproveCommentMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<ApproveCommentMutation, ApproveCommentMutationVariables>(ApproveCommentDocument, options)
}
export type ApproveCommentMutationHookResult = ReturnType<typeof useApproveCommentMutation>
export type ApproveCommentMutationResult = Apollo.MutationResult<ApproveCommentMutation>
export type ApproveCommentMutationOptions = Apollo.BaseMutationOptions<
  ApproveCommentMutation,
  ApproveCommentMutationVariables
>
export const SetGalleryDegradedDocument = gql`
  mutation setGalleryDegraded($degradedStateParams: DegradedStateParams!) {
    setGalleryDegraded(degradedStateParams: $degradedStateParams)
  }
`
export type SetGalleryDegradedMutationFn = Apollo.MutationFunction<
  SetGalleryDegradedMutation,
  SetGalleryDegradedMutationVariables
>

/**
 * __useSetGalleryDegradedMutation__
 *
 * To run a mutation, you first call `useSetGalleryDegradedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetGalleryDegradedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setGalleryDegradedMutation, { data, loading, error }] = useSetGalleryDegradedMutation({
 *   variables: {
 *      degradedStateParams: // value for 'degradedStateParams'
 *   },
 * });
 */
export function useSetGalleryDegradedMutation(
  baseOptions?: Apollo.MutationHookOptions<SetGalleryDegradedMutation, SetGalleryDegradedMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<SetGalleryDegradedMutation, SetGalleryDegradedMutationVariables>(
    SetGalleryDegradedDocument,
    options
  )
}
export type SetGalleryDegradedMutationHookResult = ReturnType<typeof useSetGalleryDegradedMutation>
export type SetGalleryDegradedMutationResult = Apollo.MutationResult<SetGalleryDegradedMutation>
export type SetGalleryDegradedMutationOptions = Apollo.BaseMutationOptions<
  SetGalleryDegradedMutation,
  SetGalleryDegradedMutationVariables
>
export const HideCommentDocument = gql`
  mutation hideComment($hideCommentParams: HideCommentParams!) {
    hideComment(hideCommentParams: $hideCommentParams)
  }
`
export type HideCommentMutationFn = Apollo.MutationFunction<HideCommentMutation, HideCommentMutationVariables>

/**
 * __useHideCommentMutation__
 *
 * To run a mutation, you first call `useHideCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHideCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hideCommentMutation, { data, loading, error }] = useHideCommentMutation({
 *   variables: {
 *      hideCommentParams: // value for 'hideCommentParams'
 *   },
 * });
 */
export function useHideCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<HideCommentMutation, HideCommentMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<HideCommentMutation, HideCommentMutationVariables>(HideCommentDocument, options)
}
export type HideCommentMutationHookResult = ReturnType<typeof useHideCommentMutation>
export type HideCommentMutationResult = Apollo.MutationResult<HideCommentMutation>
export type HideCommentMutationOptions = Apollo.BaseMutationOptions<HideCommentMutation, HideCommentMutationVariables>
export const CreateCommentDocument = gql`
  mutation createComment($createCommentParams: CreateCommentParams!) {
    createComment(createCommentParams: $createCommentParams) {
      ...commentInfo
    }
  }
  ${CommentInfoFragmentDoc}
`
export type CreateCommentMutationFn = Apollo.MutationFunction<CreateCommentMutation, CreateCommentMutationVariables>

/**
 * __useCreateCommentMutation__
 *
 * To run a mutation, you first call `useCreateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentMutation, { data, loading, error }] = useCreateCommentMutation({
 *   variables: {
 *      createCommentParams: // value for 'createCommentParams'
 *   },
 * });
 */
export function useCreateCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateCommentMutation, CreateCommentMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<CreateCommentMutation, CreateCommentMutationVariables>(CreateCommentDocument, options)
}
export type CreateCommentMutationHookResult = ReturnType<typeof useCreateCommentMutation>
export type CreateCommentMutationResult = Apollo.MutationResult<CreateCommentMutation>
export type CreateCommentMutationOptions = Apollo.BaseMutationOptions<
  CreateCommentMutation,
  CreateCommentMutationVariables
>
export const ReportCommentDocument = gql`
  mutation reportComment($reportCommentParams: ReportCommentParams!) {
    reportComment(reportCommentParams: $reportCommentParams)
  }
`
export type ReportCommentMutationFn = Apollo.MutationFunction<ReportCommentMutation, ReportCommentMutationVariables>

/**
 * __useReportCommentMutation__
 *
 * To run a mutation, you first call `useReportCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportCommentMutation, { data, loading, error }] = useReportCommentMutation({
 *   variables: {
 *      reportCommentParams: // value for 'reportCommentParams'
 *   },
 * });
 */
export function useReportCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<ReportCommentMutation, ReportCommentMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<ReportCommentMutation, ReportCommentMutationVariables>(ReportCommentDocument, options)
}
export type ReportCommentMutationHookResult = ReturnType<typeof useReportCommentMutation>
export type ReportCommentMutationResult = Apollo.MutationResult<ReportCommentMutation>
export type ReportCommentMutationOptions = Apollo.BaseMutationOptions<
  ReportCommentMutation,
  ReportCommentMutationVariables
>
export const DeleteCommentDocument = gql`
  mutation deleteComment($deleteCommentParams: DeleteCommentParams!) {
    deleteComment(deleteCommentParams: $deleteCommentParams)
  }
`
export type DeleteCommentMutationFn = Apollo.MutationFunction<DeleteCommentMutation, DeleteCommentMutationVariables>

/**
 * __useDeleteCommentMutation__
 *
 * To run a mutation, you first call `useDeleteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentMutation, { data, loading, error }] = useDeleteCommentMutation({
 *   variables: {
 *      deleteCommentParams: // value for 'deleteCommentParams'
 *   },
 * });
 */
export function useDeleteCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteCommentMutation, DeleteCommentMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<DeleteCommentMutation, DeleteCommentMutationVariables>(DeleteCommentDocument, options)
}
export type DeleteCommentMutationHookResult = ReturnType<typeof useDeleteCommentMutation>
export type DeleteCommentMutationResult = Apollo.MutationResult<DeleteCommentMutation>
export type DeleteCommentMutationOptions = Apollo.BaseMutationOptions<
  DeleteCommentMutation,
  DeleteCommentMutationVariables
>
export const GetAllSubscriptionsOverDeviceLimitDocument = gql`
  query getAllSubscriptionsOverDeviceLimit(
    $getAllSubscriptionsOverDeviceLimitParams: GetAllSubscriptionsOverDeviceLimitParams!
  ) {
    getAllSubscriptionsOverDeviceLimit(
      getAllSubscriptionsOverDeviceLimitParams: $getAllSubscriptionsOverDeviceLimitParams
    ) {
      subscriptionId
      numDevices
      deviceLimitEnforcementEnabled
    }
  }
`

/**
 * __useGetAllSubscriptionsOverDeviceLimitQuery__
 *
 * To run a query within a React component, call `useGetAllSubscriptionsOverDeviceLimitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSubscriptionsOverDeviceLimitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSubscriptionsOverDeviceLimitQuery({
 *   variables: {
 *      getAllSubscriptionsOverDeviceLimitParams: // value for 'getAllSubscriptionsOverDeviceLimitParams'
 *   },
 * });
 */
export function useGetAllSubscriptionsOverDeviceLimitQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAllSubscriptionsOverDeviceLimitQuery,
    GetAllSubscriptionsOverDeviceLimitQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetAllSubscriptionsOverDeviceLimitQuery, GetAllSubscriptionsOverDeviceLimitQueryVariables>(
    GetAllSubscriptionsOverDeviceLimitDocument,
    options
  )
}
export function useGetAllSubscriptionsOverDeviceLimitLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAllSubscriptionsOverDeviceLimitQuery,
    GetAllSubscriptionsOverDeviceLimitQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetAllSubscriptionsOverDeviceLimitQuery, GetAllSubscriptionsOverDeviceLimitQueryVariables>(
    GetAllSubscriptionsOverDeviceLimitDocument,
    options
  )
}
export type GetAllSubscriptionsOverDeviceLimitQueryHookResult = ReturnType<
  typeof useGetAllSubscriptionsOverDeviceLimitQuery
>
export type GetAllSubscriptionsOverDeviceLimitLazyQueryHookResult = ReturnType<
  typeof useGetAllSubscriptionsOverDeviceLimitLazyQuery
>
export type GetAllSubscriptionsOverDeviceLimitQueryResult = Apollo.QueryResult<
  GetAllSubscriptionsOverDeviceLimitQuery,
  GetAllSubscriptionsOverDeviceLimitQueryVariables
>
export const ToggleDeviceLimitEnforcementDocument = gql`
  mutation toggleDeviceLimitEnforcement($toggleDeviceLimitEnforcementParams: ToggleDeviceLimitEnforcementParams!) {
    toggleDeviceLimitEnforcement(toggleDeviceLimitEnforcementParams: $toggleDeviceLimitEnforcementParams) {
      deviceLimitEnforcementEnabled
    }
  }
`
export type ToggleDeviceLimitEnforcementMutationFn = Apollo.MutationFunction<
  ToggleDeviceLimitEnforcementMutation,
  ToggleDeviceLimitEnforcementMutationVariables
>

/**
 * __useToggleDeviceLimitEnforcementMutation__
 *
 * To run a mutation, you first call `useToggleDeviceLimitEnforcementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleDeviceLimitEnforcementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleDeviceLimitEnforcementMutation, { data, loading, error }] = useToggleDeviceLimitEnforcementMutation({
 *   variables: {
 *      toggleDeviceLimitEnforcementParams: // value for 'toggleDeviceLimitEnforcementParams'
 *   },
 * });
 */
export function useToggleDeviceLimitEnforcementMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ToggleDeviceLimitEnforcementMutation,
    ToggleDeviceLimitEnforcementMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<ToggleDeviceLimitEnforcementMutation, ToggleDeviceLimitEnforcementMutationVariables>(
    ToggleDeviceLimitEnforcementDocument,
    options
  )
}
export type ToggleDeviceLimitEnforcementMutationHookResult = ReturnType<typeof useToggleDeviceLimitEnforcementMutation>
export type ToggleDeviceLimitEnforcementMutationResult = Apollo.MutationResult<ToggleDeviceLimitEnforcementMutation>
export type ToggleDeviceLimitEnforcementMutationOptions = Apollo.BaseMutationOptions<
  ToggleDeviceLimitEnforcementMutation,
  ToggleDeviceLimitEnforcementMutationVariables
>
export const DismissGuidelinesDocument = gql`
  mutation dismissGuidelines {
    dismissGuidelines
  }
`
export type DismissGuidelinesMutationFn = Apollo.MutationFunction<
  DismissGuidelinesMutation,
  DismissGuidelinesMutationVariables
>

/**
 * __useDismissGuidelinesMutation__
 *
 * To run a mutation, you first call `useDismissGuidelinesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissGuidelinesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissGuidelinesMutation, { data, loading, error }] = useDismissGuidelinesMutation({
 *   variables: {
 *   },
 * });
 */
export function useDismissGuidelinesMutation(
  baseOptions?: Apollo.MutationHookOptions<DismissGuidelinesMutation, DismissGuidelinesMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<DismissGuidelinesMutation, DismissGuidelinesMutationVariables>(
    DismissGuidelinesDocument,
    options
  )
}
export type DismissGuidelinesMutationHookResult = ReturnType<typeof useDismissGuidelinesMutation>
export type DismissGuidelinesMutationResult = Apollo.MutationResult<DismissGuidelinesMutation>
export type DismissGuidelinesMutationOptions = Apollo.BaseMutationOptions<
  DismissGuidelinesMutation,
  DismissGuidelinesMutationVariables
>
export const CreateExperimentDocument = gql`
  mutation createExperiment($experimentParams: ExperimentParams!) {
    createExperiment(experimentParams: $experimentParams) {
      id
      description
      targetEnrollmentPct
    }
  }
`
export type CreateExperimentMutationFn = Apollo.MutationFunction<
  CreateExperimentMutation,
  CreateExperimentMutationVariables
>

/**
 * __useCreateExperimentMutation__
 *
 * To run a mutation, you first call `useCreateExperimentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExperimentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExperimentMutation, { data, loading, error }] = useCreateExperimentMutation({
 *   variables: {
 *      experimentParams: // value for 'experimentParams'
 *   },
 * });
 */
export function useCreateExperimentMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateExperimentMutation, CreateExperimentMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<CreateExperimentMutation, CreateExperimentMutationVariables>(
    CreateExperimentDocument,
    options
  )
}
export type CreateExperimentMutationHookResult = ReturnType<typeof useCreateExperimentMutation>
export type CreateExperimentMutationResult = Apollo.MutationResult<CreateExperimentMutation>
export type CreateExperimentMutationOptions = Apollo.BaseMutationOptions<
  CreateExperimentMutation,
  CreateExperimentMutationVariables
>
export const AssignAllUsersToExperimentsDocument = gql`
  mutation assignAllUsersToExperiments {
    assignAllUsersToExperiments
  }
`
export type AssignAllUsersToExperimentsMutationFn = Apollo.MutationFunction<
  AssignAllUsersToExperimentsMutation,
  AssignAllUsersToExperimentsMutationVariables
>

/**
 * __useAssignAllUsersToExperimentsMutation__
 *
 * To run a mutation, you first call `useAssignAllUsersToExperimentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignAllUsersToExperimentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignAllUsersToExperimentsMutation, { data, loading, error }] = useAssignAllUsersToExperimentsMutation({
 *   variables: {
 *   },
 * });
 */
export function useAssignAllUsersToExperimentsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssignAllUsersToExperimentsMutation,
    AssignAllUsersToExperimentsMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<AssignAllUsersToExperimentsMutation, AssignAllUsersToExperimentsMutationVariables>(
    AssignAllUsersToExperimentsDocument,
    options
  )
}
export type AssignAllUsersToExperimentsMutationHookResult = ReturnType<typeof useAssignAllUsersToExperimentsMutation>
export type AssignAllUsersToExperimentsMutationResult = Apollo.MutationResult<AssignAllUsersToExperimentsMutation>
export type AssignAllUsersToExperimentsMutationOptions = Apollo.BaseMutationOptions<
  AssignAllUsersToExperimentsMutation,
  AssignAllUsersToExperimentsMutationVariables
>
export const EditExperimentDocument = gql`
  mutation editExperiment($experimentParams: ExperimentParams!) {
    editExperiment(experimentParams: $experimentParams)
  }
`
export type EditExperimentMutationFn = Apollo.MutationFunction<EditExperimentMutation, EditExperimentMutationVariables>

/**
 * __useEditExperimentMutation__
 *
 * To run a mutation, you first call `useEditExperimentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditExperimentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editExperimentMutation, { data, loading, error }] = useEditExperimentMutation({
 *   variables: {
 *      experimentParams: // value for 'experimentParams'
 *   },
 * });
 */
export function useEditExperimentMutation(
  baseOptions?: Apollo.MutationHookOptions<EditExperimentMutation, EditExperimentMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<EditExperimentMutation, EditExperimentMutationVariables>(EditExperimentDocument, options)
}
export type EditExperimentMutationHookResult = ReturnType<typeof useEditExperimentMutation>
export type EditExperimentMutationResult = Apollo.MutationResult<EditExperimentMutation>
export type EditExperimentMutationOptions = Apollo.BaseMutationOptions<
  EditExperimentMutation,
  EditExperimentMutationVariables
>
export const DeleteExperimentDocument = gql`
  mutation deleteExperiment($deleteExperimentParams: DeleteExperimentParams!) {
    deleteExperiment(deleteExperimentParams: $deleteExperimentParams)
  }
`
export type DeleteExperimentMutationFn = Apollo.MutationFunction<
  DeleteExperimentMutation,
  DeleteExperimentMutationVariables
>

/**
 * __useDeleteExperimentMutation__
 *
 * To run a mutation, you first call `useDeleteExperimentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExperimentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExperimentMutation, { data, loading, error }] = useDeleteExperimentMutation({
 *   variables: {
 *      deleteExperimentParams: // value for 'deleteExperimentParams'
 *   },
 * });
 */
export function useDeleteExperimentMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteExperimentMutation, DeleteExperimentMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<DeleteExperimentMutation, DeleteExperimentMutationVariables>(
    DeleteExperimentDocument,
    options
  )
}
export type DeleteExperimentMutationHookResult = ReturnType<typeof useDeleteExperimentMutation>
export type DeleteExperimentMutationResult = Apollo.MutationResult<DeleteExperimentMutation>
export type DeleteExperimentMutationOptions = Apollo.BaseMutationOptions<
  DeleteExperimentMutation,
  DeleteExperimentMutationVariables
>
export const GetExperimentEnrollmentOverridesDocument = gql`
  query getExperimentEnrollmentOverrides(
    $experimentEnrollmentOverrideQueryParams: ExperimentEnrollmentOverrideQueryParams!
  ) {
    getExperimentEnrollmentOverrides(
      experimentEnrollmentOverrideQueryParams: $experimentEnrollmentOverrideQueryParams
    ) {
      ...testOverride
    }
  }
  ${TestOverrideFragmentDoc}
`

/**
 * __useGetExperimentEnrollmentOverridesQuery__
 *
 * To run a query within a React component, call `useGetExperimentEnrollmentOverridesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExperimentEnrollmentOverridesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExperimentEnrollmentOverridesQuery({
 *   variables: {
 *      experimentEnrollmentOverrideQueryParams: // value for 'experimentEnrollmentOverrideQueryParams'
 *   },
 * });
 */
export function useGetExperimentEnrollmentOverridesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetExperimentEnrollmentOverridesQuery,
    GetExperimentEnrollmentOverridesQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetExperimentEnrollmentOverridesQuery, GetExperimentEnrollmentOverridesQueryVariables>(
    GetExperimentEnrollmentOverridesDocument,
    options
  )
}
export function useGetExperimentEnrollmentOverridesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetExperimentEnrollmentOverridesQuery,
    GetExperimentEnrollmentOverridesQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetExperimentEnrollmentOverridesQuery, GetExperimentEnrollmentOverridesQueryVariables>(
    GetExperimentEnrollmentOverridesDocument,
    options
  )
}
export type GetExperimentEnrollmentOverridesQueryHookResult = ReturnType<
  typeof useGetExperimentEnrollmentOverridesQuery
>
export type GetExperimentEnrollmentOverridesLazyQueryHookResult = ReturnType<
  typeof useGetExperimentEnrollmentOverridesLazyQuery
>
export type GetExperimentEnrollmentOverridesQueryResult = Apollo.QueryResult<
  GetExperimentEnrollmentOverridesQuery,
  GetExperimentEnrollmentOverridesQueryVariables
>
export const RemoveExperimentEnrollmentOverrideDocument = gql`
  mutation removeExperimentEnrollmentOverride(
    $removeExperimentEnrollmentOverrideParams: RemoveExperimentEnrollmentOverrideParams!
  ) {
    removeExperimentEnrollmentOverride(
      removeExperimentEnrollmentOverrideParams: $removeExperimentEnrollmentOverrideParams
    )
  }
`
export type RemoveExperimentEnrollmentOverrideMutationFn = Apollo.MutationFunction<
  RemoveExperimentEnrollmentOverrideMutation,
  RemoveExperimentEnrollmentOverrideMutationVariables
>

/**
 * __useRemoveExperimentEnrollmentOverrideMutation__
 *
 * To run a mutation, you first call `useRemoveExperimentEnrollmentOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveExperimentEnrollmentOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeExperimentEnrollmentOverrideMutation, { data, loading, error }] = useRemoveExperimentEnrollmentOverrideMutation({
 *   variables: {
 *      removeExperimentEnrollmentOverrideParams: // value for 'removeExperimentEnrollmentOverrideParams'
 *   },
 * });
 */
export function useRemoveExperimentEnrollmentOverrideMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveExperimentEnrollmentOverrideMutation,
    RemoveExperimentEnrollmentOverrideMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<
    RemoveExperimentEnrollmentOverrideMutation,
    RemoveExperimentEnrollmentOverrideMutationVariables
  >(RemoveExperimentEnrollmentOverrideDocument, options)
}
export type RemoveExperimentEnrollmentOverrideMutationHookResult = ReturnType<
  typeof useRemoveExperimentEnrollmentOverrideMutation
>
export type RemoveExperimentEnrollmentOverrideMutationResult =
  Apollo.MutationResult<RemoveExperimentEnrollmentOverrideMutation>
export type RemoveExperimentEnrollmentOverrideMutationOptions = Apollo.BaseMutationOptions<
  RemoveExperimentEnrollmentOverrideMutation,
  RemoveExperimentEnrollmentOverrideMutationVariables
>
export const UpdateUserExperimentEnrollmentOverrideDocument = gql`
  mutation updateUserExperimentEnrollmentOverride($experimentEnrollmentParams: ExperimentEnrollmentParams!) {
    updateUserExperimentEnrollmentOverride(experimentEnrollmentParams: $experimentEnrollmentParams) {
      ...testOverride
    }
  }
  ${TestOverrideFragmentDoc}
`
export type UpdateUserExperimentEnrollmentOverrideMutationFn = Apollo.MutationFunction<
  UpdateUserExperimentEnrollmentOverrideMutation,
  UpdateUserExperimentEnrollmentOverrideMutationVariables
>

/**
 * __useUpdateUserExperimentEnrollmentOverrideMutation__
 *
 * To run a mutation, you first call `useUpdateUserExperimentEnrollmentOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserExperimentEnrollmentOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserExperimentEnrollmentOverrideMutation, { data, loading, error }] = useUpdateUserExperimentEnrollmentOverrideMutation({
 *   variables: {
 *      experimentEnrollmentParams: // value for 'experimentEnrollmentParams'
 *   },
 * });
 */
export function useUpdateUserExperimentEnrollmentOverrideMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserExperimentEnrollmentOverrideMutation,
    UpdateUserExperimentEnrollmentOverrideMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<
    UpdateUserExperimentEnrollmentOverrideMutation,
    UpdateUserExperimentEnrollmentOverrideMutationVariables
  >(UpdateUserExperimentEnrollmentOverrideDocument, options)
}
export type UpdateUserExperimentEnrollmentOverrideMutationHookResult = ReturnType<
  typeof useUpdateUserExperimentEnrollmentOverrideMutation
>
export type UpdateUserExperimentEnrollmentOverrideMutationResult =
  Apollo.MutationResult<UpdateUserExperimentEnrollmentOverrideMutation>
export type UpdateUserExperimentEnrollmentOverrideMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserExperimentEnrollmentOverrideMutation,
  UpdateUserExperimentEnrollmentOverrideMutationVariables
>
export const CreateAsrJobDocument = gql`
  mutation createASRJob($createASRJobParams: CreateASRJobParams!) {
    createASRJob(createASRJobParams: $createASRJobParams) {
      success
      errorCode
      job {
        uploadPolicy
        status
        whisperImplementation
        beamSize
        results {
          text
          segments {
            startTime
            endTime
            confidence
            text
          }
        }
      }
    }
  }
`
export type CreateAsrJobMutationFn = Apollo.MutationFunction<CreateAsrJobMutation, CreateAsrJobMutationVariables>

/**
 * __useCreateAsrJobMutation__
 *
 * To run a mutation, you first call `useCreateAsrJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAsrJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAsrJobMutation, { data, loading, error }] = useCreateAsrJobMutation({
 *   variables: {
 *      createASRJobParams: // value for 'createASRJobParams'
 *   },
 * });
 */
export function useCreateAsrJobMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateAsrJobMutation, CreateAsrJobMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<CreateAsrJobMutation, CreateAsrJobMutationVariables>(CreateAsrJobDocument, options)
}
export type CreateAsrJobMutationHookResult = ReturnType<typeof useCreateAsrJobMutation>
export type CreateAsrJobMutationResult = Apollo.MutationResult<CreateAsrJobMutation>
export type CreateAsrJobMutationOptions = Apollo.BaseMutationOptions<
  CreateAsrJobMutation,
  CreateAsrJobMutationVariables
>
export const ReprocessAsrJobDocument = gql`
  mutation reprocessASRJob($reprocessASRJobParams: ReprocessASRJobParams!) {
    reprocessASRJob(reprocessASRJobParams: $reprocessASRJobParams) {
      success
      errorCode
      job {
        uploadPolicy
        status
        results {
          text
          segments {
            startTime
            endTime
            confidence
            text
          }
        }
      }
    }
  }
`
export type ReprocessAsrJobMutationFn = Apollo.MutationFunction<
  ReprocessAsrJobMutation,
  ReprocessAsrJobMutationVariables
>

/**
 * __useReprocessAsrJobMutation__
 *
 * To run a mutation, you first call `useReprocessAsrJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReprocessAsrJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reprocessAsrJobMutation, { data, loading, error }] = useReprocessAsrJobMutation({
 *   variables: {
 *      reprocessASRJobParams: // value for 'reprocessASRJobParams'
 *   },
 * });
 */
export function useReprocessAsrJobMutation(
  baseOptions?: Apollo.MutationHookOptions<ReprocessAsrJobMutation, ReprocessAsrJobMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<ReprocessAsrJobMutation, ReprocessAsrJobMutationVariables>(ReprocessAsrJobDocument, options)
}
export type ReprocessAsrJobMutationHookResult = ReturnType<typeof useReprocessAsrJobMutation>
export type ReprocessAsrJobMutationResult = Apollo.MutationResult<ReprocessAsrJobMutation>
export type ReprocessAsrJobMutationOptions = Apollo.BaseMutationOptions<
  ReprocessAsrJobMutation,
  ReprocessAsrJobMutationVariables
>
export const GetCurrentAsrProcessorVersionDocument = gql`
  query getCurrentASRProcessorVersion {
    getCurrentASRProcessorVersion {
      processorVersion
    }
  }
`

/**
 * __useGetCurrentAsrProcessorVersionQuery__
 *
 * To run a query within a React component, call `useGetCurrentAsrProcessorVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentAsrProcessorVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentAsrProcessorVersionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentAsrProcessorVersionQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCurrentAsrProcessorVersionQuery, GetCurrentAsrProcessorVersionQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetCurrentAsrProcessorVersionQuery, GetCurrentAsrProcessorVersionQueryVariables>(
    GetCurrentAsrProcessorVersionDocument,
    options
  )
}
export function useGetCurrentAsrProcessorVersionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCurrentAsrProcessorVersionQuery,
    GetCurrentAsrProcessorVersionQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetCurrentAsrProcessorVersionQuery, GetCurrentAsrProcessorVersionQueryVariables>(
    GetCurrentAsrProcessorVersionDocument,
    options
  )
}
export type GetCurrentAsrProcessorVersionQueryHookResult = ReturnType<typeof useGetCurrentAsrProcessorVersionQuery>
export type GetCurrentAsrProcessorVersionLazyQueryHookResult = ReturnType<
  typeof useGetCurrentAsrProcessorVersionLazyQuery
>
export type GetCurrentAsrProcessorVersionQueryResult = Apollo.QueryResult<
  GetCurrentAsrProcessorVersionQuery,
  GetCurrentAsrProcessorVersionQueryVariables
>
export const GetAsrJobDocument = gql`
  query getASRJob($getASRJobParams: GetASRJobParams!) {
    getASRJob(getASRJobParams: $getASRJobParams) {
      success
      errorCode
      job {
        sha512Hash
        audioDurationMs
        status
        whisperImplementation
        beamSize
        results {
          text
          segments {
            startTime
            endTime
            confidence
            text
          }
        }
        quizJobs {
          id
          status
          errorReason
        }
        summaryJobs {
          id
          status
          errorReason
        }
      }
    }
  }
`

/**
 * __useGetAsrJobQuery__
 *
 * To run a query within a React component, call `useGetAsrJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAsrJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAsrJobQuery({
 *   variables: {
 *      getASRJobParams: // value for 'getASRJobParams'
 *   },
 * });
 */
export function useGetAsrJobQuery(baseOptions: Apollo.QueryHookOptions<GetAsrJobQuery, GetAsrJobQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetAsrJobQuery, GetAsrJobQueryVariables>(GetAsrJobDocument, options)
}
export function useGetAsrJobLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAsrJobQuery, GetAsrJobQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetAsrJobQuery, GetAsrJobQueryVariables>(GetAsrJobDocument, options)
}
export type GetAsrJobQueryHookResult = ReturnType<typeof useGetAsrJobQuery>
export type GetAsrJobLazyQueryHookResult = ReturnType<typeof useGetAsrJobLazyQuery>
export type GetAsrJobQueryResult = Apollo.QueryResult<GetAsrJobQuery, GetAsrJobQueryVariables>
export const GetAsrJobMetaDocument = gql`
  query getASRJobMeta($getASRJobParams: GetASRJobParams!) {
    getASRJob(getASRJobParams: $getASRJobParams) {
      success
      errorCode
      job {
        sha512Hash
        audioDurationMs
        status
        whisperImplementation
        beamSize
        audioCreationDate
        language
        quizJobs {
          id
          status
          errorReason
        }
        summaryJobs {
          id
          status
          errorReason
        }
      }
    }
  }
`

/**
 * __useGetAsrJobMetaQuery__
 *
 * To run a query within a React component, call `useGetAsrJobMetaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAsrJobMetaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAsrJobMetaQuery({
 *   variables: {
 *      getASRJobParams: // value for 'getASRJobParams'
 *   },
 * });
 */
export function useGetAsrJobMetaQuery(
  baseOptions: Apollo.QueryHookOptions<GetAsrJobMetaQuery, GetAsrJobMetaQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetAsrJobMetaQuery, GetAsrJobMetaQueryVariables>(GetAsrJobMetaDocument, options)
}
export function useGetAsrJobMetaLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAsrJobMetaQuery, GetAsrJobMetaQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetAsrJobMetaQuery, GetAsrJobMetaQueryVariables>(GetAsrJobMetaDocument, options)
}
export type GetAsrJobMetaQueryHookResult = ReturnType<typeof useGetAsrJobMetaQuery>
export type GetAsrJobMetaLazyQueryHookResult = ReturnType<typeof useGetAsrJobMetaLazyQuery>
export type GetAsrJobMetaQueryResult = Apollo.QueryResult<GetAsrJobMetaQuery, GetAsrJobMetaQueryVariables>
export const GetUserSharedNotesDocument = gql`
  query getUserSharedNotes($getUserSharedNotesParams: GetUserSharedNotesParams!) {
    getUserSharedNotes(getUserSharedNotesParams: $getUserSharedNotesParams) {
      name
      createdDate
      id
    }
  }
`

/**
 * __useGetUserSharedNotesQuery__
 *
 * To run a query within a React component, call `useGetUserSharedNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSharedNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSharedNotesQuery({
 *   variables: {
 *      getUserSharedNotesParams: // value for 'getUserSharedNotesParams'
 *   },
 * });
 */
export function useGetUserSharedNotesQuery(
  baseOptions: Apollo.QueryHookOptions<GetUserSharedNotesQuery, GetUserSharedNotesQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetUserSharedNotesQuery, GetUserSharedNotesQueryVariables>(GetUserSharedNotesDocument, options)
}
export function useGetUserSharedNotesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserSharedNotesQuery, GetUserSharedNotesQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetUserSharedNotesQuery, GetUserSharedNotesQueryVariables>(
    GetUserSharedNotesDocument,
    options
  )
}
export type GetUserSharedNotesQueryHookResult = ReturnType<typeof useGetUserSharedNotesQuery>
export type GetUserSharedNotesLazyQueryHookResult = ReturnType<typeof useGetUserSharedNotesLazyQuery>
export type GetUserSharedNotesQueryResult = Apollo.QueryResult<
  GetUserSharedNotesQuery,
  GetUserSharedNotesQueryVariables
>
export const SetIgnoreFlagsDocument = gql`
  mutation setIgnoreFlags($setIgnoreFlagsParams: SetIgnoreFlagsParams!) {
    setIgnoreFlags(setIgnoreFlagsParams: $setIgnoreFlagsParams) {
      id
      ignoreFlagging
    }
  }
`
export type SetIgnoreFlagsMutationFn = Apollo.MutationFunction<SetIgnoreFlagsMutation, SetIgnoreFlagsMutationVariables>

/**
 * __useSetIgnoreFlagsMutation__
 *
 * To run a mutation, you first call `useSetIgnoreFlagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetIgnoreFlagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setIgnoreFlagsMutation, { data, loading, error }] = useSetIgnoreFlagsMutation({
 *   variables: {
 *      setIgnoreFlagsParams: // value for 'setIgnoreFlagsParams'
 *   },
 * });
 */
export function useSetIgnoreFlagsMutation(
  baseOptions?: Apollo.MutationHookOptions<SetIgnoreFlagsMutation, SetIgnoreFlagsMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<SetIgnoreFlagsMutation, SetIgnoreFlagsMutationVariables>(SetIgnoreFlagsDocument, options)
}
export type SetIgnoreFlagsMutationHookResult = ReturnType<typeof useSetIgnoreFlagsMutation>
export type SetIgnoreFlagsMutationResult = Apollo.MutationResult<SetIgnoreFlagsMutation>
export type SetIgnoreFlagsMutationOptions = Apollo.BaseMutationOptions<
  SetIgnoreFlagsMutation,
  SetIgnoreFlagsMutationVariables
>
export const UpdateUserLanguageDocument = gql`
  mutation updateUserLanguage($updateUserLanguageParams: UpdateUserLanguageParams!) {
    updateUserLanguage(updateUserLanguageParams: $updateUserLanguageParams)
  }
`
export type UpdateUserLanguageMutationFn = Apollo.MutationFunction<
  UpdateUserLanguageMutation,
  UpdateUserLanguageMutationVariables
>

/**
 * __useUpdateUserLanguageMutation__
 *
 * To run a mutation, you first call `useUpdateUserLanguageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserLanguageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserLanguageMutation, { data, loading, error }] = useUpdateUserLanguageMutation({
 *   variables: {
 *      updateUserLanguageParams: // value for 'updateUserLanguageParams'
 *   },
 * });
 */
export function useUpdateUserLanguageMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateUserLanguageMutation, UpdateUserLanguageMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<UpdateUserLanguageMutation, UpdateUserLanguageMutationVariables>(
    UpdateUserLanguageDocument,
    options
  )
}
export type UpdateUserLanguageMutationHookResult = ReturnType<typeof useUpdateUserLanguageMutation>
export type UpdateUserLanguageMutationResult = Apollo.MutationResult<UpdateUserLanguageMutation>
export type UpdateUserLanguageMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserLanguageMutation,
  UpdateUserLanguageMutationVariables
>
export const GetAllSubscriptionInfoDocument = gql`
  query getAllSubscriptionInfo($getAllSubscriptionInfoParams: GetAllSubscriptionInfoParams!) {
    getAllSubscriptionInfo(getAllSubscriptionInfoParams: $getAllSubscriptionInfoParams) {
      bestSubscription {
        user {
          id
          profile {
            screenname
          }
        }
        devices {
          id
          deviceId
          countryCode
          latestReceiptAt
          deactivatedAt
          createdAt
          updatedAt
        }
        deviceLimitEnforcementEnabled
        originalTransactionId
        originalPurchaseDate
        productId
        expirationDate
        gracePeriodExpiresAt
        expirationIntent
        status
        isTrialPeriod
        isInIntroOfferPeriod
        isInBillingRetryPeriod
        promotionalOfferId
        offerCodeRefName
        refundedDate
        refundedReason
        tier
      }
      subscriptions {
        deviceLimitEnforcementEnabled
        originalTransactionId
        originalPurchaseDate
        productId
        expirationDate
        gracePeriodExpiresAt
        expirationIntent
        status
        isTrialPeriod
        isInIntroOfferPeriod
        isInBillingRetryPeriod
        promotionalOfferId
        offerCodeRefName
        refundedDate
        refundedReason
        tier
      }
      devices {
        id
        deviceId
        countryCode
        latestReceiptAt
        deactivatedAt
        createdAt
        updatedAt
      }
      users {
        id
        email
        profile {
          screenname
        }
      }
      overrides {
        id
        createdAt
        expirationDate
        overrideTier
        overrideReason
        createdBy {
          id
          email
        }
      }
      classicStatuses {
        id
        deviceId
        originalApplicationVersion
        originalPurchaseDate
        likelyFraud
        createdAt
        updatedAt
      }
      receipts {
        id
        parsedReceipt
        deviceId
        environment
        isValid
        originalTransactionId
        receipt
        receiptCreationDate
        updatedAt
      }
    }
  }
`

/**
 * __useGetAllSubscriptionInfoQuery__
 *
 * To run a query within a React component, call `useGetAllSubscriptionInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSubscriptionInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSubscriptionInfoQuery({
 *   variables: {
 *      getAllSubscriptionInfoParams: // value for 'getAllSubscriptionInfoParams'
 *   },
 * });
 */
export function useGetAllSubscriptionInfoQuery(
  baseOptions: Apollo.QueryHookOptions<GetAllSubscriptionInfoQuery, GetAllSubscriptionInfoQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetAllSubscriptionInfoQuery, GetAllSubscriptionInfoQueryVariables>(
    GetAllSubscriptionInfoDocument,
    options
  )
}
export function useGetAllSubscriptionInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAllSubscriptionInfoQuery, GetAllSubscriptionInfoQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetAllSubscriptionInfoQuery, GetAllSubscriptionInfoQueryVariables>(
    GetAllSubscriptionInfoDocument,
    options
  )
}
export type GetAllSubscriptionInfoQueryHookResult = ReturnType<typeof useGetAllSubscriptionInfoQuery>
export type GetAllSubscriptionInfoLazyQueryHookResult = ReturnType<typeof useGetAllSubscriptionInfoLazyQuery>
export type GetAllSubscriptionInfoQueryResult = Apollo.QueryResult<
  GetAllSubscriptionInfoQuery,
  GetAllSubscriptionInfoQueryVariables
>
export const GetCollatedFlaggedNoteInfoDocument = gql`
  query getCollatedFlaggedNoteInfo($getCollatedFlaggedNoteInfoParams: GetCollatedFlaggedNoteInfoParams!) {
    getCollatedFlaggedNoteInfo(getCollatedFlaggedNoteInfoParams: $getCollatedFlaggedNoteInfoParams) {
      flaggingUser {
        id
        email
        profile {
          screenname
          ignoreFlagging
        }
      }
      flaggedNotes {
        id
        name
      }
    }
  }
`

/**
 * __useGetCollatedFlaggedNoteInfoQuery__
 *
 * To run a query within a React component, call `useGetCollatedFlaggedNoteInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollatedFlaggedNoteInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollatedFlaggedNoteInfoQuery({
 *   variables: {
 *      getCollatedFlaggedNoteInfoParams: // value for 'getCollatedFlaggedNoteInfoParams'
 *   },
 * });
 */
export function useGetCollatedFlaggedNoteInfoQuery(
  baseOptions: Apollo.QueryHookOptions<GetCollatedFlaggedNoteInfoQuery, GetCollatedFlaggedNoteInfoQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetCollatedFlaggedNoteInfoQuery, GetCollatedFlaggedNoteInfoQueryVariables>(
    GetCollatedFlaggedNoteInfoDocument,
    options
  )
}
export function useGetCollatedFlaggedNoteInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCollatedFlaggedNoteInfoQuery, GetCollatedFlaggedNoteInfoQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetCollatedFlaggedNoteInfoQuery, GetCollatedFlaggedNoteInfoQueryVariables>(
    GetCollatedFlaggedNoteInfoDocument,
    options
  )
}
export type GetCollatedFlaggedNoteInfoQueryHookResult = ReturnType<typeof useGetCollatedFlaggedNoteInfoQuery>
export type GetCollatedFlaggedNoteInfoLazyQueryHookResult = ReturnType<typeof useGetCollatedFlaggedNoteInfoLazyQuery>
export type GetCollatedFlaggedNoteInfoQueryResult = Apollo.QueryResult<
  GetCollatedFlaggedNoteInfoQuery,
  GetCollatedFlaggedNoteInfoQueryVariables
>
export const ComputeTopTagsDocument = gql`
  mutation computeTopTags {
    computeTopTags
  }
`
export type ComputeTopTagsMutationFn = Apollo.MutationFunction<ComputeTopTagsMutation, ComputeTopTagsMutationVariables>

/**
 * __useComputeTopTagsMutation__
 *
 * To run a mutation, you first call `useComputeTopTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useComputeTopTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [computeTopTagsMutation, { data, loading, error }] = useComputeTopTagsMutation({
 *   variables: {
 *   },
 * });
 */
export function useComputeTopTagsMutation(
  baseOptions?: Apollo.MutationHookOptions<ComputeTopTagsMutation, ComputeTopTagsMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<ComputeTopTagsMutation, ComputeTopTagsMutationVariables>(ComputeTopTagsDocument, options)
}
export type ComputeTopTagsMutationHookResult = ReturnType<typeof useComputeTopTagsMutation>
export type ComputeTopTagsMutationResult = Apollo.MutationResult<ComputeTopTagsMutation>
export type ComputeTopTagsMutationOptions = Apollo.BaseMutationOptions<
  ComputeTopTagsMutation,
  ComputeTopTagsMutationVariables
>
export const SetGlobalOverrideValueDocument = gql`
  mutation setGlobalOverrideValue($setGlobalOverrideValueParams: SetGlobalOverrideValueParams!) {
    setGlobalOverrideValue(setGlobalOverrideValueParams: $setGlobalOverrideValueParams)
  }
`
export type SetGlobalOverrideValueMutationFn = Apollo.MutationFunction<
  SetGlobalOverrideValueMutation,
  SetGlobalOverrideValueMutationVariables
>

/**
 * __useSetGlobalOverrideValueMutation__
 *
 * To run a mutation, you first call `useSetGlobalOverrideValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetGlobalOverrideValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setGlobalOverrideValueMutation, { data, loading, error }] = useSetGlobalOverrideValueMutation({
 *   variables: {
 *      setGlobalOverrideValueParams: // value for 'setGlobalOverrideValueParams'
 *   },
 * });
 */
export function useSetGlobalOverrideValueMutation(
  baseOptions?: Apollo.MutationHookOptions<SetGlobalOverrideValueMutation, SetGlobalOverrideValueMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<SetGlobalOverrideValueMutation, SetGlobalOverrideValueMutationVariables>(
    SetGlobalOverrideValueDocument,
    options
  )
}
export type SetGlobalOverrideValueMutationHookResult = ReturnType<typeof useSetGlobalOverrideValueMutation>
export type SetGlobalOverrideValueMutationResult = Apollo.MutationResult<SetGlobalOverrideValueMutation>
export type SetGlobalOverrideValueMutationOptions = Apollo.BaseMutationOptions<
  SetGlobalOverrideValueMutation,
  SetGlobalOverrideValueMutationVariables
>
export const DeleteGlobalOverrideValueDocument = gql`
  mutation deleteGlobalOverrideValue($deleteGlobalOverrideValueParams: DeleteGlobalOverrideValueParams!) {
    deleteGlobalOverrideValue(deleteGlobalOverrideValueParams: $deleteGlobalOverrideValueParams)
  }
`
export type DeleteGlobalOverrideValueMutationFn = Apollo.MutationFunction<
  DeleteGlobalOverrideValueMutation,
  DeleteGlobalOverrideValueMutationVariables
>

/**
 * __useDeleteGlobalOverrideValueMutation__
 *
 * To run a mutation, you first call `useDeleteGlobalOverrideValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGlobalOverrideValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGlobalOverrideValueMutation, { data, loading, error }] = useDeleteGlobalOverrideValueMutation({
 *   variables: {
 *      deleteGlobalOverrideValueParams: // value for 'deleteGlobalOverrideValueParams'
 *   },
 * });
 */
export function useDeleteGlobalOverrideValueMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteGlobalOverrideValueMutation,
    DeleteGlobalOverrideValueMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<DeleteGlobalOverrideValueMutation, DeleteGlobalOverrideValueMutationVariables>(
    DeleteGlobalOverrideValueDocument,
    options
  )
}
export type DeleteGlobalOverrideValueMutationHookResult = ReturnType<typeof useDeleteGlobalOverrideValueMutation>
export type DeleteGlobalOverrideValueMutationResult = Apollo.MutationResult<DeleteGlobalOverrideValueMutation>
export type DeleteGlobalOverrideValueMutationOptions = Apollo.BaseMutationOptions<
  DeleteGlobalOverrideValueMutation,
  DeleteGlobalOverrideValueMutationVariables
>
export const AdminSimulateQuotaDocument = gql`
  mutation adminSimulateQuota($simulateASRQuotaParams: SimulateASRQuotaParams!) {
    adminSimulateQuota(simulateASRQuotaParams: $simulateASRQuotaParams)
  }
`
export type AdminSimulateQuotaMutationFn = Apollo.MutationFunction<
  AdminSimulateQuotaMutation,
  AdminSimulateQuotaMutationVariables
>

/**
 * __useAdminSimulateQuotaMutation__
 *
 * To run a mutation, you first call `useAdminSimulateQuotaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSimulateQuotaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSimulateQuotaMutation, { data, loading, error }] = useAdminSimulateQuotaMutation({
 *   variables: {
 *      simulateASRQuotaParams: // value for 'simulateASRQuotaParams'
 *   },
 * });
 */
export function useAdminSimulateQuotaMutation(
  baseOptions?: Apollo.MutationHookOptions<AdminSimulateQuotaMutation, AdminSimulateQuotaMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<AdminSimulateQuotaMutation, AdminSimulateQuotaMutationVariables>(
    AdminSimulateQuotaDocument,
    options
  )
}
export type AdminSimulateQuotaMutationHookResult = ReturnType<typeof useAdminSimulateQuotaMutation>
export type AdminSimulateQuotaMutationResult = Apollo.MutationResult<AdminSimulateQuotaMutation>
export type AdminSimulateQuotaMutationOptions = Apollo.BaseMutationOptions<
  AdminSimulateQuotaMutation,
  AdminSimulateQuotaMutationVariables
>
export const GetCurrentQuotaUsageDocument = gql`
  query getCurrentQuotaUsage($getCurrentQuotaUsageParams: GetCurrentQuotaUsageParams!) {
    getCurrentQuotaUsage(getCurrentQuotaUsageParams: $getCurrentQuotaUsageParams) {
      exceeded
      quotaUsage
      retryAfter
    }
  }
`

/**
 * __useGetCurrentQuotaUsageQuery__
 *
 * To run a query within a React component, call `useGetCurrentQuotaUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentQuotaUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentQuotaUsageQuery({
 *   variables: {
 *      getCurrentQuotaUsageParams: // value for 'getCurrentQuotaUsageParams'
 *   },
 * });
 */
export function useGetCurrentQuotaUsageQuery(
  baseOptions: Apollo.QueryHookOptions<GetCurrentQuotaUsageQuery, GetCurrentQuotaUsageQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetCurrentQuotaUsageQuery, GetCurrentQuotaUsageQueryVariables>(
    GetCurrentQuotaUsageDocument,
    options
  )
}
export function useGetCurrentQuotaUsageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentQuotaUsageQuery, GetCurrentQuotaUsageQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetCurrentQuotaUsageQuery, GetCurrentQuotaUsageQueryVariables>(
    GetCurrentQuotaUsageDocument,
    options
  )
}
export type GetCurrentQuotaUsageQueryHookResult = ReturnType<typeof useGetCurrentQuotaUsageQuery>
export type GetCurrentQuotaUsageLazyQueryHookResult = ReturnType<typeof useGetCurrentQuotaUsageLazyQuery>
export type GetCurrentQuotaUsageQueryResult = Apollo.QueryResult<
  GetCurrentQuotaUsageQuery,
  GetCurrentQuotaUsageQueryVariables
>
export const GetAllOrganizationsDocument = gql`
  query getAllOrganizations($getAllOrganizationsParams: GetAllOrganizationsParams!) {
    getAllOrganizations(getAllOrganizationsParams: $getAllOrganizationsParams) {
      organizations {
        ...organizationDetails
      }
      organizationCount
    }
  }
  ${OrganizationDetailsFragmentDoc}
`

/**
 * __useGetAllOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetAllOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllOrganizationsQuery({
 *   variables: {
 *      getAllOrganizationsParams: // value for 'getAllOrganizationsParams'
 *   },
 * });
 */
export function useGetAllOrganizationsQuery(
  baseOptions: Apollo.QueryHookOptions<GetAllOrganizationsQuery, GetAllOrganizationsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetAllOrganizationsQuery, GetAllOrganizationsQueryVariables>(
    GetAllOrganizationsDocument,
    options
  )
}
export function useGetAllOrganizationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAllOrganizationsQuery, GetAllOrganizationsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetAllOrganizationsQuery, GetAllOrganizationsQueryVariables>(
    GetAllOrganizationsDocument,
    options
  )
}
export type GetAllOrganizationsQueryHookResult = ReturnType<typeof useGetAllOrganizationsQuery>
export type GetAllOrganizationsLazyQueryHookResult = ReturnType<typeof useGetAllOrganizationsLazyQuery>
export type GetAllOrganizationsQueryResult = Apollo.QueryResult<
  GetAllOrganizationsQuery,
  GetAllOrganizationsQueryVariables
>
export const GetOrganizationsAwaitingApprovalDocument = gql`
  query getOrganizationsAwaitingApproval {
    getOrganizationsAwaitingApproval {
      ...organization
    }
  }
  ${OrganizationFragmentDoc}
`

/**
 * __useGetOrganizationsAwaitingApprovalQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsAwaitingApprovalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsAwaitingApprovalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsAwaitingApprovalQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationsAwaitingApprovalQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetOrganizationsAwaitingApprovalQuery,
    GetOrganizationsAwaitingApprovalQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetOrganizationsAwaitingApprovalQuery, GetOrganizationsAwaitingApprovalQueryVariables>(
    GetOrganizationsAwaitingApprovalDocument,
    options
  )
}
export function useGetOrganizationsAwaitingApprovalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOrganizationsAwaitingApprovalQuery,
    GetOrganizationsAwaitingApprovalQueryVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetOrganizationsAwaitingApprovalQuery, GetOrganizationsAwaitingApprovalQueryVariables>(
    GetOrganizationsAwaitingApprovalDocument,
    options
  )
}
export type GetOrganizationsAwaitingApprovalQueryHookResult = ReturnType<
  typeof useGetOrganizationsAwaitingApprovalQuery
>
export type GetOrganizationsAwaitingApprovalLazyQueryHookResult = ReturnType<
  typeof useGetOrganizationsAwaitingApprovalLazyQuery
>
export type GetOrganizationsAwaitingApprovalQueryResult = Apollo.QueryResult<
  GetOrganizationsAwaitingApprovalQuery,
  GetOrganizationsAwaitingApprovalQueryVariables
>
export const ReviewOrganizationDocument = gql`
  mutation reviewOrganization($reviewOrganizationParams: ReviewOrganizationParams!) {
    reviewOrganization(reviewOrganizationParams: $reviewOrganizationParams)
  }
`
export type ReviewOrganizationMutationFn = Apollo.MutationFunction<
  ReviewOrganizationMutation,
  ReviewOrganizationMutationVariables
>

/**
 * __useReviewOrganizationMutation__
 *
 * To run a mutation, you first call `useReviewOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewOrganizationMutation, { data, loading, error }] = useReviewOrganizationMutation({
 *   variables: {
 *      reviewOrganizationParams: // value for 'reviewOrganizationParams'
 *   },
 * });
 */
export function useReviewOrganizationMutation(
  baseOptions?: Apollo.MutationHookOptions<ReviewOrganizationMutation, ReviewOrganizationMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<ReviewOrganizationMutation, ReviewOrganizationMutationVariables>(
    ReviewOrganizationDocument,
    options
  )
}
export type ReviewOrganizationMutationHookResult = ReturnType<typeof useReviewOrganizationMutation>
export type ReviewOrganizationMutationResult = Apollo.MutationResult<ReviewOrganizationMutation>
export type ReviewOrganizationMutationOptions = Apollo.BaseMutationOptions<
  ReviewOrganizationMutation,
  ReviewOrganizationMutationVariables
>
export const RestoreOrganizationDocument = gql`
  mutation restoreOrganization($restoreOrganizationParams: RestoreOrganizationParams!) {
    restoreOrganization(restoreOrganizationParams: $restoreOrganizationParams)
  }
`
export type RestoreOrganizationMutationFn = Apollo.MutationFunction<
  RestoreOrganizationMutation,
  RestoreOrganizationMutationVariables
>

/**
 * __useRestoreOrganizationMutation__
 *
 * To run a mutation, you first call `useRestoreOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreOrganizationMutation, { data, loading, error }] = useRestoreOrganizationMutation({
 *   variables: {
 *      restoreOrganizationParams: // value for 'restoreOrganizationParams'
 *   },
 * });
 */
export function useRestoreOrganizationMutation(
  baseOptions?: Apollo.MutationHookOptions<RestoreOrganizationMutation, RestoreOrganizationMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<RestoreOrganizationMutation, RestoreOrganizationMutationVariables>(
    RestoreOrganizationDocument,
    options
  )
}
export type RestoreOrganizationMutationHookResult = ReturnType<typeof useRestoreOrganizationMutation>
export type RestoreOrganizationMutationResult = Apollo.MutationResult<RestoreOrganizationMutation>
export type RestoreOrganizationMutationOptions = Apollo.BaseMutationOptions<
  RestoreOrganizationMutation,
  RestoreOrganizationMutationVariables
>
export const GetOrganizationAdminDocument = gql`
  query getOrganizationAdmin($organizationAdminQueryParams: OrganizationAdminQueryParams!) {
    getOrganizationAdmin(organizationAdminQueryParams: $organizationAdminQueryParams) {
      name
      email
      jobTitle
      organizationName
      organizationType
      organizationId
      licenseKey
      maxSeats
      usedSeats
      subscriptionStatus
      approved
      organizationDeletedAt
      organizationStatus
      mdmPlatform
    }
  }
`

/**
 * __useGetOrganizationAdminQuery__
 *
 * To run a query within a React component, call `useGetOrganizationAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationAdminQuery({
 *   variables: {
 *      organizationAdminQueryParams: // value for 'organizationAdminQueryParams'
 *   },
 * });
 */
export function useGetOrganizationAdminQuery(
  baseOptions: Apollo.QueryHookOptions<GetOrganizationAdminQuery, GetOrganizationAdminQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetOrganizationAdminQuery, GetOrganizationAdminQueryVariables>(
    GetOrganizationAdminDocument,
    options
  )
}
export function useGetOrganizationAdminLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationAdminQuery, GetOrganizationAdminQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetOrganizationAdminQuery, GetOrganizationAdminQueryVariables>(
    GetOrganizationAdminDocument,
    options
  )
}
export type GetOrganizationAdminQueryHookResult = ReturnType<typeof useGetOrganizationAdminQuery>
export type GetOrganizationAdminLazyQueryHookResult = ReturnType<typeof useGetOrganizationAdminLazyQuery>
export type GetOrganizationAdminQueryResult = Apollo.QueryResult<
  GetOrganizationAdminQuery,
  GetOrganizationAdminQueryVariables
>
export const RenameUserDocument = gql`
  mutation renameUser($renameUserParams: RenameUserParams!) {
    renameUser(renameUserParams: $renameUserParams)
  }
`
export type RenameUserMutationFn = Apollo.MutationFunction<RenameUserMutation, RenameUserMutationVariables>

/**
 * __useRenameUserMutation__
 *
 * To run a mutation, you first call `useRenameUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameUserMutation, { data, loading, error }] = useRenameUserMutation({
 *   variables: {
 *      renameUserParams: // value for 'renameUserParams'
 *   },
 * });
 */
export function useRenameUserMutation(
  baseOptions?: Apollo.MutationHookOptions<RenameUserMutation, RenameUserMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<RenameUserMutation, RenameUserMutationVariables>(RenameUserDocument, options)
}
export type RenameUserMutationHookResult = ReturnType<typeof useRenameUserMutation>
export type RenameUserMutationResult = Apollo.MutationResult<RenameUserMutation>
export type RenameUserMutationOptions = Apollo.BaseMutationOptions<RenameUserMutation, RenameUserMutationVariables>
export const GetOrganizationDocument = gql`
  query getOrganization($getOrganizationParams: GetOrganizationParams!) {
    getOrganization(getOrganizationParams: $getOrganizationParams) {
      ...organizationDetails
    }
  }
  ${OrganizationDetailsFragmentDoc}
`

/**
 * __useGetOrganizationQuery__
 *
 * To run a query within a React component, call `useGetOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationQuery({
 *   variables: {
 *      getOrganizationParams: // value for 'getOrganizationParams'
 *   },
 * });
 */
export function useGetOrganizationQuery(
  baseOptions: Apollo.QueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options)
}
export function useGetOrganizationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options)
}
export type GetOrganizationQueryHookResult = ReturnType<typeof useGetOrganizationQuery>
export type GetOrganizationLazyQueryHookResult = ReturnType<typeof useGetOrganizationLazyQuery>
export type GetOrganizationQueryResult = Apollo.QueryResult<GetOrganizationQuery, GetOrganizationQueryVariables>
export const ModifyOrganizationLicenseDocument = gql`
  mutation modifyOrganizationLicense($modifyOrganizationLicenseParams: ModifyOrganizationLicenseParams!) {
    modifyOrganizationLicense(modifyOrganizationLicenseParams: $modifyOrganizationLicenseParams)
  }
`
export type ModifyOrganizationLicenseMutationFn = Apollo.MutationFunction<
  ModifyOrganizationLicenseMutation,
  ModifyOrganizationLicenseMutationVariables
>

/**
 * __useModifyOrganizationLicenseMutation__
 *
 * To run a mutation, you first call `useModifyOrganizationLicenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyOrganizationLicenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyOrganizationLicenseMutation, { data, loading, error }] = useModifyOrganizationLicenseMutation({
 *   variables: {
 *      modifyOrganizationLicenseParams: // value for 'modifyOrganizationLicenseParams'
 *   },
 * });
 */
export function useModifyOrganizationLicenseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ModifyOrganizationLicenseMutation,
    ModifyOrganizationLicenseMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<ModifyOrganizationLicenseMutation, ModifyOrganizationLicenseMutationVariables>(
    ModifyOrganizationLicenseDocument,
    options
  )
}
export type ModifyOrganizationLicenseMutationHookResult = ReturnType<typeof useModifyOrganizationLicenseMutation>
export type ModifyOrganizationLicenseMutationResult = Apollo.MutationResult<ModifyOrganizationLicenseMutation>
export type ModifyOrganizationLicenseMutationOptions = Apollo.BaseMutationOptions<
  ModifyOrganizationLicenseMutation,
  ModifyOrganizationLicenseMutationVariables
>
export const ResetOrganizationSeatUsageDocument = gql`
  mutation resetOrganizationSeatUsage($resetOrganizationSeatUsageParams: ResetOrganizationSeatUsageParams!) {
    resetOrganizationSeatUsage(resetOrganizationSeatUsageParams: $resetOrganizationSeatUsageParams)
  }
`
export type ResetOrganizationSeatUsageMutationFn = Apollo.MutationFunction<
  ResetOrganizationSeatUsageMutation,
  ResetOrganizationSeatUsageMutationVariables
>

/**
 * __useResetOrganizationSeatUsageMutation__
 *
 * To run a mutation, you first call `useResetOrganizationSeatUsageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetOrganizationSeatUsageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetOrganizationSeatUsageMutation, { data, loading, error }] = useResetOrganizationSeatUsageMutation({
 *   variables: {
 *      resetOrganizationSeatUsageParams: // value for 'resetOrganizationSeatUsageParams'
 *   },
 * });
 */
export function useResetOrganizationSeatUsageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResetOrganizationSeatUsageMutation,
    ResetOrganizationSeatUsageMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<ResetOrganizationSeatUsageMutation, ResetOrganizationSeatUsageMutationVariables>(
    ResetOrganizationSeatUsageDocument,
    options
  )
}
export type ResetOrganizationSeatUsageMutationHookResult = ReturnType<typeof useResetOrganizationSeatUsageMutation>
export type ResetOrganizationSeatUsageMutationResult = Apollo.MutationResult<ResetOrganizationSeatUsageMutation>
export type ResetOrganizationSeatUsageMutationOptions = Apollo.BaseMutationOptions<
  ResetOrganizationSeatUsageMutation,
  ResetOrganizationSeatUsageMutationVariables
>
export const GetSummaryJobContentDocument = gql`
  query getSummaryJobContent($getSummaryJobContentParams: GetSummaryJobContentParams!) {
    getSummaryJobContent(getSummaryJobContentParams: $getSummaryJobContentParams)
  }
`

/**
 * __useGetSummaryJobContentQuery__
 *
 * To run a query within a React component, call `useGetSummaryJobContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSummaryJobContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSummaryJobContentQuery({
 *   variables: {
 *      getSummaryJobContentParams: // value for 'getSummaryJobContentParams'
 *   },
 * });
 */
export function useGetSummaryJobContentQuery(
  baseOptions: Apollo.QueryHookOptions<GetSummaryJobContentQuery, GetSummaryJobContentQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetSummaryJobContentQuery, GetSummaryJobContentQueryVariables>(
    GetSummaryJobContentDocument,
    options
  )
}
export function useGetSummaryJobContentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSummaryJobContentQuery, GetSummaryJobContentQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetSummaryJobContentQuery, GetSummaryJobContentQueryVariables>(
    GetSummaryJobContentDocument,
    options
  )
}
export type GetSummaryJobContentQueryHookResult = ReturnType<typeof useGetSummaryJobContentQuery>
export type GetSummaryJobContentLazyQueryHookResult = ReturnType<typeof useGetSummaryJobContentLazyQuery>
export type GetSummaryJobContentQueryResult = Apollo.QueryResult<
  GetSummaryJobContentQuery,
  GetSummaryJobContentQueryVariables
>
export const GetQuizJobContentDocument = gql`
  query getQuizJobContent($getQuizJobContentParams: GetQuizJobContentParams!) {
    getQuizJobContent(getQuizJobContentParams: $getQuizJobContentParams)
  }
`

/**
 * __useGetQuizJobContentQuery__
 *
 * To run a query within a React component, call `useGetQuizJobContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuizJobContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuizJobContentQuery({
 *   variables: {
 *      getQuizJobContentParams: // value for 'getQuizJobContentParams'
 *   },
 * });
 */
export function useGetQuizJobContentQuery(
  baseOptions: Apollo.QueryHookOptions<GetQuizJobContentQuery, GetQuizJobContentQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetQuizJobContentQuery, GetQuizJobContentQueryVariables>(GetQuizJobContentDocument, options)
}
export function useGetQuizJobContentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetQuizJobContentQuery, GetQuizJobContentQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetQuizJobContentQuery, GetQuizJobContentQueryVariables>(
    GetQuizJobContentDocument,
    options
  )
}
export type GetQuizJobContentQueryHookResult = ReturnType<typeof useGetQuizJobContentQuery>
export type GetQuizJobContentLazyQueryHookResult = ReturnType<typeof useGetQuizJobContentLazyQuery>
export type GetQuizJobContentQueryResult = Apollo.QueryResult<GetQuizJobContentQuery, GetQuizJobContentQueryVariables>
export const GetInstitutionsDocument = gql`
  query getInstitutions($getInstitutionsParams: GetInstitutionsParams!) {
    getInstitutions(getInstitutionsParams: $getInstitutionsParams) {
      institutions {
        id
        name
        deviceCount
        createdAt
        licenseEnforcement
        licenseEnforcementExpiration
      }
      count
    }
  }
`

/**
 * __useGetInstitutionsQuery__
 *
 * To run a query within a React component, call `useGetInstitutionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstitutionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstitutionsQuery({
 *   variables: {
 *      getInstitutionsParams: // value for 'getInstitutionsParams'
 *   },
 * });
 */
export function useGetInstitutionsQuery(
  baseOptions: Apollo.QueryHookOptions<GetInstitutionsQuery, GetInstitutionsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetInstitutionsQuery, GetInstitutionsQueryVariables>(GetInstitutionsDocument, options)
}
export function useGetInstitutionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetInstitutionsQuery, GetInstitutionsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetInstitutionsQuery, GetInstitutionsQueryVariables>(GetInstitutionsDocument, options)
}
export type GetInstitutionsQueryHookResult = ReturnType<typeof useGetInstitutionsQuery>
export type GetInstitutionsLazyQueryHookResult = ReturnType<typeof useGetInstitutionsLazyQuery>
export type GetInstitutionsQueryResult = Apollo.QueryResult<GetInstitutionsQuery, GetInstitutionsQueryVariables>
export const SetLicenseEnforcementDocument = gql`
  mutation setLicenseEnforcement($setLicenseEnforcementParams: SetLicenseEnforcementParams!) {
    setLicenseEnforcement(setLicenseEnforcementParams: $setLicenseEnforcementParams)
  }
`
export type SetLicenseEnforcementMutationFn = Apollo.MutationFunction<
  SetLicenseEnforcementMutation,
  SetLicenseEnforcementMutationVariables
>

/**
 * __useSetLicenseEnforcementMutation__
 *
 * To run a mutation, you first call `useSetLicenseEnforcementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetLicenseEnforcementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setLicenseEnforcementMutation, { data, loading, error }] = useSetLicenseEnforcementMutation({
 *   variables: {
 *      setLicenseEnforcementParams: // value for 'setLicenseEnforcementParams'
 *   },
 * });
 */
export function useSetLicenseEnforcementMutation(
  baseOptions?: Apollo.MutationHookOptions<SetLicenseEnforcementMutation, SetLicenseEnforcementMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<SetLicenseEnforcementMutation, SetLicenseEnforcementMutationVariables>(
    SetLicenseEnforcementDocument,
    options
  )
}
export type SetLicenseEnforcementMutationHookResult = ReturnType<typeof useSetLicenseEnforcementMutation>
export type SetLicenseEnforcementMutationResult = Apollo.MutationResult<SetLicenseEnforcementMutation>
export type SetLicenseEnforcementMutationOptions = Apollo.BaseMutationOptions<
  SetLicenseEnforcementMutation,
  SetLicenseEnforcementMutationVariables
>
export const SetLicenseEnforcementExpirationDocument = gql`
  mutation setLicenseEnforcementExpiration(
    $setLicenseEnforcementExpirationParams: SetLicenseEnforcementExpirationParams!
  ) {
    setLicenseEnforcementExpiration(setLicenseEnforcementExpirationParams: $setLicenseEnforcementExpirationParams)
  }
`
export type SetLicenseEnforcementExpirationMutationFn = Apollo.MutationFunction<
  SetLicenseEnforcementExpirationMutation,
  SetLicenseEnforcementExpirationMutationVariables
>

/**
 * __useSetLicenseEnforcementExpirationMutation__
 *
 * To run a mutation, you first call `useSetLicenseEnforcementExpirationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetLicenseEnforcementExpirationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setLicenseEnforcementExpirationMutation, { data, loading, error }] = useSetLicenseEnforcementExpirationMutation({
 *   variables: {
 *      setLicenseEnforcementExpirationParams: // value for 'setLicenseEnforcementExpirationParams'
 *   },
 * });
 */
export function useSetLicenseEnforcementExpirationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetLicenseEnforcementExpirationMutation,
    SetLicenseEnforcementExpirationMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<SetLicenseEnforcementExpirationMutation, SetLicenseEnforcementExpirationMutationVariables>(
    SetLicenseEnforcementExpirationDocument,
    options
  )
}
export type SetLicenseEnforcementExpirationMutationHookResult = ReturnType<
  typeof useSetLicenseEnforcementExpirationMutation
>
export type SetLicenseEnforcementExpirationMutationResult =
  Apollo.MutationResult<SetLicenseEnforcementExpirationMutation>
export type SetLicenseEnforcementExpirationMutationOptions = Apollo.BaseMutationOptions<
  SetLicenseEnforcementExpirationMutation,
  SetLicenseEnforcementExpirationMutationVariables
>
export const GenerateStudyMaterialsBatchDocument = gql`
  mutation generateStudyMaterialsBatch($generateStudyMaterialsBatchParams: GenerateStudyMaterialsBatchParams!) {
    generateStudyMaterialsBatch(generateStudyMaterialsBatchParams: $generateStudyMaterialsBatchParams) {
      id
      promptGroup
      language
      studyMaterials {
        contentHash
        source
        quizJob {
          id
          status
          errorReason
        }
        summaryJob {
          id
          status
          errorReason
        }
      }
    }
  }
`
export type GenerateStudyMaterialsBatchMutationFn = Apollo.MutationFunction<
  GenerateStudyMaterialsBatchMutation,
  GenerateStudyMaterialsBatchMutationVariables
>

/**
 * __useGenerateStudyMaterialsBatchMutation__
 *
 * To run a mutation, you first call `useGenerateStudyMaterialsBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateStudyMaterialsBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateStudyMaterialsBatchMutation, { data, loading, error }] = useGenerateStudyMaterialsBatchMutation({
 *   variables: {
 *      generateStudyMaterialsBatchParams: // value for 'generateStudyMaterialsBatchParams'
 *   },
 * });
 */
export function useGenerateStudyMaterialsBatchMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateStudyMaterialsBatchMutation,
    GenerateStudyMaterialsBatchMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<GenerateStudyMaterialsBatchMutation, GenerateStudyMaterialsBatchMutationVariables>(
    GenerateStudyMaterialsBatchDocument,
    options
  )
}
export type GenerateStudyMaterialsBatchMutationHookResult = ReturnType<typeof useGenerateStudyMaterialsBatchMutation>
export type GenerateStudyMaterialsBatchMutationResult = Apollo.MutationResult<GenerateStudyMaterialsBatchMutation>
export type GenerateStudyMaterialsBatchMutationOptions = Apollo.BaseMutationOptions<
  GenerateStudyMaterialsBatchMutation,
  GenerateStudyMaterialsBatchMutationVariables
>
export const GetStudyMaterialsBatchDocument = gql`
  query getStudyMaterialsBatch($getStudyMaterialsBatchParams: GetStudyMaterialsBatchParams!) {
    getStudyMaterialsBatch(getStudyMaterialsBatchParams: $getStudyMaterialsBatchParams) {
      id
      promptGroup
      language
      studyMaterials {
        contentHash
        source
        quizJob {
          id
          status
          errorReason
        }
        summaryJob {
          id
          status
          errorReason
        }
      }
    }
  }
`

/**
 * __useGetStudyMaterialsBatchQuery__
 *
 * To run a query within a React component, call `useGetStudyMaterialsBatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudyMaterialsBatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudyMaterialsBatchQuery({
 *   variables: {
 *      getStudyMaterialsBatchParams: // value for 'getStudyMaterialsBatchParams'
 *   },
 * });
 */
export function useGetStudyMaterialsBatchQuery(
  baseOptions: Apollo.QueryHookOptions<GetStudyMaterialsBatchQuery, GetStudyMaterialsBatchQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetStudyMaterialsBatchQuery, GetStudyMaterialsBatchQueryVariables>(
    GetStudyMaterialsBatchDocument,
    options
  )
}
export function useGetStudyMaterialsBatchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetStudyMaterialsBatchQuery, GetStudyMaterialsBatchQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetStudyMaterialsBatchQuery, GetStudyMaterialsBatchQueryVariables>(
    GetStudyMaterialsBatchDocument,
    options
  )
}
export type GetStudyMaterialsBatchQueryHookResult = ReturnType<typeof useGetStudyMaterialsBatchQuery>
export type GetStudyMaterialsBatchLazyQueryHookResult = ReturnType<typeof useGetStudyMaterialsBatchLazyQuery>
export type GetStudyMaterialsBatchQueryResult = Apollo.QueryResult<
  GetStudyMaterialsBatchQuery,
  GetStudyMaterialsBatchQueryVariables
>
export const CreateOrganizationDocument = gql`
  mutation CreateOrganization($createOrgParams: CreateOrgParams!) {
    createOrganization(createOrgParams: $createOrgParams) {
      id
      name
      approved
      isAsmEnrolled
      educationLevelsProvided
      mdmPlatform
      license {
        id
        maxSeats
      }
      organizationType
      industry
      contractAcceptedAt
    }
  }
`
export type CreateOrganizationMutationFn = Apollo.MutationFunction<
  CreateOrganizationMutation,
  CreateOrganizationMutationVariables
>

/**
 * __useCreateOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationMutation, { data, loading, error }] = useCreateOrganizationMutation({
 *   variables: {
 *      createOrgParams: // value for 'createOrgParams'
 *   },
 * });
 */
export function useCreateOrganizationMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<CreateOrganizationMutation, CreateOrganizationMutationVariables>(
    CreateOrganizationDocument,
    options
  )
}
export type CreateOrganizationMutationHookResult = ReturnType<typeof useCreateOrganizationMutation>
export type CreateOrganizationMutationResult = Apollo.MutationResult<CreateOrganizationMutation>
export type CreateOrganizationMutationOptions = Apollo.BaseMutationOptions<
  CreateOrganizationMutation,
  CreateOrganizationMutationVariables
>
export const GetViableSubscriptionDocument = gql`
  query getViableSubscription($getViableSubscriptionParams: GetViableSubscriptionParams!) {
    getViableSubscription(getViableSubscriptionParams: $getViableSubscriptionParams) {
      originalTransactionId
      originalPurchaseDate
      productId
      expirationDate
      status
      isTrialPeriod
      isInIntroOfferPeriod
      refundedDate
      refundedReason
      overDeviceLimit
      gracePeriodExpiresAt
      expirationIntent
      isInBillingRetryPeriod
      tier
    }
  }
`

/**
 * __useGetViableSubscriptionQuery__
 *
 * To run a query within a React component, call `useGetViableSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetViableSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetViableSubscriptionQuery({
 *   variables: {
 *      getViableSubscriptionParams: // value for 'getViableSubscriptionParams'
 *   },
 * });
 */
export function useGetViableSubscriptionQuery(
  baseOptions: Apollo.QueryHookOptions<GetViableSubscriptionQuery, GetViableSubscriptionQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetViableSubscriptionQuery, GetViableSubscriptionQueryVariables>(
    GetViableSubscriptionDocument,
    options
  )
}
export function useGetViableSubscriptionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetViableSubscriptionQuery, GetViableSubscriptionQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetViableSubscriptionQuery, GetViableSubscriptionQueryVariables>(
    GetViableSubscriptionDocument,
    options
  )
}
export type GetViableSubscriptionQueryHookResult = ReturnType<typeof useGetViableSubscriptionQuery>
export type GetViableSubscriptionLazyQueryHookResult = ReturnType<typeof useGetViableSubscriptionLazyQuery>
export type GetViableSubscriptionQueryResult = Apollo.QueryResult<
  GetViableSubscriptionQuery,
  GetViableSubscriptionQueryVariables
>
export const GetSendGridEventsDocument = gql`
  query getSendGridEvents($getSendGridEventsParams: GetSendGridEventsParams!) {
    getSendGridEvents(getSendGridEventsParams: $getSendGridEventsParams) {
      events {
        id
        email
        createdAt
        event
      }
      count
    }
  }
`

/**
 * __useGetSendGridEventsQuery__
 *
 * To run a query within a React component, call `useGetSendGridEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSendGridEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSendGridEventsQuery({
 *   variables: {
 *      getSendGridEventsParams: // value for 'getSendGridEventsParams'
 *   },
 * });
 */
export function useGetSendGridEventsQuery(
  baseOptions: Apollo.QueryHookOptions<GetSendGridEventsQuery, GetSendGridEventsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetSendGridEventsQuery, GetSendGridEventsQueryVariables>(GetSendGridEventsDocument, options)
}
export function useGetSendGridEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSendGridEventsQuery, GetSendGridEventsQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetSendGridEventsQuery, GetSendGridEventsQueryVariables>(
    GetSendGridEventsDocument,
    options
  )
}
export type GetSendGridEventsQueryHookResult = ReturnType<typeof useGetSendGridEventsQuery>
export type GetSendGridEventsLazyQueryHookResult = ReturnType<typeof useGetSendGridEventsLazyQuery>
export type GetSendGridEventsQueryResult = Apollo.QueryResult<GetSendGridEventsQuery, GetSendGridEventsQueryVariables>
export const GetSubscriptionInfoForUserDocument = gql`
  query getSubscriptionInfoForUser {
    subscriptionInfo: getSubscriptionInfoForUser {
      isClassicUser
      subscriptionTier
      subscriptionSource
      trialLengthInDays
      trialExpirationDate
      subscriptionRenewalDate
    }
  }
`

/**
 * __useGetSubscriptionInfoForUserQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionInfoForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionInfoForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionInfoForUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSubscriptionInfoForUserQuery(
  baseOptions?: Apollo.QueryHookOptions<GetSubscriptionInfoForUserQuery, GetSubscriptionInfoForUserQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<GetSubscriptionInfoForUserQuery, GetSubscriptionInfoForUserQueryVariables>(
    GetSubscriptionInfoForUserDocument,
    options
  )
}
export function useGetSubscriptionInfoForUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionInfoForUserQuery, GetSubscriptionInfoForUserQueryVariables>
) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<GetSubscriptionInfoForUserQuery, GetSubscriptionInfoForUserQueryVariables>(
    GetSubscriptionInfoForUserDocument,
    options
  )
}
export type GetSubscriptionInfoForUserQueryHookResult = ReturnType<typeof useGetSubscriptionInfoForUserQuery>
export type GetSubscriptionInfoForUserLazyQueryHookResult = ReturnType<typeof useGetSubscriptionInfoForUserLazyQuery>
export type GetSubscriptionInfoForUserQueryResult = Apollo.QueryResult<
  GetSubscriptionInfoForUserQuery,
  GetSubscriptionInfoForUserQueryVariables
>
